export const FrTranslation = {
  lang: 'fr',
  data: {
    MANAGE_RETURNS: {
      TITLE: 'Gestion des retours',
      SEARCH_PLACEHOLDER: 'Rechercher un retour...',
      CREATE_NEW: 'Créer',
      DOWNLOAD_EXCEL: 'Télécharger Excel',
      COMING_SOON: 'Bientôt disponible',
      CREATE: {
        TITLE: 'Créer un nouveau retour',
        ON_BACK: 'Retour aux retours',
        SECTION_TITLE: 'Saisir les informations du panier',
        RETURN_CREATED: 'Retour créé',
        FORM_INVALID: 'Remplissez les champs obligatoires',
      },
      CREATE_ITEMS: {
        SECTION_TITLE: 'Sélectionner les articles à retourner',
        SEARCH_PLACEHOLDER: 'Rechercher des articles',
        FILTERS: 'Filtres',
        SMART_SELECTION: 'Sélection intelligente',
        VIEW_ALL: 'Tous',
        VIEW_SELECTED: 'Sélectionnés',
        SAVE_AS_DRAFT: 'Enregistrer comme brouillon',
        SAVE_AND_SEND: 'Enregistrer et envoyer la demande',
        COLUMNS: {
          FULFILLMENT_NUMBER: 'Numéro d\'exécution',
          ORDER_ID: 'ID commande',
          SKU: 'SKU',
          CODE_XIII: 'Code XIII',
          DELIVERY_DATE: 'Date de livraison',
          WAREHOUSE: 'Entrepôt',
          QTY_DELIVERED: 'Qté livrée',
          AVAILABLE_QTY: 'Qté disponible',
          TOT_SELECTED: 'Tot sélectionnés',
          EAN: 'EAN',
          STATUS: 'Statut',
          QTY_SELECTED: 'Qté sélectionnée',
          UNIT_PRICE: 'Prix unitaire',
          TOT_PRICE: 'Prix total',
          MAX_RETURNABLE: 'Max retournable',
          SET_QTY: 'Définir qté',
        },
        NO_ITEMS_SELECTED: 'Sélectionnez au moins un article à retourner',
        INVALID_QTY: 'Vérifiez les quantités à retourner',
        STORE_CONTEXT_MISSING: 'Impossible de déterminer le magasin : les articles ne peuvent pas être chargés. Rechargez la page ou contactez le support.',
        PRE_VALIDATION: {
          FAILED: 'La demande ne peut pas être envoyée : vérifiez les problèmes signalés',
          TITLE: 'Certains articles ne peuvent pas être retournés',
          AVAILABLE_QTY: 'disponible : {{qty}}',
          LINE_REASONS: {
            UNKNOWN: 'Non retournable pour une raison non précisée',
            NOT_POSITIVE_QUANTITY: 'La quantité doit être supérieure à zéro',
            EXCEEDS_AVAILABLE: 'La quantité dépasse la quantité retournable',
            NO_AVAILABILITY_INFO: 'L\'article n\'est plus disponible pour le retour',
            OUTSIDE_RETURN_WINDOW: 'La fenêtre de retour de cet article est expirée',
            ORDER_NOT_RETURNABLE: 'La commande d\'origine n\'est pas dans un état retournable',
            DUPLICATE_LINE: 'Le même article apparaît plusieurs fois dans la demande',
            NOT_FOR_REQUESTED_CUSTOMER_OR_STORE: 'L\'article appartient à un autre client ou magasin',
          },
          SET_ISSUES: {
            UNKNOWN: 'La demande a été refusée pour une raison non précisée',
            NO_ITEMS: 'La demande ne contient aucun article valide',
            MULTIPLE_WAREHOUSES: 'Les articles sélectionnés appartiennent à des entrepôts différents',
            WAREHOUSE_NOT_ACTIVE: 'L\'entrepôt de destination n\'est pas actif',
            RETURNS_DISABLED_FOR_STORE: 'Les retours sont désactivés pour ce magasin',
            AMOUNT_EXCEEDS_ROLE_LIMIT: 'Le montant du retour dépasse votre limite d\'approbation',
          },
        },
        FILTER_STYLE_CODE: 'Code style',
        FILTER_SIZE: 'Taille',
        FILTER_ORDER_ID: 'ID de commande',
        FILTER_DELIVERY_DATE: 'Date de livraison',
        FILTER_STATUS: 'Statut',
        FILTER_STATUS_PARTIALLY: 'Partiellement traité',
        FILTER_STATUS_TOTALLY: 'Totalement traité',
        SMART_NO_MATCH: 'Aucun article ne correspond aux codes saisis',
        WAREHOUSE_LOCKED: 'Sélection annulée : ces articles appartiennent à un entrepôt différent de celui déjà sélectionné',
        SMART_RESULT: '{{selected}} articles sélectionnés, {{unmatched}} codes introuvables, {{skipped}} exclus (entrepôt différent)',
        SMART_MODAL: {
          TITLE: 'Sélection intelligente',
          CODE_TYPE_LABEL: 'Choisissez le type de code que vous allez saisir :',
          STYLE_CODE: 'Code style',
          CODE_XIII: 'Code XIII',
          ORDER_ID: 'ID de commande',
          CODES_LABEL: 'Saisissez vos codes ci-dessous.',
          CODES_PLACEHOLDER: 'Écrivez ou collez vos codes ici, séparés par des virgules ou des espaces.',
          APPLY: 'Appliquer la sélection intelligente',
        },
        SAVE_MODAL: {
          TITLE: 'Enregistrer et envoyer la demande',
          WARNING: 'Si vous continuez, vous ne pourrez plus modifier vos changements.',
          SEE_EDITINGS: 'Voir vos modifications',
          CANCEL: 'Annuler',
          CONFIRM: 'Enregistrer et envoyer la demande',
          COLUMNS: {
            SKU: 'Code SKU',
            EAN: 'EAN',
            OLD_QTY: 'Ancienne qté',
            NEW_QTY: 'Nouvelle qté',
          },
        },
      },
      COLUMNS: {
        NAME: 'Colonnes',
        RETURN_NAME: 'Nom',
        ID: 'ID',
        DATE: 'Date',
        CUSTOMER: 'Client',
        POINT_OF_SALE: 'Point de vente',
        AGENCY: 'Agence',
        PCS_DELIVERED: 'Pcs livrées',
        PCS_TO_RETURN: 'Pcs à retourner',
        TOTAL: 'Total',
        RETURN_REQUEST: 'Demande de retour',
      },
      FORM: {
        BASKET_NAME: 'Nom du panier',
        CUSTOMER: 'Client',
        REASON: 'Motif du retour',
        NOTES: 'Notes (optionnel, max 300 caractères)',
        BASKET_NAME_HINT: 'max 200 caractères',
        OPTIONAL: 'optionnel',
        TEXT_PLACEHOLDER: 'Texte...',
        BASKET_NAME_PLACEHOLDER: 'Saisissez le nom du panier...',
        NOTES_PLACEHOLDER: 'Écrivez vos notes...',
      },
      STATUS: {
        DRAFT: 'Brouillon',
        CREATED: 'Envoyé à ERP',
        WAITING_APPROVAL: "En attente d'approbation",
        APPROVED: 'Approuvé',
        FAILED: 'Échoué',
        REJECTED: 'Rejeté',
      },
      STATUS_INFO: {
        DRAFT: 'Le retour est encore modifiable',
        WAITING_APPROVAL: 'Un utilisateur interne doit approuver le retour',
        CREATED: "En attente d'approbation par ERP",
        APPROVED: 'Approuvé par ERP',
        REJECTED: 'Le retour a été refusé par un utilisateur interne',
        FAILED: 'Le retour a été refusé par ERP',
      },
      DETAIL: {
        BACK_TO_RETURNS: 'Retour aux retours',
        TITLE: 'Détail du retour',
        CUSTOMER_INFO: 'Infos client',
        NAME: 'Nom',
        NOTES: 'Notes',
        REASON: 'Motif',
        RMA_NUMBER: 'Numéro RMA',
        TOT_QTY: 'Qté totale',
        TOT_RETAIL: 'Total retail',
        CUSTOMER: 'Client',
        BILLING_ADDRESS: 'Adresse de facturation',
        SHIPPING_ADDRESS: 'Adresse de livraison',
        VAT: 'TVA',
        AGENCY: 'Agence',
        DELETE_DRAFT: 'Supprimer le brouillon',
        SEND_REQUEST: 'Envoyer la demande',
        DOWNLOAD_REPORT: 'Télécharger le rapport',
        NOTES_MODAL_TITLE: 'Notes (max 300 caractères)',
        NOTES_SAVED: 'Notes enregistrées',
        REQUEST_SENT: 'Demande de retour envoyée',
        DRAFT_DELETED: 'Brouillon supprimé',
        DELETE_FAILED: 'Échec de la suppression',
        DELETE_DRAFT_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce brouillon ? Cette action est irréversible.',
        DELETE_RETURN: 'Supprimer le retour',
        DELETE_RETURN_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce retour ? Cette action est irréversible.',
        RETURN_DELETED: 'Retour supprimé',
        RESTORE_DRAFT: 'Restaurer le brouillon',
        DRAFT_RESTORED: 'Brouillon restauré',
        CREATED_BANNER_TITLE: 'Demande de retour approuvée.',
        CREATED_BANNER_BODY: 'Approuvé par {{user}} le {{date}} • Motif : {{reason}}.',
        CREATED_BANNER_BODY_TRAIL_ONLY: 'Approuvé par {{user}} le {{date}}.',
        REJECTED_BANNER_TITLE: 'Demande de retour refusée.',
        REJECTED_BANNER_BODY: 'Refusé par {{user}} le {{date}} • Motif : {{reason}}.',
        REJECTED_BANNER_BODY_TRAIL_ONLY: 'Refusé par {{user}} le {{date}}.',
        FAILED_BANNER_TITLE: 'Retour refusé par ERP.',
        BANNER_BODY_REASON_ONLY: 'Motif : {{reason}}.',
        ITEMS: 'Articles',
        ITEMS_COLUMNS: {
          SKU: 'SKU',
          EAN: 'EAN',
          STYLE: 'Style',
          COLOR: 'Couleur',
          SIZE: 'Taille',
          ORDER_ID: 'ID commande',
          FULFILLMENT: 'Expédition',
          RETURN_QTY: 'Qté retournée',
          INVOICE_ID: 'ID facture',
        },
        EDIT_NAME: 'Modifier le nom (max. 200 caractères)',
        NAME_SAVED: 'Nom enregistré',
        ADD_ITEMS: 'Ajouter des articles',
        EDIT_ITEMS: 'Modifier les articles',
        CLOSE_SELECT_MODE: 'Fermer le mode sélection',
        EDIT_SELECTED_ITEMS: 'Modifier les articles sélectionnés',
        CANCEL: 'Annuler',
        GO_BACK: 'Retour',
        ITEMS_SELECTED: 'sélectionnés',
        ITEMS_UPDATED: 'Articles mis à jour',
        SAVE_AND_EXIT: 'Enregistrer et quitter',
        SAVE_AND_SEND_REQUEST: 'Enregistrer et envoyer la demande',
        SAVE_RECAP_WARNING: 'Si vous continuez, vous ne pourrez plus modifier vos changements.',
        SEE_QUANTITY_CHANGES: 'Voir les modifications de quantité',
        SEE_DELETED_ITEMS: 'Voir les articles supprimés',
        NO_QUANTITY_CHANGES: 'Aucune modification de quantité',
        NO_DELETED_ITEMS: 'Aucun article supprimé',
        APPROVE: 'Approuver',
        REJECT: 'Refuser',
        APPROVE_RETURN: 'Approuver le retour',
        REJECT_RETURN: 'Refuser le retour',
        REJECTION_REASON: 'Saisissez un motif (200 caractères max)',
        APPROVAL_REASON: 'Saisissez un motif (facultatif, 200 caractères max)',
        RETURN_APPROVED: 'Retour approuvé',
        RETURN_REJECTED: 'Retour refusé',
        ITEMS_ADDED: 'Articles ajoutés au retour',
        APPROVE_RANGE_INFO: 'Avec la confirmation de ce retour, selon la plage configurée dans les paramètres du magasin :',
        RETURNED_AMOUNT: 'Montant retourné',
        PURCHASED_AMOUNT: 'Montant acheté',
        RETURNABLE_AMOUNT: 'Montant retournable',
        APPROVING_RETURN: 'Vous approuvez le retour #{{id}}.',
        REJECTING_RETURN: 'Vous êtes sur le point de refuser le retour #{{id}}. Cette action est irréversible.',
        PRODUCT_TITLE: 'Produit',
        MAX_RETURNABLE_QTY: 'Qté max retournable',
        CURRENT_QTY: 'Qté actuelle',
        NEW_QTY: 'Nouvelle quantité',
        ALL_ITEMS_REMOVED: 'Tous les articles sélectionnés seront supprimés.',
        ITEMS_SEARCH_PLACEHOLDER: 'Rechercher des articles...',
        SELECTED_ITEMS: 'Articles sélectionnés',
        GROUP_BY: 'Regrouper par',
        GROUP_BY_NONE: 'Aucun',
        GROUP_BY_ORDER: 'Commande',
        GROUP_BY_PRODUCT: 'Produit',
        GROUP_ORDER_HEADER: 'Commande {{id}}',
        GROUP_UNKNOWN: 'Inconnu',
        GROUP_EMPTY: 'Aucun article ne correspond à la recherche ou aux filtres actuels',
      },
    },
    CULTURE: {
      TITLE_MODAL: 'Sélectionnez la langue',
      ITALIAN: 'Italien',
      ENGLISH: 'Anglais',
      FRENCH: 'Français',
      SPANISH: 'Espagnol',
      GERMAN: 'Allemande',
    },
    PRODUCTS_LIST: {
      ACTIONS: 'Actions sur tous les produits',
      HANDLE_IMAGES: 'Gérer les images'
    },
    PRICE_LIST_DETAIL: {
      INFORMATION: 'Informations',
      NAME: 'Nom',
      ASSOCIATED_CUSTOMERS_COUNT: 'Clients associés',
      TYPE: 'Type',
      PRICE_LIST_TYPE: 'Type de liste de prix',
      CUSTOM_PRICE_LIST: 'Liste de prix personnalisée',
      DEFAULT_PRICE_LIST: 'Liste de prix par défaut',
      STORE: 'Magasin',
      INCLUDED_VARIANTS: 'Variantes incluses',
      EXCLUDED_VARIANTS: 'Variantes exclues',
      PRODUCT_LIST: 'Liste des produits',
      VARIANTS: 'Variantes',
      BACK_TO_PRICE_LISTS: 'Retour aux listes de prix',
      PARENT_PRICE_LIST: 'Liste de prix de référence',
    },
    MENU: {
      UTILITIES: {
        UTILITIES: 'Utilitaires',
        BULK_OPERATIONS: 'Opérations',
      },
      DASHBOARD: 'Dashboard',
      ORDERS: 'Commandes',
      CARTS: 'Paniers',
      PROMOTIONS: 'Promotions',
      CUSTOMIZATION_REQUESTS: 'Demandes personnalisation',
      RETURNS: 'Retours',
      AUTOMATIC_DISCOUNTS: 'Remises automatiques',
      CUSTOMER_DISCOUNTS: 'Remise client',
      STORECHANNEL_DISCOUNT: 'Remises store-channel',
      GOK_MODE: 'Gok',
      DIRECT_MODE: 'Orde direct',
      VOUCHERS: 'Vouchers',
      COMMERCIAL_AGREEMENTS: 'Accords commerciaux',
      CUSTOMERS_DISCOUNTS: 'Remises clients',
      AGENTS: 'Agents',
      GENERAL_FIELDS: 'Champs généraux',
      AGENCY_INFO: 'Info agence',
      CUSTOMER_INFO: 'Info client',
      CATEGORIES: 'Groupe de Classification Client',
      PAYMENT_TERMS: 'Termes de paiement',
      COMPANY_FORMS: 'Forme Juridique',
      COURIERS: 'Transporteurs',
      DOWNLOADS: {
        DOWNLOADS: 'Téléchargements',
        REPORTS: 'Reports'
      },
      PRODUCTS: {
        NAME: 'Produits',
        PRODUCTS_LIST: 'Liste des produits',
        INVENTORY_VISIBILITY: 'Visibilité des stocks',
        ASSORTMENTS: 'Assortiments',
        IMPORT_PRODUCTS: 'Importer des produits',
        BULK_EDITOR: 'Éditeur en vrac',
        VARIANT_BULK_EDITOR: 'Éditeur variantes',
      },
      SETTINGS: {
        NAME: 'Paramètres',
        STORE_SETTINGS: 'Du boutique',
        PRICE_LIST: 'Liste de prix',
        TIERS: 'Tiers',
        SALES_CAMPAIGNS: 'Campagnes de vente',
        TERMS_OF_SALE: 'Conditions de vente',
        SEASON_REFERENCE: 'Season Reference',
        PACKAGE_GROUP: 'Package Group',
        TRANSPORT_AGENCY: 'Agence de transport',
        ORDER_LABEL: 'Order label (facultatif)',
        DEFAULT: 'Défaut',
        EMAIL_SETTINGS: 'Paramètres e-mail',
        EMAIL_FOR_CHANNEL: 'E-mail pour le canal',
        OVERRIDE_EMAIL_INFO: 'Ci-dessous, vous pouvez spécifier différents e-mails pour chaque canal de vente. Si aucun e-mail n\'est spécifié pour un canal, l\'e-mail par défaut sera utilisé.',
        SHIPPING_COST_SETTINGS: 'Paramètres de coût d\'expédition',
        FREE_SHIPPING_THRESHOLD: 'Seuil de livraison gratuite',
        SHIPPING_COST: 'Frais d\'expédition',
        AVOID_REPLACEMENT_SHIPPING_COSTS: 'Pas de frais d\'expédition sur les commandes d\'échange d\'article',
        AVOID_REPLACEMENT_SHIPPING_COSTS_HINT:
          'Frais de transporteur inclus. S\'applique aux paniers confirmés à partir de maintenant : les commandes déjà confirmées ne changent pas.',
        RETURN_SETTINGS: 'Paramètres de retour',
        RETURN_AMOUNTS_INFO: 'Montant retourné : €X · Montant acheté : €Y · Montant remboursable : €Z.',
        RETURN_WINDOW: 'Fenêtre de retour',
        RETURN_WINDOW_DISABLED_NOTE: 'Laisser vide pour désactiver les retours sur ce store.',
        DAYS: 'Jours',
        INTERNAL_RETURN_APPROVAL_LIMIT: 'Limite d\'approbation interne des retours',
        INTERNAL_RETURN_APPROVAL_LIMIT_NOTE: 'Les retours au-dessus de la limite définie ne peuvent être approuvés que par les admins.',
        INTERNAL_RETURN_APPROVAL_LIMIT_EMPTY_NOTE: 'Laisser vide pour ne pas appliquer de limite.',
        INTERNAL_RETURN_APPROVAL_LIMIT_STORE_OWNER: 'Limite store owner — Euro (€)',
        INTERNAL_RETURN_APPROVAL_LIMIT_ADMIN: 'Limite admin — Euro (€)',
        EURO: 'Euro (€)',
        RETURN_NOTIFICATIONS: 'Notifications de retour',
        RETURN_NOTIFICATIONS_DISABLED_NOTE: 'Laisser vide pour désactiver tous les e-mails de retour.',
        RETURN_NOTIFICATIONS_EMAIL: 'E-mail de réception des notifications de retour',
        NUMBER_OF_DAYS_TO_CALCULATE_THE_RE_ORDER_DATE: 'Nombre de jours pour calculer la date de re-order',
        DEFAULT_LIMIT_FOR_STYLE_COLOR_OF_MONOBRAND_STORES: 'Limite d\'achat par défaut sur style-color (pour les canaux de vente qui l\'exigent)',
        MINIMUM_VALUE_FOR_THE_TOTAL_ORDER_AMOUNT: 'Valeur minimale d\'un panier pour créer la commande correspondante (pour les canaux de vente qui le nécessitent)',
        MINIMUM_REORDER_QUANTITY: 'Quantité minimale pour re-order (pour les canaux de vente qui le nécessitent)',
        MINIMUM_REORDER_QUANTITY_TOOLTIP:
          'Cette quantité minimale s\'applique uniquement aux rôles Customer et Customer Owner lorsqu\'ils commandent en re-order.',
        FREE_SHIPPING_ORDER_TOTAL_THRESHOLD: 'Seuil de livraison gratuite (pour les canaux de vente qui le nécessitent)',
        GENERAL: 'Général',
        STORE_NAME: 'Nom',
        DISCOUNT: 'Remise',
        CURRENCY: 'Monnaie',
        SALES_SETTINGS: 'Paramètres de vente',
        PRE_ORDER_ACTIVE_FROM: 'Pre-order actif depuis',
        PRE_ORDER_ACTIVE_TO: 'Pre-order actif à',
        RE_ORDER_ACTIVE_FROM: 'Re-order actif depuis',
        RE_ORDER_ACTIVE_TO: 'Re-order actif à',
        MAX_CUSTOM_DATES: 'Date de livraison personnalisée possible jusqu\'à',

        BACKGROUND_IMAGE: 'Image de fond',
        LOGO_IMAGE: 'Image logo',
        FAVICON_IMAGE: 'Fav icon',
        ADD: 'Ajouter',
        CHANGE: 'Changer',
        SMALL_LOGO: 'Petit logo',

        UPLOAD_MEDIA: 'Télécharger des médias',
        UPLOAD_EXCEL: 'Télécharger Excel',
        SAVE: 'Enregistrer',
        UPLOAD_FILE: 'Télécharger un fichier',
        UPLOAD_LINK: 'Télécharger le lien',
        VALID_URL: 'Veuillez saisir une URL valide',
        AVILABLE_FILE_SIZE: 'Taille maximale du fichier',

        PRIMARY_COLOR: 'Couleur primaire',
        MAIL_NOTIFICATIONS: 'E-mail recevant des notifications de la boutique',
        MAIL_SENDER: 'E-mail de l\'expéditeur de la boutique',
        FOOTER_TEXT: 'Footer text',
        CART_NAME_MAX_LENGTH: 'Longueur maximale du nom d\'un panier',
        CART_NOTIFICATION_SETTINGS: 'Impostations des notifications de panier inactifs',
        CART_NOTIFICATION_THRESHOLD: 'Notifica suppression panier dans jours',
        CART_NOTIFICATION_DELETION_THRESHOLD: 'Suppression panier inactif dans jours',
        DEFAULT_DESIGNER: 'Designer par défaut',
        KUSTOM_EMAIL: 'E-mail Kustom',
        KUSTOM_PHONE: 'Téléphone Kustom',
        KUSTOM_EMAIL_SECONDARY: 'E-mail Kustom secondaire',
        KUSTOM_SETTINGS: 'Paramètres BasicKustom',
        KUSTOM_MIN_QUANTYTY_FOR_PRODUCT: "Quantité d'achat minimale pour produit personnalisé dans les demandes",
        ENABLE_KUSTOM: 'BasicKustom activé',
        DISABLE_KUSTOM: 'BasicKustom désactivé',
        PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Veuillez remplir tous les champs obligatoires',
      },
      AGENCIES: 'Agences',
      CUSTOMERS: 'Clients',
      USERS: 'Utilisateurs',
      LOCATIONS: 'Emplacements',
      TUTORIAL: {
        NAME: 'Tutorial',
        VIDEO: 'Video',
        DOCUMENTATION: 'Documentation',
      },
      BY_DATE: 'Date de livraison',
      CUSTOM_DATE: 'Date personnalisée',
      STYLE_CODE: 'Style code',
    },
    IMPORT_PRODUCTS: {
      START_SEARCH: 'Insérez le texte de recherche pour commencer l\'importation',
      DESELECT_ALL: 'Tout déselectionner',
      RELOAD_PRODUCTS: 'Recharger produits',
      SEARCH_BY: 'Rechercher par',
      ID: 'ID',
      NAME: 'Nom',
      SELLING_PERIOD: 'Période de vente',
      PRODUCTS_QUANTITY: 'Quantité',
      LOAD_MORE_DATA: 'Charger plus de données',
      THERE_IS_NO_MORE_DATA: 'Il n\'y a plus de données',
      STATUS: {
        IMPORTED: 'Importé',
        NOT_IMPORTED: 'Non importé',
        IMPORTING: 'Importation..',
        FAILED: 'Manqué'
      },
      MODAL: {
        TITLE: 'Importer des produits',
        YOU_HAVE_SELECTED: 'Vous avez sélectionné',
        ITEMS: 'éléments',
        ATTENTTION_YOU_ARE_IMPORTING: 'Attention, vous importez',
        MESSAGE: 'styles déjà importés. Toutes les modifications le concernant et ses variantes seront perdues. Es-tu sûr?',
        YOU_HAVE_TO_SELECT_AT_LAST_ONE_ITEM: 'Vous devez sélectionner au moins un élément',
        USE_CUSTOM_DISCOUNT: 'Définir une remise personnalisée pour calculer le prix wholesale',
        USE_CUSTOM_DISCOUNT_INFO: 'Si vous configurez une remise personnalisée, elle sera utilisée pour calculer le prix wholesale de toutes les variantes de produits importés, à la fois pour le calcul du prix PRE order et RE order. Si vous ne le définissez pas à la place, le dernier pourcentage utilisé sera utilisé pour les produits déjà importés dans le passé et la remise de base de la boutique actuelle pour les produits qui n\'ont jamais été importés.'
      }
    },
    USERMENU: {
      SHOP: 'Boutique',
      MY_PROFILE: 'Profil',
      LOGOUT: 'Déconnexion',
      SWITCH_TENANT: 'Changer de pays',
      LOGOUT_CONFIRM: 'Êtes-vous sûr de vouloir vous déconnecter?',
      CANCEL: 'Annuler',
    },
    BACK_TO: {
      SALES_CAMPAIGN: 'Retour à la campagne commerciale',
      SALES_CAMPAIGNS: 'Retour aux campagnes commerciales',
    },
    GENERIC_LABEL: {
      FILTER: 'Filtre',
      SELECT: 'Sélectionner',
      SELECT_ALL: 'Tout sélectionner',
      SELECT_SIZE: 'Sélectionner la taille',
      APPROVE: 'Approuver',
      COPY: 'Copier',
      SALE_COMPAIGN: 'Campagne de vente',
      CHOOSE_FILE: 'Choisir le fichier',
      BACK: 'Précédent',
      SYNC_START: 'La synchronisation a commencé',
      ADD_NEW: 'Ajouter un nouveau',
      ADD: 'Ajouter',
      SAVE: 'Enregistrer',
      SAVE_CHANGES: 'Enregistrer les modifications',
      'SAVE AND_SYNC_LATER': 'Enregistrer et synchroniser plus tard',
      SAVE_AND_SYNC_NOW: 'Enregistrer et synchroniser maintenant',
      DELETE: 'Effacer',
      CANCEL: 'Annuler',
      CLOSE: 'Fermer',
      TRANSFORM_INTO_DRAFT: 'Reconvertir en panier',
      LEAVE_PAGE: 'Laisser la page',
      ACTIONS: 'Actions',
      UPLOAD: 'Télécharger',
      IMPORT: 'Importer',
      DUPLICATE: 'Dupliquer',
      CONFIRM: 'Confirmer',
      SEND_CONFIRMATION_MAIL: 'Renvoyer un courriel de confirmation',
      EDIT: 'Modifier',
      EDIT_ITEMS: 'Modifier les articles',
      EDIT_CART: 'Modifier le chariot',
      ACTIVATE: 'Activer',
      SEND: 'Envoyer',
      RESEND: 'Renvoyer',
      DEACTIVATE: 'Désactiver',
      FORM_ERROR: 'Données manquantes ou incorrectes',
      YES: 'Oui',
      NO: 'Non',
      PRINT: 'Imprimer',
      PRINT_PREVIEW: 'Aperçu avant impression',
      ERROR: 'Erreur!',
      ARE_YOU_SURE: 'Êtes-vous sûr?',
      ARE_YOU_SURE_YOU_WANT_TO_PROCEED: 'Êtes-vous sûr de vouloir procéder?',
      DONE: 'Fait!',
      REMOVE: 'Retirer',
      BLOCKED: 'Bloqué',
      UNBLOCKED: 'Non bloqué',
      USER: 'Utilisateur',
      ACTIVATED: 'Activé',
      DEACTIVATED: 'Désactivé',
      MAN: 'Homme',
      WOMAN: 'Femme',
      UNISEX: 'Unisexe',
      UNPUBLISH: 'Dépublier',
      CREATE: 'Créer',
      LOSING_CHANGES_MESSAGE: 'Les modifications non enregistrées seront perdues. Tu veux procéder?',
      SETTINGS: 'Paramètres',
      DETAILS: 'Détails',
      START_SYNC: 'Commencez l\'alignement avec l\'ERP',
      THE_VALUE_MUST_BE_BETWEEN: 'La valeur doit être comprise entre {{min}} et {{max}}',
      MAX_LENGTH: 'Longueur maximale {{max}}, valeur actuelle {{current}}',
      ATTENTION: 'Attention!',
      PREVIEW: 'Aperçu',
      DOWNLOAD: 'Télécharger {{extension}}',
      APPLY: 'Appliquer',
      NEXT: 'Suivant',
      SELECT_CODE: 'Sélectionner le code',
      DOWNLOAD_REPORT: 'Télécharger les rapports',
      EXPORT_ORDERS: 'Exporter les commandes',
      ONLY_WITH_STOCK_PRODUCTS: 'Produits disponibles uniquement',
      PRODUCT_TYPE: 'Type de produit',
      REPORTS_MODAL_MESSAGE: 'Définissez les filtres souhaités et vous recevrez le rapport dans votre boîte mail.',
      STORE_VARIANTS_REPORT: 'Rapport de variantes de magasin',
      CUSTOMER_REPORT: 'Rapport client',
      FROM_DATE: 'De',
      TO_DATE: 'Au',
      SALES_CAMPAIGN: 'Campagne de vente',
      SELECTED_ORDERS: 'Commandes sélectionnées',
      NO_ORDERS_SELECTED: 'Aucune commande sélectionnée',
      SELECTED: 'Sélectionnés',
      EDIT_SELECTED_ORDERS: 'Modifier les commandes sélectionnées',
      DELETE_ORDERS: 'Supprimer les commandes',
      CANCEL_ORDERS: 'Annuler les commandes',
      DELETE_ORDERS_BY_EXCEL: 'Supprimer commandes par Excel',
      SUCCESS_DELETE_ORDERS: 'Commandes supprimées avec succès',
      UPLOAD_ORDERS_TEMPLATE: 'Télécharge les articles de tes commandes en utilisant le modèle',
      DOWNLOAD_TEMPLATE: 'Télécharger le modèle',
      ERROR_NEGATIVE_NUMBERS: 'Impossible d\'insérer des nombres négatifs ou décimaux',
      INVALID_QUANTITY: 'Quantité non valide',
      NAME: 'Nom',
      CART_QTY: 'articles dans le panier',
      BULK_SELECTION: 'Sélection en masse',
      WORKING_MODE: "Sélectionnez le mode de travail",
      SELECT_FILTERS: "Sélectionner par filtres",
      SELECT_FREE_TEXT: "Sélectionner par de external ID",
      ENTER_ORDER_IDS: "Saisir les ID de commande",
      ENTER_ORDER_IDS_PLACEHOLDER: "Tapez ou collez un ou plusieurs external ID de commande, séparés par un point-virgule",
      OTHERS: "Autres",
      DRAG_DROP_REORDER_COLUMNS: 'Dans ce tableau, vous pouvez réorganiser les colonnes par glisser-déposer',
      VIEW_PENDING_BULK: 'Voir les bulk en attente',
      GO_BACK: 'Retour',
      CART_SUMMARY: 'Récapitulatif du panier',
    },
    MANAGE_GENERAL_FIELDS: {
      FIELDS_TYPE: 'Type de champs',
      VALUE_SET: 'Ensemble de valeurs',
      TABLE: {
        VALUE: 'Valeur',
        DECIMAL_VALUE: 'Valeur décimale',
        CREATION_TIME: 'Date de création',
        LAST_UPDATE: 'Dernière mise à jour',
        DELETE_GF: 'Supprimer le champ général',
        ARE_YOU_SURE: 'Êtes-vous sûr de vouloir supprimer ce champ général?',
        EDIT_GF: 'Modifier le champ général',
        CREATE_GF: 'Créer un nouveau champ général',
        CODE: 'Code',
        DESCRIPTION: 'Description',
        ID: 'ID',
        EXTERNAL_ID: 'External ID',
        NAME: 'Nom',
        ORDER: 'Ordre',
        COST: 'Coût',
        IS_PUBLIC: 'Public',
      },
    },
    TABLE: {
      ACTION: {
        NAME: 'Actions',
        EDIT: 'Modifier',
        DELETE: 'Effacer',
        CREATE_NEW: 'Créer un nouveau',
        EXPORT: 'Exporter',
        IMPORT: 'Importer',
        INVITE_USER: 'Inviter un utilisateur',
        DUPLICATE: 'Dupliquer',
        VIEW_DETAILS: 'Voir les détails',
        ACTIVATE: 'Activer',
        DEACTIVATE: 'Désactiver',
        REFRESH: 'Rafraîchir',
        ARCHIVE: 'Archive',
        UPLOAD: 'Télécharger',
        DOWNLOAD_LIST: 'Télécharger la liste',
        CREATE_CART_FROM_EXCEL: 'Créer des paniers depuis Excel',
        MANAGE_ASSORTMENT: 'Gérer les assortiments',
      },
      FILTERS: {
        WITH_CUSTOMIZATION_REQUESTS: 'Avec demande de personnalisation',
        BY_CUSTOMIZATION_REQUESTS: 'Par demande de personnalisation',
        FILTERS: 'Filtres',
        CREATOR: 'Créateur',
        REQUESTER: 'Demandeur',
        CUSTOMER_REQUESTER: 'Demandeur Client',
        AGENCY_REQUESTER: 'Demandeur Agence',
        DESIGNER: 'Designer',
        APPROVED_BY: 'Approuvé par',
        APPLY_FILTER: 'Appliquer le filtre',
        ACTIVE_FILTERS: 'Filtres actifs',
        SEARCH: 'Chercher',
        VISIBILITY_TYPE: 'Type',
        TYPE: 'Type',
        VALIDITY: 'Valide',
        REORDER: 'Re-order',
        PREORDER: 'Pre-order',
        PRE_ORDER: 'Pre-order',
        RE_ORDER: 'Re-order',
        WHOLESALE_PRICE: 'Prix wholesale',
        NEW_WHOLESALE_PRICE: 'Nouveau prix wholesale',
        FROM: 'De',
        TO: 'À',
        RETAIL_PRICE: 'Prix retail',
        STOCK: 'Stock',
        ASSORTMENT: 'Assortiment',
        STYLE_GROUP: 'Group de article',
        CITY: 'Ville',
        TIER: 'Niveau',
        STORE: 'Boutique',
        CUSTOMER: 'Client',
        CUSTOMER_TYPE: 'Type de client',
        AGENCY: 'Agent',
        ONLINE_STORES: 'Boutiques en ligne',
        WITHOUT_STORE: 'Sans boutique',
        POINT_OF_SALE: 'Point de vente',
        POS: 'Point de vente',
        ORDER_STATUS: 'Statut de la commande',
        STATUS: 'Statut',
        LOCATION_TYPE: 'Type d\'emplacement',
        REGISTERED_DATE: 'Date d\'inscription',
        ROLE: 'Rôle',
        ONLY_INCLUDED: 'Inclus',
        COLORS: 'Couleurs',
        SIZE: 'Taille',
        SIZE_GROUP: 'Groupe taille',
        NOTES: 'Notes',
        HAS_NOTES: 'Avec des notes',
        EXTERNAL_COLLECTIONS: 'Collections externes',
        EXTERNAL_ORDER_ID: 'ID de la commande externe',
        CHANNEL: 'Canal',
        PRODUCTS: 'Produits',
        OPERATION_TYPE: 'Type d\'opération',
        CUSTOMER_AMMINISTRATIVE_STATUS: 'Statut de bloc commercial',
        SHOW_ONLY_BLOCKED: 'Afficher uniquement les clients bloqués',
        SHOW_ONLY_WITH_CR: 'Afficher les commandes avec des demandes de personnalisation associées',
        CHANNEL_ID: 'Id channel',
        CREATED_AFTER: 'Créé après le',
        CREATED_BEFORE: 'Créé avant le',
        SELECT_ORDERS: 'Sélectionner les commandes',
        MANAGEMENT_ORDERS: 'Gérer les commandes',
        GO_BACK_TO_ORDERS: 'Retourner aux commandes',
        COMERCIAL_BLOCK: 'Bloque commercial',
        SHOW_CR_WITH_DESIGNER_NOTIFICATION: 'Afficher uniquement les demandes de personnalisation avec notification du demandeur',
        COMPLETED_AT: 'Completé le',
        ORDER_BULK_OPERATION_SCOPE: 'Scope opérations',
        ORDER: 'Commande',
      },

      CUSTOMIZATION_REQUEST: {
        TITLE: 'Demandes de personnalisation',
        COLUMN: {
          NAME: 'Nom',
          STATUS: 'Statut',
          CUSTOMER: 'Client',
          CHANNEL: 'Canal',
          POINT_OF_SALE: 'Point de vente',
          TOTAL_WHOLESALE: 'Tot. wholesale',
          PRODUCT_NUMBER: 'N° de produits',
          LAST_UPDATE: 'Dernière mise à jour',
          WITH_REQUESTER_NOTIFICATION: 'Avec notification du demandeur',
          LAST_UPDATE_REQUESTER: 'Dernière mise à jour du demandeur',
          LAST_DESIGNER_NOTIFICATION: 'Notification au demandeur envoyée le',
          PROJECT: 'Projet',
          NOTIFICATIONS: 'Notifications',
        },
      },

      PRICE_LIST: {
        DEFAULT_PRICE_LIST: 'Liste de prix par défaut',
        CUSTOM_PRICE_LIST: 'Listes de prix personnalisées',
        CREATE_PRICE_LIST: 'Créer une liste de prix',
        NAME: 'Nom',
        PARENT_PRICE_LIST: 'Liste de prix parent',
        TYPE: 'Type',
        STORE: 'Magasin',
        ASSOCIATED_CUSTOMERS: 'Sélectionnez si vous souhaitez procéder à l\'association des clients à cette liste de prix',
      },

      PRICE_LIST_DETAIL: {
        COLUMNS: {
          SKU: 'SKU',
          PALETTE: 'Palette',
          TYPE: 'Type',
          PRE_ORDER: 'Pre-order',
          RE_ORDER: 'Re-order',
          CURRENCY: 'Devise',
          DEFAULTRETAILPRICE: 'Prix détail par défaut',
          DEFAULTWHOLESALEPRICE: 'Prix gros par défaut',
          CUSTOMRETAILPRICE: 'Prix détail personnalisé',
          CUSTOMWHOLESALEPRICE: 'Prix gros personnalisé',
        },
      },

      SUPER_BULK: {
        COLUMN: {
          ID: 'Id',
          USER: 'Utilisateur',
          OPERATION_TYPE: 'Type d\'opération',
          CREATION_TIME: 'Heure de création',
          START_AT: 'Commence à',
          CONCLUDED_AT: 'Conclu à',
          STATUS: 'Statut',
        },
        OPERATION_TYPE: {
          UPDATING_VISIBILITY_PRE: 'Mise à jour de la visibilité pre-order',
          UPDATING_VISIBILITY_RE: 'Mise à jour de la visibilité re-order',
          UPDATING_PRICE: 'Mise à jour du prix',
          UPDATING_BLANK_CELL: 'Mise à jour de la cellule vide',
          ASSOCIATING_TIER: 'Association de niveau',
          DISASSOCIATING_TIER: 'Dissociation de niveau',
          ASSOCIATING_ASSORTMENT: 'Association d’assortiment',
          DISASSOCIATING_ASSORTMENT: 'Désassociation d’assortiment',
          ASSOCIATING_PROMOTION: 'Association de promotion',
          DISASSOCIATING_PROMOTION: 'Dissociation de promotion',
          UPDATE_PALETTES_STOCK_LIMITS: 'Mettre à jour les limites d’achat par couleur (pour les canaux qui le prennent en charge)',
        }
      },

      BULK_OPERATIONS: {
        NAME: 'Opérations',
        COLUMNS: {
          ID: 'Id',
          TYPE: 'Type',
          CREATOR: 'Créateur',
          CREATED_AT: 'Date de création',
          SCOPE: 'Portée',
          STATUS: 'Statut',
          ISSUE: 'Problème',
          ORDER_ITEM_ID: 'ID article commande',
          ORDER_ID: 'ID commande',
          ORDER_NUMBER: 'Numéro commande',
          CUSTOMER_NAME: 'Nom client',
          CUSTOMER_ACCOUNT: 'Compte client',
          STARTED_AT: 'Débuté le',
          CONCLUDED_AT: 'Conclu le',
          PROCESSED_ORDER_ITEMS_COUNT: 'Articles traités',
          PROCESSED_WITH_ISSUES_COUNT: 'Articles avec problèmes',
          HAS_PENDING: 'Sync en att.'
        },
        GO_TO_ORDER: 'Aller au détail de la commande',
      },

      BULK_EDIT_ORDERS_MODAL: {
        INFO_MESSAGE: 'En utilisant les cases à cocher, vous pouvez modifier plusieurs éléments simultanément. Attention : lors de l’enregistrement, tous les éléments de cette fenêtre seront enregistrés, indépendamment de la sélection effectuée.',
        ADD_NEW_ITEMS: 'Ajouter nouveaux articles',
        REPLACE_ITEMS: 'Remplacer articles',
        REMOVE_ITEMS: 'Supprimer articles',
        CURRENT_DATE: 'Date actuelle',
        NEW_DATE: 'Nouvelle date',
        CHANGE_ITEMS_DELIVERY_DATE: 'Changer date livraison articles',
        SUCCESS_CHANGE_ITEMS_DELIVERY_DATE: 'Date livraison articles modifiée avec succès',
        ADD_DELIVERIES: 'Ajouter des livraisons',
        ADD_DELIVERIES_DUPLICATE_DATE: 'Cet article a déjà une livraison à cette date',
        SUCCESS_ADD_ITEMS: 'Articles ajoutés avec succès',
        SUCCESS_CHANGE_ITEMS_WHOLESALE_PRICE: 'Prix mis à jour avec succès',
        INVALID_PRICE: 'Le prix saisi n\'est pas valide',
        CHANGE_CUSTOMER_AND_SHIPPING_ADDRESS: 'Changer client et adresse livraison',
        EDIT_QUANTITY: 'Modifier quantité',
        WHOLESALE_PRICE: 'Prix de gros',
        DISCOUNT: 'Remise',
        EDIT_NET_PRICE: 'Modifier le prix net',
        EDIT_RETAIL_PRICE: 'Modifier le prix de vente',
        CURRENT_UNIT_PRICE: 'Prix unitaire actuel',
        NEW_UNIT_PRICE: 'Nouveau prix',
        NEW_RETAIL_PRICE: 'Nouveau prix de vente',
        CURRENT_RETAIL_PRICE: 'Prix de vente actuel',
        RETAIL_PRICE: 'Prix de vente',
        SUCCESS_REPLACE_ITEMS: 'Articles remplacés avec succès',
        SUCCESS_CHANGE_ITEMS_QUANTITY: 'Quantités articles modifiées avec succès',
        SUCCESS_DELETE_ITEMS: 'Articles supprimés avec succès',
        SUCCESS_OPERATION: 'Opération mise en file d\'attente avec succès',
      },

      COMMERCIAL_AGREEMENT: {
        NAME: 'Accords commerciaux',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nom',
          VALID_FROM: 'Valide de',
          VALID_UNTIL: 'Valable pour',
          DISCOUNT_PERCENTAGE: '% remise',
          TOTAL_RETAIL_AMOUNT: 'Tot. retail (€)',
          RESIDUAL_RETAIL_AMOUNT: 'Tot. résiduel (€)',
          CUSTOMER_NAME: 'Nom du client',
          STATUS: 'Statut',
          CONSUMPTION: 'Consommation',
        },
        MODAL_DELETE: {
          TITLE: 'Supprimer l\'accord commercial',
          MESSAGE: 'Êtes-vous sûr de vouloir supprimer l\'accord commercial?',
          ATTENTION_COMMERCIAL_AGREEMENT_IS_LINKED_ON_VARIOUS_CART: '<strong>Attention!</strong> Il y a {{draftOrdersCount}} chariots liés à cet accord commercial. En supprimant cet accord, les associations seront également supprimées.',
        },
      },

      TERM_OF_SALE: {
        NAME: 'Termes de vente',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Prénom',
          STATUS: 'Statut',
          CREATION_TIME: 'Création de temps',
          LAST_UPDATE_TIME: 'Dernière mise à jour',
        },
      },

      FULFILLMENT: {
        GROUP_ELEMENT: {
          SHIPPING_PACKAGE: 'Colis',
          TOTAL_QUANTITY: 'Quantité totale',
          TOTAL_WEIGHT: 'Poids total',
        },
        COLUMNS: {
          STYLE: 'Article',
          COLOR: 'Couleur',
          SIZE: 'Taille',
          QUANTITY: 'Qty',
          AMOUNT: 'Montant',
          EAN: 'EAN',
          ORDER_ID: 'ID commande',
        },
      },

      PROMOTION: {
        NAME: 'Promotions',
        COLUMNS: {
          ID: 'Id',
          NAME: 'prénom',
          VALID_FROM: 'Valide à partir de',
          VALID_TO: 'Valide jusqu\'à',
          TYPE: 'Type',
          VALID_ON: 'Valide sur',
        },
        MODAL_DELETE_PROMOTION: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_PROMOTION: 'Êtes-vous sûr de vouloir supprimer la promotion?',
        },
        INFO_ALLERT: 'Les remises automatiques définies ne seront pas activées sur les canaux'
      },
      VOUCHERS: {
        NAME: 'Vouchers',
        COLUMNS: {
          ID: 'Id',
          CODE: 'Code',
          DESCRIPTION: 'Description',
          CONSTRAINT_TYPE: 'Contrainte',
          AMOUNT: 'Montante',
          THRESHOLD: 'Seuil',
          VALID_FROM: 'Valide à partir de',
          VALID_TO: 'Valable pour',
          RESIDUAL_AMOUNT: 'Montant résiduel',
          STATUS: 'Statut'
        },
        MODAL_DELETE_VOUCHER: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_VOUCHER: 'Voulez-vous vraiment supprimer le client?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Êtes-vous sûr de dissocier le voucher du client?',
        },
        INFO_ALLERT: 'Les bons configurés ne seront pas activés sur les chaînes',
      },

      PRIVILEGES_CASH: {
        COLUMNS: {
          EXTERNAL_ID: 'ID',
          NAME: 'Nom',
          INITIAL_AMOUNT_WITH_VAT: 'Montant initial avec TVA',
          RESIDUAL_AMOUNT_WITH_VAT: 'Montant résiduel avec TVA',
          RESIDUAL_AMOUNT_WITHOUT_VAT: 'Montant résiduel sans TVA',
          VALID_FROM: 'Valide à partir de',
          VALID_TO: 'Valable pour',
          STATUS: 'Statut',
        },
        STATUS: {
          IMPORTABLE: 'Importable',
          ALREADY_IMPORTED: 'Déjà importé',
        },
      },

      DISCOUNT: {
        NAME: 'Remises',
      },

      CART: {
        NAME: 'Paniers',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nom',
          VARIANTS: 'Variantes',
          POS: 'Point de vente',
          TOTAL: 'Total',
          TOTAL_RETAIL: 'Total retail',
          DATE: 'Date',
          TYPE: 'Type',
          AGENCY_CODE: 'Agence',
          CHANNEL_NAME: 'Canal',
          PCS: 'Pcs',
          SEASON_REFERENCE: 'Season reference',
          NOTE: 'Notes',
          EXTERNAL_ID: 'External ID',
        },
        ASTERISK_MESSAGE: 'Totaux calculés sur les prix de vente car ils appartiennent aux filières',
        MISSING_EXCEL_FILE_MESSAGE: 'Pour continuer, vous devez télécharger un fichier Excel',
        MISSING_EXCE_CODE_MESSAGE: 'Sélectionnez un type de code pour pouvoir télécharger le modèle',
        UPLOAD_DONE: 'Opération lancée avec succès ! Vous recevrez un e-mail avec le résultat de l’opération.',
        MODAL_IMPORT: {
          IMPORT_CART_FROM_FILE_XLSX: 'Importer un panier à partir d\'un fichier XLSX',
          CART_REPORT_UPLOADED: 'Le rapport de panier a été téléchargé',
          CUSTOMER: 'Client',
          POINT_OF_SALE: 'Point de vente',
          CART_NAME: 'Nom du panier',
          TYPE: 'Type',
          ALTERNATIVE_SHIPPING_ADDRESS: 'Adresse de livraison alternative',
          PRODUCT: 'Produit',
          AGENCY: 'Agence'
        },
        MODAL_DUPLICATE_CART: {
          DUPLICATE_CART: 'Dupliquer le panier',
          DUPLICATE: 'Dupliquer',
        },
        MODAL_DELETE_CART: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_CART: 'Êtes-vous sûr de vouloir supprimer le panier?',
        },
      },

      ADMIN_DOWNLOADS: {
        NAME: 'Téléchargements administratifs',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nom',
          EXTENTION: 'Type',
          UPLOAD_DATE: 'Date de téléchargement',
          CREATOR: 'Créateur',
        },
        ACTION: {
          DOWNLOAD: 'Télécharger',
          DELETE: 'Supprimer',
          UPLOAD_FILE: 'Téléverser un fichier',
        },
        MODAL_DELETE_FILE: {
          ARE_YOU_SURE: 'Êtes-vous sûr ?',
          ARE_YOU_SURE_DELETE_FILE: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
        },
      },

      ORDER: {
        NAME: 'Commandes',
        COLUMNS: {
          STATUS: 'Statut',
          PENDING_BULK: 'Opérations',
          OPERATIONS: 'Opérations',
          POINTS_OF_SALES: 'Points de vente',
          AGENCY_CODE: 'Code agent',
          CUSTOMER: 'Client',
          GOK: 'GOK',
          REASSORTMENT: 'Réassortiment',
          PRODUCT_EXCHANGE: 'Échange de produits'
        }
      },

      ASSORTMENTS: {
        NAME: 'Assortiments',
        COLUMNS: {
          ID: 'Id',
          TITLE: 'Titre',
          CHANNEL_NAME: 'Canal',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },

      VARIANT_BULK_EDITOR: {
        NAME: 'Éditeur variantes',
        INCLUDE_BY: 'Sélectionner par: ',
        INCLUDE_BY_ASSORTMENT: 'Assortiment',
        INCLUDE_BY_COLLECTION: 'Collection',
        INCLUDE_BY_TIER: 'Tier',
        SELECTED: 'Sélectionné',
        EDIT_SELECTED: 'Modifier la sélections',
        DESELECT_ALL: 'Désélectionner tout',
        YOU_HAVE_JUST_SELECTED: 'Vous avez juste sélectionné',
        NEW_VARIANTS_FROM_ASSORTMENT: 'nouvelles variantes de l\'assortiment',
        NEW_VARIANTS_FROM_COLLECTION: 'nouvelles variantes de collection',
        NEW_VARIANTS_FROM_TIER: 'nouvelles variantes de tier',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_ASSORTMENT: 'Vous pouvez sélectionner toutes les variantes d\'un assortiment donné',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_COLLECTION: 'Vous pouvez sélectionner toutes les variantes d\'una collection donné',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_TIER: 'Vous pouvez sélectionner toutes les variantes d\'un tier donné',
        NO_ASSORTMENT_TO_VIEW: 'Aucun assortiment à afficher',
        NO_COLLECTION_TO_VIEW: 'Aucun collection à afficher',
        NO_SELECTED_VARIANTS: 'Aucune variante sélectionnée',
        ORDERS_FROM_LIST: 'Commandes de la liste',
        CONFIRM_LEAVE_PAGE: {
          ARE_YOUR_SURE: 'Êtes-vous sûr?',
          IF_YUO_LEAVE_PAGE_YOU_WILL_LOSE_ALL_CHANGES: 'Si vous quittez la page, vous perdrez toutes les modifications',
        },
        UNPUBLISH_ALL_FOR_PRE_ORDER: 'Dépublier tout pour pré-commande',
        ARE_YOU_SURE: 'Êtes-vous sûr?',
        ARE_YOU_SURE_UNPUBLISH_ALL_VARIANTS_FROM_PRE_ORDER: 'Êtes-vous sûr de vouloir dépublier toutes les variantes de pré-commande?',
        UNPUBLISH_ALL_FOR_PRE_ORDER_WARNING: 'Cette action sera appliquée à tous les produits',
        MESSAGE_SUCCESS_UNPUBLISH: 'Toutes les variantes de pré-commande ont été dépubliées',
        MESSAGE_SUCCESS_SEND_EMAIL: 'Le rapport des variantes pré-commande a été envoyé avec succès',
        DOWNLOAD_REPORT_VARIANTS_ON_PRE_ORDER: 'Télécharger le rapport des variantes pre-order',
        DOWNLOAD_REPORT_VARIANTS_ON_RE_ORDER: 'Télécharger le rapport des variantes re-order',
        DOWNLOAD_REPORT_VARIANTS: 'Télécharger le rapport des variantes',
        DOWNLOAD_REPORTS: 'Télécharger les rapports',
        PUBLISHED_VARIANTS: 'Par publication et canal de vente',
        REPORT_OF_VARIANTS: 'Rapport des variantes',
        DOWNLOAD_REPORT_OF_VARIANTS: 'Télécharger le rapport des variantes',
        ARE_YOU_SURE_DELETE_ORDERS: 'Êtes-vous sûr de vouloir supprimer ce niveau?',
      },

      TIERS: {
        NAME: 'Tiers',
        CREATE_MODAL: {
          ADD_NEW_TIER: 'Ajouter un nouveau niveau',
          EDIT_TIER: 'Modifier le niveau',
          NAME: 'Nom',
          DESCRIPTION: 'Description',
        },
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nom',
          DESCRIPTION: 'Description',
          CREATED_ON: 'Créé el',
          CREATED_BY: 'Créé par',
        },
        DELETE_MODAL: {
          TITLE: 'Êtes-vous sûr?',
          DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer ce niveau?',
        },
        ARCHIVE_MODAL_DESCRIPTION: 'Êtes-vous sûr de vouloir archiver ce niveau ? L\'opération n\'est pas réversible.'
      },

      SEASON_REFERENCE: {
        NAME: 'Season Reference',
        CREATE_EDIT: {
          NAME: 'Nom',
          DATE_FROM: 'Valable à partir de',
          DATE_TO: 'Valable jusqu\'à',
        },
        TABLE: {
          ID: 'Id externe',
          NAME: 'Nom',
          DATE_FROM: 'Valable à partir de',
          DATE_TO: 'Valable jusqu\'à',
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Créer un nouveau',
          EDIT: 'Modification',
          CANCEL: 'Annuler',
          SAVE: 'Sauver',
        },
        DELETE_MODAL: {
          DELETE_SR: 'Supprimer season reference',
          SURE: 'Voulez-vous éliminer ce sr?',
          DELETE: 'Supprimer'
        }
      },

      SHOWCASES: {
        NAME: 'Showcases',
        CREATE_EDIT: {
          NAME: 'Nom',
          DATE_FROM: 'Valable du',
          DATE_TO: 'Valable jusqu\'au',
        },
        TABLE: {
          NAME: 'Nom',
          STATUS: 'Statut',
          ACTIVE: 'Actif',
          INACTIVE: 'Inactif'
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Créer un nouveau',
          EDIT: 'Modifier',
          CANCEL: 'Annuler',
          SAVE: 'Enregistrer',
        },
        AUTOMATIC_DISCOUNTS: {
          TITLE: 'Ajouter une remise automatique',
          ARE_YOU_SURE: 'Êtes-vous sûr de vouloir supprimer la vitrine de la remise automatique',
          ALREADY_ADDED_TITLE: 'Déjà ajouté',
          ALREADY_ADDED: 'Cette vitrine est déjà associée à cette remise automatique.'
        },
        ASSORTMENTS: {
          TITLE: 'Ajouter un assortiment',
          ARE_YOU_SURE: 'Êtes-vous sûr de vouloir retirer cette vitrine de l\'assortiment',
          ALREADY_ADDED: 'La vitrine est déjà associée à cet assortiment.'
        },
        DESCRIPTION: {
          NAME: 'Sélectionnez la vitrine pour laquelle l\'assortiment est disponible:'
        },
        DELETE_MODAL: {
          DELETE_SR: 'Supprimer la vitrine',
          SURE: 'Voulez-vous supprimer cette vitrine?',
          DELETE: 'Supprimer'
        }
      },

      AGENCIES: {
        NAME: 'Agences',
        CHANGE_AGENCY_ASSOCIATION: 'Association d\'agences/points de vente de changement',
        FROM_AGENCY: 'De l\'agence',
        TO_AGENCY: 'À l\'agence',
        MODAL_INFO: 'Ici, vous pouvez déplacer massivement les liens de tous les points de vente (et chariots correspondants) d\'une agence à l\'autre',
        COLUMNS: {
          VAT: 'TVA',
          AGENCY_CODE: 'Code',
          NAME: 'Nom',
          CITY: 'Ville',
          ORDERS_YTD: 'Commandes (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          STATUS: 'Statut',
        },
        MODAL_DELETE_AGENCY: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_AGENCY: 'Êtes-vous sûr de vouloir supprimer l\'agence?',
        },
        POS_UPDATE: 'Points de vente mis à jour: ',
        CARTS_UPDATE: 'Paniers mis à jour: '
      },

      CUSTOMERS: {
        NAME: 'Clients',
        COLUMNS: {
          VAT: 'TVA',
          ALTERNATIVE_VAT: 'TVA Alternative',
          ALTERNATIVE_GLN: 'GLN Alternative',
          NAME: 'Nom',
          CITY: 'Ville',
          POS: 'Point de vente',
          POS_PLURAL: 'Points de vente',
          ORDERS_YTD: 'Commandes (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          STATUS: 'Statut',
          RELOAD_PAGE: 'Recharger la page',
          EXTERNAL_ID: 'ID Externe',
          VAT_NUMBER: 'Numéro de TVA',
        },
        INFO_SECTION: {
          INFO: "Infos Client",
          COMMERCIAL_INFO: "Infos Commerciales",
          FINANCIAL_INFO: "Infos Financières",
          CUSTOMER_CLASSIFICATION: "Classification du Client",
          TAX_COMPLIANCE: "Fiscalité & Conformité",
          PREFIX_VAT: "Préfixe TVA",
          VAT_WITHOUT_PREFIX: "TVA sans Préfixe",
          DEFAULT_TRANSACTION_SPECIFICATION: "Spécification Transaction Défaut",
          TRANSACTION_TYPE: "Type de Transaction",
          IBAN: "IBAN",
          MISSING_POS_NAME: 'Nom manquant dans au moins un point de vente',
          SWIFT_CODE: "Code SWIFT",
          BANK_NAME: "Nom de la Banque",
          BANK_ACCOUNT_NUMBER: "Numéro de Compte Bancaire",
          BANK_ACCOUNT_ID: "ID du Compte Bancaire",
          ROUTING_NUMBER: 'Routing number',
          ROUTING_TYPE: 'Routing type',
          FISCAL_CODE: "Code Fiscal",
          ABI: "ABI",
          CAB: "CAB",
          BANKING_DETAILS: "Détails Bancaires",
          SAVE_ERP: "Enregistrer et Envoyer à l'ERP",
          BUSINESS_INFO: "Infos Business",
          ACCOUNT_NUMBER: "Numéro de Compte",
          GENERATE: 'Générer auto',
          ACCOUNT_NUMBER_USED: 'Numéro de compte déjà utilisé!',
          VAT_ALREADY_USED: 'TVA déjà utilisée!',
          EMAIL_ALREADY_USED: 'Email déjà utilisé!',
          CUSTOMERS_GROUP: "Groupe de Clients",
          SALES_TAX_GROUP: "Groupe de Taxes sur les Ventes",
          COMPANY_NAME: "Nom de l’Entreprise",
          PAYMENT_METHOD_CODE: "Code Méthode de Paiement",
          LOGISTICS_TRANSACTIONS: "Logistique & Transactions",
          PACKAGE_GROUPING_MODE: "Mode de Regroupement des Colis",
          DELIVERY_TERMS: "Conditions de Livraison",
          CURRENCY_CODE: "Code Devise",
          ADMINISTRATIVEEMAIL_MISSING: 'Détails du contact : Email administratif manquant',
          PHONE_MISSING: 'Détails du contact : Téléphone manquant',
          MOBILE_MISSING: 'Détails du contact : Mobile manquant',
          FAX_MISSING: 'Détails du contact : Fax manquant',
          EMAIL_MISSING: 'Détails du contact : Email manquant',
          COMMERCIALEMAIL_MISSING: 'Détails du contact : Email commercial manquant',
          PEC_MISING: 'Détails du contact : PEC manquant',
          WEBSITE_MISSING: 'Détails du contact : Site web manquant',
          FACEBOOK_MISSING: 'Détails du contact : Facebook manquant',
          INSTAGRAM_MISSING: 'Détails du contact : Instagram manquant',
          TWITTER_MISSING: 'Détails du contact : Twitter manquant',
          LINKEDIN_MISSING: 'Détails du contact : LinkedIn manquant',
          MISSING_USER: 'Créer un utilisateur ou en insérer un existant',
          MISSING_CONTACTS_POS: 'Données de contact manquantes dans le point de vente',
          MISSING_CONTACTS_POS_FRANCE: 'Saisissez au moins un e-mail administratif',
          MISSING_LOCATION_POS: 'Données d\'adresse manquantes dans le point de vente',
          MISSING_CHANNELS_IN_DROPDOWN: 'Pour chaque point de vente, activez au moins un magasin et ajoutez au moins un canal de vente pour chaque magasin actif',
          MISSING_ONLINESTORES_POS: 'Données de boutique en ligne manquantes dans le point de vente',
          TOOLTIP_TAX_COMPLIANCE: 'Saisir un numéro de TVA valide et unique',
          TOOLTIP_COMPANY_OWNER: 'Il est nécessaire de créer/sélectionner un utilisateur',
          NOT_POSSIBLE_SAVE: 'Impossible d’enregistrer',
          SAVE_CHANGES: 'Voulez-vous enregistrer les modifications ?',
          SUBJECTED_FACTORING: "Factor",
          CREDIT_LIMIT: 'Credit limit',
          PAYMENT_TERMS_CODE: "Code des Conditions de Paiement",
          PAYMENT: "Paiement",
          SDI_CODE: "Code SDI",
          OFFICE_PA_CODE: "Code du Bureau PA",
          PEC_EMAIL: "Email PEC",
          CENTRAL_OF_PAYMENT: 'Compte du centre de paiement',
          CENTRAL_OF_PAYMENT_NUMBER: 'Numéro du centre de paiement',
          INVOICING_ACCOUNT_NUMBER: 'Compte de facturation',
          COMPANY_FORM: "Forme Juridique",
          KNOWN_AS: "Aussi Connu Comme",
          GROUP_REPS: "Groupe de Représentants",
          SWITCH_1: 'Ce client peut être attribué comme "Compte de facturation" pour d’autres clients',
          SWITCH_2: 'Ce client peut être attribué comme "Compte du centre de paiement" pour d’autres clients',
          BILLING_LOCATION: "Adresse de Facturation",
          ADDRESS: "Adresse",
          ALTERNATIVE_ADDRESS: "Adresse Alternative",
          PROVINCE: "Province",
          POSTAL_CODE: "Code Postal",
          EXTERNAL_LOCATION_ID: "ID externe du lieu",
          CITY: "Ville",
          COUNTRY: "Pays",
          COMPANY_IDENTIFICATION: "Identification de l’Entreprise",
          SIREN_NUMBER: "Numéro SIREN",
          SIRET_NUMBER: "Numéro SIRET",
          GLN_NUMBER: "Numéro Client GLN",
          TOOLTIP_DETAIL_CONTACTS: 'Saisissez au moins un contact pour chaque type énuméré ci-dessous',
          CONTACTS_DETAIL: "Détail des Contacts",
          ADMINISTRATIVE: "Administratif",
          TYPE: "Type",
          VALUE: "Valeur",
          ANALYTICS: "Analyse",
          CLASSIFICATION_GROUP: 'Groupe de Classification Client',
          GROUP_CODE: "Code du Groupe Client",
          SUB_CODE: "Code du Sous-Groupe Client",
          SINGBOARD: "Panneau d'affichage pour les clients",
          HOLDING: "Holding du Client",
          MISSING_FIELDS: 'Les champs suivants ne sont pas remplis',
          MISSING_FIELDS_TOOLTIP: 'Impossible d\'envoyer à l\'ERP car les champs suivants ne sont pas remplis :',
          MISSING_FIELDS_EMPTY: 'Envoi vers l\'ERP possible, tous les champs obligatoires ont été remplis ✅',
          ALREADY_SENT: '✅ Client déjà envoyé, aucune modification',
          SELECT_COUNTRY: "Sélectionnez un pays",
          ADD_LOCATION_BEFORE_CONTACTS: "Remplissez et enregistrez la section <strong>\"Adresse de Facturation\"</strong> avant d'ajouter les contacts"
        },
        SUMMARY: {
          ORDER_INSIGHTS: 'Informations sur les achats',
          CARTS_ORDERS_PLACED: 'Commandes et chariots placés'
        },
        GOK: {
          NEW_GOK: 'Nouveau Gok',
          EDIT_GOK: 'Modifier Gok',
          NAME: 'Nom',
          TOTAL_AMOUNT: 'Montant total',
          DISACTIVE: 'Inactif',
          EMAIL: 'Contacter Gok par courrier électronique',
          MODIFY_EMAIL: 'Modifier l\'email',
          VALID_FROM: 'Valable depuis',
          VALID_TO: 'Valable jusqu\'au',
          RESIDUAL: 'Résiduel',
          ORIGINAL_AMOUNT: 'Montant original',
          STATUS: 'Statut',
          TITLE_MODAL: 'Supprimer Gok',
          MESSAGE: 'Êtes-vous sûr de vouloir supprimer ce Gok',
          CANT_ELIMINATE: 'Il n\'est pas possible de supprimer/modifier ce Gok car il a déjà été utilisé',
          IMPOSSIBLE: 'Dates non disponibles',
          DATE_RANGE: 'Un GOK existe déjà dans la période sélectionnée. Veuillez choisir une plage de dates qui ne chevauche pas celles existantes.',
          ACTIVATE_GOK: 'Gok actif',
          NUMBER: 'Numéro Gok',
          MODIFY_GOK_NUMBER: 'Modifier le numéro Gok',
          ADD_GOK_NUMBER: 'Ajoutez un numéro gok pour activer sa création'
        },
        ATTACHMENTS: {
          TITLE: 'Pièces jointes',
          NAME: 'Nom',
          CODE: 'Code',
          COMMENTS: 'Commentaires',
          CREATION_TIME: 'Date de création',
          TITLE_MODAL: 'Supprimer les pièces jointes',
          MESSAGE: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe',
          VIEW_ATTACHMENTS: 'Voir les pièces jointes',
        },
        COMMERCIAL_BLOCK: {
          TITLE: 'Bloc commercial client',
          DESCRIPTION: 'En activant le bloc commercial sur le client, personne, à l\'exception des utilisateurs ayant les rôles StoreOwner, StoreUser et Admin, ne pourra confirmer le panier d\'achat',
          RESTRICTION_CAUSE: 'Cause de la restriction',
          BLOCK_USER: 'Utilisateur bloqué',
        },
        ORDER_CONFIRMATION_EMAIL: {
          TITLE: 'E-mail de confirmation de commande',
          BLOCK_BY_DEFAULT: 'Ne pas envoyer l\'e-mail de confirmation de commande',
          DESCRIPTION: 'Si activé, à la confirmation d\'un panier de ce client l\'option « Ne pas envoyer d\'e-mail de confirmation » est déjà cochée. La personne qui confirme peut toujours la décocher.',
          TOOLTIP_NOT_RECEIVED: 'Ne le reçoivent plus : les contacts e-mail de l\'adresse de facturation du client et les contacts de l\'agence.',
          TOOLTIP_STILL_RECEIVED: 'Le reçoivent toujours : la personne qui confirme la commande (y compris le client lui-même, s\'il confirme depuis la boutique, ou un agent) et l\'adresse de notification de la boutique, en copie cachée.',
          TOOLTIP_EXCEPTIONS: 'L\'e-mail part à tout le monde comme avant si la personne qui confirme décoche l\'option, et pour les commandes créées en masse.',
        },
        MODAL_DELETE_CUSTOMER: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Êtes-vous sûr de vouloir supprimer le client?',
        },
        MODAL_IMPORT_CUSTOMER: 'Importer un client par Id Post Office',
        CREATE_CUSTOMER: 'Créer un client'
      },

      USERS: {
        NAME: 'Utilisateurs',
        COLUMNS: {
          NAME: 'Nom',
          EMAIL: 'Email',
          ROLE: 'Rôle',
          COMPANY: 'Société',
          TYPE: 'Type',
          STATUS: 'Statut',
          GOK_NUMBER: 'Numéro Gok',
        }
      },

      LOCATION: {
        NAME: 'Emplacements',
        PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: 'Veuillez remplir tous les champs obligatoires',
        PLEASE_FILL_IN_ALL_STOCK_LIMIT_FIELDS: 'Veuillez remplir tous les champs de limite de stock',
        PLEASE_ENABLE_AT_LEAST_ONE_STORE_AND_ITS_CHANNEL: 'Veuillez activer au moins un magasin et son canal',
        PLEASE_ENABLE_AT_LEAST_ONE_CHANNEL: 'Veuillez sélectionner au moins un canal de vente pour chaque magasin activé',
        POINT_OF_SALE: 'Point de vente',
        SHIPPING_LOCATION: 'Emplacement de livraison',
        CREATE_MODAL: {
          CREATE_NEW_POINT_OF_SALE: 'Créer un nouveau point de vente',
          CREATE_NEW_SHIPPING_ADDRESS: 'Créer un nouvel emplacement de livraison',
        },
        COLUMNS: {
          NAME: 'Nom',
          CITY: 'Ville',
          STORES: 'Boutiques',
          ORDERS_YTD: 'Commandes (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          COUNTRY: 'Pays',
          ADDRESS: 'Adresse',
        },
        MODAL_DELETE_POS: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_POINT_OF_SALE: 'Êtes-vous sûr de vouloir supprimer le point de vente?',
        },
        MODAL_DELETE_SA: {
          ARE_YOU_SURE: 'Êtes-vous sûr?',
          ARE_YOU_SURE_DELETE_SHIPPING_ADDRESS: 'Êtes-vous sûr de vouloir supprimer l\'emplacement de livraison?',
        },
      },

      PRODUCT_LIST: {
        NAME: 'Liste de produits',
        COLUMNS: {
          STYLE: 'Style',
          NAME: 'Nom',
          WHOLE_SALE: 'Pre-order wholesale',
          RETAIL: 'Pre-order retail',
          ALL_IMAGES_HIDDEN: 'Images masquées',
          STOCK: 'Stock',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        },
        PRICE: 'Prix',
        VARIANTS: 'Variantes',
        INCLUDED: 'Inclus',
        SELECTED: 'sélectionnées',
        BY_PRODS: 'Par produits',
        BY_DATE: 'Date de livraison',
      },

      VARIANT: {
        COLUMNS: {
          SKU: 'SKU',
          SIZE: 'Taille',
          COLOR: 'Couleur',
          STOCK_QTY: 'Stock (q.ty)',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
          STOCK_LIMIT: 'Limite stock',
        },
      },
      SALES_CAMPAIGNS: {
        COLUMNS: {
          NAME: 'Nom',
          CAMPAIGN_VALIDITY: 'Validité de la campagne',
          REORDER_VALIDITY: 'Validité de réapprovisionnement',
          STORE_REORDER_START: 'Début du réapprovisionnement du magasin',
          APPLY_REORDER_SPENDING_LIMIT_ONLY_TO_AUTOMATIC_DISCOUNT_ITEMS:
            'Appliquer la limite de dépenses de réapprovisionnement uniquement aux articles avec remise automatique',
          STORE_REORDER_END: 'Fin du réapprovisionnement du magasin',
          UNLIMITED_REORDER: 'Variantes avec réapprovisionnement illimité',
          UNLIMITED_REORDER_TOOLTIP:
            'En sélectionnant ces variantes, vous autorisez un réapprovisionnement illimité pour celles-ci.',
          LIMITED_REORDER_PIECES: 'Variantes avec limite maximale de pièces réapprovisionnables',
          LIMITED_REORDER_PIECES_TOOLTIP:
            'En sélectionnant ces variantes, vous appliquez la limite maximale de pièces réapprovisionnables pour chacune.',
          PERCENTAGE: 'Pourcentage de réapprovisionnement pour cette campagne',
          REORDER_PERCENTAGE: 'Pourcentage de réapprovisionnement',
          REORDER_PIECES_PERCENTAGE: 'Pourcentage maximum de pièces à réapprovisionner par variante',
          PREORDER_SPENDING_LIMIT: 'Limite de dépense en pré-commande',
          PREORDER_PERCENTAGE: 'Pourcentage de dépense en pré-commande',
          PREORDER_SPENDING_LIMIT_TOOLTIP: 'Dépense maximale en pré-commande autorisée sur chaque variante sélectionnée, calculée comme ce pourcentage de la dépense sur la même variante dans la campagne précédente.',
          PREORDER_TIER_PERCENTAGES: 'Pourcentage de dépense en pré-commande par tier',
          PREORDER_TIERS_DESCRIPTION: 'Le pourcentage s\'applique aux points de vente du tier. Tiers sans pourcentage et points de vente sans tier : aucune limite.',
          PREORDER_TIER: 'Tier',
          PREORDER_TIER_ARCHIVED: 'Archivé',
          PREORDER_TIER_NO_LIMIT: 'Aucune limite',
          PREORDER_TIERS_SAVE_FIRST: 'Enregistrez la campagne pour définir les pourcentages par tier.',
          PREORDER_TIERS_EMPTY: 'Aucun tier sur le canal de pré-commande de ce magasin : la limite de dépense en pré-commande ne s\'applique pas.',
          PREORDER_TIERS_SEARCH: 'Rechercher des tiers...',
          PREORDER_BASELINE_CAMPAIGN: 'Campagne précédente',
          SELECT_PREVIOUS_CAMPAIGN: 'Sélectionnez une campagne précédente',
          PREORDER_AVAILABLE_VARIANTS: 'Variantes disponibles',
          PREORDER_AVAILABLE_VARIANTS_TOOLTIP: 'Sélectionnez les variantes soumises à la limite : seules les variantes sélectionnées sont contraintes par le pourcentage ; les autres restent illimitées en pré-commande.',
          INSERT_PERCENTAGE: 'Entrer un pourcentage',
          DESCRIPTION: 'Description',
          START_DATE: 'Date de début',
          END_DATE: 'Date de fin',
          SHOP_SELLING_PERIOD_START: 'Début des ventes en magasin',
          SHOP_SELLING_PERIOD_END: 'Fin des ventes en magasin',
          DELIVERY_PERIOD_START: 'Début de livraison',
          DELIVERY_PERIOD_END: 'Fin de livraison'
        },
        CREATE_MODAL: {
          EDIT_SALE_CAMPAIGN: 'Modifier la campagne de vente',
          ADD_NEW_SALE_CAMPAIGN: 'Ajouter une campagne de vente'
        },
        ERROR_MODAL:{
          TITLE: 'Erreur',
          DESCRIPTION: 'Veuillez remplir tous les champs obligatoires'
        },
        DELETE_MODAL: {
          TITLE: 'Êtes-vous sûr?',
          DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer cette campagne de vente?'
        },
        RULE: {
          COLUMN: {
            ID: 'Id',
            NAME: 'Nom',
            ROLES_BYPASSING: 'Rôles qui contournent la règle',
            TIER: 'Tier',
            LAST_MODIFICATION_TIME: 'Dernière modification',
            STATUS: 'Statut',
          },
        },
      },
      REPORTS: {
        NAME: 'Reports',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nom',
          TYPE: 'Type',
          CREATOR: 'Créateur',
          COMPLETED_AT: 'Completé le',
        },
      },

    },
    SALES_CAMPAIGNS: {
      NAME: 'Nom',
      VALIDITY: 'Valide',
      COMMERCIAL_RULES: 'Règles commerciales',
      PRE_ORDER: 'Pré-commande',
      RE_ORDER: 'Réapprovisionnement',
      VARIANT_UNLIMITED_REORDER_TAG_ADDED: 'Variante ajoutée au réapprovisionnement illimité.',
      VARIANT_UNLIMITED_REORDER_TAG_REMOVED: 'Variante retirée du réapprovisionnement illimité.',
      VARIANT_UNLIMITED_REORDER_TAG_ERROR: 'Impossible de mettre à jour le tag de la variante. Réessayez.',
      UNLIMITED_REORDER_TAG_NOT_FOUND: 'Tag réapprovisionnement illimité introuvable. Contactez le support.',
      VARIANT_LIMITED_REORDER_PIECES_SAVED: 'Variantes avec limite de pièces réapprovisionnables enregistrées avec succès.',
      VARIANT_LIMITED_REORDER_PIECES_TAG_ERROR: 'Impossible de mettre à jour le tag de la variante avec limite de pièces. Réessayez.',
      LIMITED_REORDER_PIECES_TAG_NOT_FOUND: 'Tag limite de pièces réapprovisionnables introuvable. Contactez le support.',
      NEW_RULE: 'Nouvelle règle',
      DELETE_ASSORTMENT_SUCCESSFULLY: 'Assortiment supprimé avec succès',
      DELETE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Contrainte de package supprimée avec succès',
      CREATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Contrainte de package créée avec succès',
      UPDATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Contrainte de package mise à jour avec succès',
      ENABLED_CONSTRAINT_VALUE_SUCCESSFULLY: 'Contrainte de valeur activée avec succès',
      DELETE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Contrainte de valeur supprimée avec succès',
      CREATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Contrainte de valeur créée avec succès',
      UPDATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Contrainte de valeur mise à jour avec succès',
      DELETE_FILTER_SUCCESSFULLY: 'Filtre supprimé avec succès',
      CREATE_FILTER_SUCCESSFULLY: 'Filtre créé avec succès',
      UPDATE_FILTER_SUCCESSFULLY: 'Filtre mis à jour avec succès',
      UPDATE_RULE_SUCCESSFULLY: 'Règle mise à jour avec succès',

      RULES: {
        CONSTRAINT_VALUE_NOT_ENABLED: 'La contrainte ne peut pas être activée pour cet assortiment car elle est déjà active sur un autre assortiment',
        CONSTRAINT_VALUE_INFO_MESSAGE: 'Ce contrainte se déclenchera sur chaque chariot lié à cette règle commerciale.',
        CONSTRAINT_VALUE_ENABLED: 'Contrainte valeur activée',
        NO_ASSORTMENTS: 'Aucun assortiment configuré, ajouter un assortiment pour gérer les contraintes',
        NO_CONSTRAINT_PACKAGE: 'Vous n\'avez encore saisi aucune restriction de forfait pour cet assortiment',
        NO_CONSTRAINT_VALUE: 'Activez cette fonctionnalité pour insérer la contrainte de valeur sur cet assortiment',
        NO_CONSTRAINT_FILTER: 'Vous pouvez définir des filtres pour déterminer les articles avec lesquels calculer le total en gros',
        CONSTRAINTS_CONFIGURATION: 'Configuration des contraintes',
        TITLE: 'Règles',
        RULE: 'Règle: {{ruleName}}',
        NAME: 'Nom',
        TIER: 'Tier',
        ROLES_BYPASSING: 'Rôles qui contournent la règle',
        ADD_ASSORTMENT: 'Ajouter un assortiment',
        ADD_CONSTRAINT: 'Ajouter une contrainte',
        ADD_RULE: 'Ajouter une règle',
        CONSTRAINTS_PACKAGE: 'Contraintes de package',
        QUANTITY: 'Quantité',
        STYLES_CODE: 'Produits',
        CONSTRAINT_VALUE: 'Contraintes de valeur',
        PERCENTAGE: 'Pourcentage',
        TYPE: 'Type',
        CONDITION: 'Condition',
        VALUE: 'Valeur',
        VALUE_RULE_WHEN_CALCULATE_TOTAL_WHOLESALE_INFORMATION: 'La valeur en gros des articles appartenant à cet assortiment, rapportée au prix de gros total du panier, doit être supérieure ou égale à :',
        VALUE_RULE_INFORMATION: 'Filtres pour déterminer les articles de commande sur lesquels évaluer la contrainte de valeur :',
        ADD_OR_REMOVE: 'Ajouter ou supprimer',
        ADD_FILTER: 'Ajouter un filtre',
        ACTIVATE: 'Activer règle',
        DISABLE: 'Désactiver règle'
      },
      TYPE: {
        WHERE_STYLE_GROUP: 'Où style group',
        WHERE_SIZE_GROUP: 'Où size group',
      },
      CONDITION: {
        IS: 'est',
        IS_NOT: 'n\'est pas',
      },
    },
    PICK_LIST: {
      TO_INCLUDE: 'À inclure',
      INCLUDED: 'Inclus',
      VARIANTS_SELECTED: 'variantes sélectionnées: {{quantity}}',
      ALL: 'tout',
      SELECTED_ALL: 'Tout sélectionné',
      CLICK_FOR_OPEN_REPORT: 'Cliquez pour ouvrir le rapport',
      INCLUDE: 'Inclure',
      EXCLUDE: 'Exclure',
      VARIANTS: 'Variantes {{quantity}}',
      SUCCESS_VARIANTS_DISASSOCIATE: '{{quantity}} variantes dissocier avec succès',
      SUCCESS_VARIANTS_ASSOCIATE: '{{quantity}} variantes associées avec succès',
      NO_OTHER_DATA: 'Aucune autre donnée',
      NO_DATA_FOUND: 'Aucune donnée trouvée',
      SELECT_ALL_MODAL: {
        TITLE: 'Sélectionnez tout',
        MESSAGE: '<strong>Attention! </strong> La sélection de ce mode sélectionnera tous les produits et variantes disponibles pour les filtres sélectionnés. <br> Vous pouvez toujours exclure des produits et des variantes de la liste de sélection.',
        NOT_SHOW_AGAIN: 'Ne plus afficher',
        CONFIRM: 'Confirmer',
      },
      SELECT_ALL_CANCELED: 'Sélectionnez tout annulé',
      REPORT_SELECTED_MODAL: {
        TITLE: 'Rapport sélectionné',
        NOT_SELECTED: 'Aucune variante ou couleur de produit n\'a encore été sélectionnée',
        YOU_ARE_SELECTING: 'Vous sélectionnez {{quantity}} {{what}}',
        YOU_ARE_EXCLUDING: 'excluez {{quantity}} {{what}}',
        PRODUCT_STYLE_COLOR: 'produit-couleur',
        VARIANTS: 'variantes',
        YOU_ARE_SELECTING_ALL_VARIANTS_FOR_THIS_FILTERS: 'Vous sélectionnez toutes les variantes pour ces filtres',
        YOU_ARE_SELECTING_THE_ENTIRE_CATALOGUE_AVAILABLE: 'Vous sélectionnez tout le catalogue disponible',
        FROM_THE_SELECTION_YOU_ARE: 'De la sélection, vous êtes',
        EXCLUDING_PRODUCTS_STYLE_COLOR: 'exclure {{quantity}} produits-couleurs',
        EXCLUDING_VARIANTS: 'exclure {{quantity}} variantes',
        NOT_VARIANT_OR_PRODUCT_STYLE_COLOR_HAS_BEEN_SELECTED_YET: 'Aucune variante ou couleur de produit n\'a encore été sélectionnée',

      },
      SAVE_INCLUDE_EXCLUDE_MODAL: {
        ARE_YOU_SURE: 'Êtes-vous sûr?',
      }
    },
    COMMERCIAL_AGREEMENT_DETAIL: {
      CONTINUE_WITHOUT_COMMERCIALAGREEMENT: "Continue sans sélection",
      BACK_TO_COMMERCIAL_AGREEMENTS: 'Retour aux accords commerciaux',
      CREATE_NEW_COMMERCIAL_AGREEMENT: 'Créer un nouvel accord commercial',
      COMMERCIAL_AGREEMENT: 'Accord commercial: {name}',
      COMMERCIAL_AGREEMENT_INFO: 'Informations sur l\'accord commercial',
      NAME: 'Nom',
      VALID_FROM: 'Valide de',
      VALID_UNTIL: 'Valable pour',
      DISCOUNT_PERCENTAGE: '% remise',
      TOTAL_RETAIL_AMOUNT: 'Plafond (valeur retail, €)',
      CUSTOMER: 'Client',
      CHANNEL: 'Canal',
      ERRORS: {
        COMPILE_ALL_REQUIRED_FIELDS: 'Veuillez remplir tous les champs obligatoires',
      },
    },
    TERM_OF_SALE_DETAIL: {
      BACK_TO_TERMS_OF_SALE: 'Retour aux conditions de vente',
      CREATE_NEW_TERM_OF_SALE: 'Créer une nouvelle condition de vente',
      TERM_OF_SALE: 'Condition de vente',
      NAME: 'Nom',
      SET_AS_ACTIVE: 'Définir comme actif',
      TERMS_AN_CONDITIONS_BY_LANGUAGE: 'Termes et conditions par langue',
      PLEASE_SELECT_A_DEFAULT_LANGUAGE: 'Sélectionnez une langue par défaut à l\'aide du menu d\'action à côté du nom de la langue sélectionnée',
      PLEASE_WRITE_A_TERM_OF_SALE_FOR_THE_DEFAULT_LANGUAGE_OR_SELECT_ANOTHER_DEFAULT_LANGUAGE: 'Écrivez un terme de vente pour la langue par défaut ou sélectionnez une autre langue par défaut',
      PLEASE_ENTER_A_VALID_TERM_OF_SALE_NAME: 'Veuillez entrer un nom de condition de vente valide',
      TERM_OF_SALE_UPDATE_SUCCESS: 'Termine de vente mis à jour avec succès',
      TERM_OF_SALE_CREATE_SUCCESS: 'Termine de vente créé avec succès',
      NAME_ALREADY_EXISTS: 'Le nom existe déjà',
      ENTER_THE_TERM_OF_SALE: 'Entrez le terme de vente',
      NAME_REQUIRED: 'Nom requis',
      NAME_INVALID: 'Nom invalide',
      TERM_OF_SALE_DELETE_SUCCESS: 'Termine de vente supprimé avec succès',
      ARE_YOU_SURE: 'Êtes-vous sûr?',
      ARE_YOU_SURE_DELETE_TERM_OF_SALE: 'Êtes-vous sûr de vouloir supprimer la condition de vente?',
      ERROR_IS_APPLIED_TO_ORDERS: 'Ces conditions de vente ne peuvent être ni modifiées ni supprimées car elles ont été associées à une ou plusieurs commandes',
    },
    TIER_DETAIL: {
      BACK_TO_TIERS: 'Retour aux tiers',
      CREATE_NEW_TIER: 'Créer un nouveau tier',
      NAME: 'Nom',
      INFORMATION: 'Information',
      DESCRIPTION: 'Description',
      INCLUDE_VARIANTS: 'Inclure les variantes',
      INCLUDED_VARIANTS: 'Variantes incluses',
      ASSOCIATE_VARIANTS: 'Associer des variantes',
      DISASSOCIATE_VARIANTS: 'Dissocier des variantes',
      PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Veuillez remplir tous les champs obligatoires',
      TIER_UPDATE_SUCCESS: 'Tier mis à jour avec succès',
      TIER_CREATE_SUCCESS: 'Tier créé avec succès',
      VARIANTS_DISASSOCIATED_SUCCESS: 'Variantes dissocier avec succès',
      VARIANTS_ASSOCIATED_SUCCESS: 'Variantes associées avec succès',
      REMOVE_POS_FROM_TIER: 'Êtes-vous sûr de vouloir supprimer le point de vente du niveau?',
      POS_ALREADY_ASSOCIATED: 'Point de vente déjà associé au niveau',
      OPTION_DESCRIPTION: 'En activant cette option, les magasins avec ce niveau associé verront non seulement les variantes de ce niveau, mais aussi celles sans niveau associé, pour le canal de vente défini.',
      INFO_ALLERT: {
        INCLUDE_VARIANTS: 'Sélectionnez les variantes à inclure dans le niveau, puis cliquez sur Enregistrer pour mettre à jour le niveau.',
        INCLUDED_VARIANTS: 'Ce sont les variantes incluses dans le niveau. Sélectionnez les variantes que vous souhaitez dissocier, puis cliquez sur Enregistrer pour mettre à jour le niveau.',
      },
      DETAIL: 'Détail',
      ASSOCIATED_VARIANTS: 'Variantes associées',
      ARCHIVED_TIER: 'Niveau archivé #{{tierName}}',
      WORK_IN_PROGRESS_MESSAGE: 'Ici, vous pourrez voir les variantes associées à ce niveau. Nous travaillons pour vous.',
      CHANNEL: 'Canal',
      ARE_YOU_SURE_SAVE_STORE_POINTS_OF_SALE: 'Êtes-vous sûr de vouloir associer les points de vente sélectionnés au niveau actuel?',
      SELECTED_STORE_POINTS_OF_SALE: 'Points de vente sélectionnés',
      STORE_POINTS_OF_SALE_SAVED: 'Points de vente enregistrés avec succès',
    },
    LOCATION_DETAIL: {
      POINT_OF_SALE_INFO: 'Informations sur le point de vente',
      BACK_TO_POS: 'etour aux points de vente',
      ADDRESS_INFO: 'Informations sur l\'adresse',
      PURCHASE_STATS: {
        NAME: 'Statistiques d\'achat',
        TOTAL_CUSTOMER_REVENUE: 'Revenu total des clients',
        FROM_PRE_ORDER: 'À partir de la pre-order',
        FROM_RE_ORDER: 'À partir de la re-order',
        TOTAL_MARGIN: 'Total de la marge',
        TOTAL_ORDERS: 'Total des commandes',
        AVERAGE_ORDER_VALUE: 'Valeur moyenne de la commande',
      },
      SUMMER_STOCK_LIMIT: 'Limite de stock d\'été',
      WINTER_STOCK_LIMIT: 'Limite de stock d\'hiver',
      SUMMER_START_MONTH: 'Mois de début d\'été',
      WINTER_START_MONTH: 'Mois de début d\'hiver',
      SUMMER_START_DAY: 'Jour de début d\'été',
      WINTER_START_DAY: 'Jour de début d\'hiver',
      STOCK_LIMIT: 'Limite de stock',
      THE_WAREHOUSE_LIMIT_MUST_BE_SET_FOR_THE_CHANNELS: 'La limite de stock doit être définie pour les canaux',
      ONLINE_STORES_ENABLED: 'Boutiques en ligne activés',
      USE_NAME_IN_ORDER_HEADER: 'Utiliser le nom du point de vente sur le bon de commande',
      BACK_TO_LOCATIONS: 'Retour aux emplacements',
      NAME: 'Nom',
      TIER: 'Niveau',
      AGENCY: 'Agent',
      CHANNEL: 'Canal',
      YOU_CANT_EDITINFO_ABOUT_ADDRESS: 'Vous ne pouvez pas modifier les informations sur l\'adresse si elle est en attente d\'approbation pour un boutique!',
      YOU_CANT_ACTIVEATE_THIS_ADDRESS_IF_ITS_CUSTOMER_IS_NOT_APPROVED: 'Vous ne pouvez pas activer cette adresse si son client n\'est pas approuvé!',
      MISSING_STOCK_LIMIT: 'Attention ! Pour activer l’adresse sur le canal Plug&Sell, vous devez d’abord compléter la section relative aux limites de stock !',
      ERROR_MODAL: {
        TITLE: 'Attention!',
        DESCRIPTION: 'Champs manquants pour enregistrer les modifications, complétez les données pour continuer',
      }
    },
    CONTACT: {
      NAME: 'Contact',
      NEW_CONTACT: 'Nouveau contact',
      EDIT_CONTACT: 'Modifier le contact',
      CONTACT_INFO: 'Informations sur le contact',
    },
    USER_DETAIL: {
      USER_INFO: 'Informations sur l\'utilisateur',
      REGISTERED_SINCE: 'Inscrit depuis',
      NAME_SURNAME: 'Nom et prénom',
      NAME_SURNAME_ERROR: 'Nom et prénom obligatoire',
      EMAIL_ERROR: 'Email obligatoire',
      ROLES_ERROR: 'Rôle obligatoire',
      STORE_ERROR: 'Boutique obligatoire',
      CUSTOMER_ERROR: 'Client obligatoire',
      AGENCY_ERROR: 'Agent obligatoire',
      USER_ROLE: 'Rôle de l\'utilisateur',
      AGENCY: 'Agent',
      CUSTOMER: 'Client',
      BACK_TO_USERS: 'Retour aux utilisateurs',
      MY_PROFILE: 'Mon profil',
      INVITE_USER: 'Inviter un utilisateur',
      SEND_INVIATION: 'Envoyer une invitation',
      USER_STATUS: 'Statut de l\'utilisateur',
      RESEND_INVITATION: 'Renvoyer l\'invitation',
      INVITATION_RESENT_COMPLETED: 'Invitation renvoyée avec succès',
      INVITATION_RESENT_ERROR: 'Erreur lors de l\'envoi de l\'invitation',
      MODAL_CONFIRM: {
        ARE_YOU_SURE: 'Êtes-vous sûr?',
        ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER: 'Êtes-vous sûr de vouloir désactiver cet utilisateur?',
      }
    },
    WORK_IN_PROGRESS_TITLE: 'Nous travaillons pour vous : maintenance extraordinaire à partir de {{fromHour}} le {{fromDate}}. Nous serons de retour en ligne à {{toHour}} le {{toDate}}',
    ORDER_DETAIL: {
      EXTRA_COSTS_INFO: 'Ici, vous pouvez personnaliser les frais de livraison et/ou de personnalisation. S’ils ne sont pas renseignés, les frais correspondants seront appliqués selon les paramètres par défaut. Par exemple, si vous ne souhaitez pas facturer les frais de livraison pour ce panier, saisissez 0 dans le champ correspondant.',
      COURIER_COSTS_INFO: 'Les frais de livraison associés au transporteur {{transportAgencyName}} de €{{transportAgencyCost}} sont actuellement appliqués.',
      CUSTOMIZATION_COSTS: 'Coûts de personnalisation',
      MANAGE_EXTRA_COSTS: 'Gérer les coûts supplémentaires',
      BULK_OPERATIONS_STATUS_SYNCING: 'Cette commande est en cours de mise à jour ({{processingCount}} opérations en file d’attente). Toutes les opérations sont temporairement désactivées jusqu’à la fin de la synchronisation.',
      BULK_OPERATIONS_STATUS_SYNCING_2: 'Cette commande est en cours de mise à jour. Toutes les opérations sont temporairement désactivées jusqu’à la fin de la synchronisation.',
      BULK_OPERATIONS_STATUS_AWATING: 'Cette commande a {{processingCount}} opérations en attente dans la file.',
      HAS_OPERATION_PENDING_MESSAGE: 'Désolé ! Cette commande ne peut plus être modifiée car l’un des travaux en file d’attente a déjà commencé. Revenez modifier la commande lorsque tous les travaux en file d’attente seront terminés et actualisez la page pour voir les détails.',
      STATS: {
        TOTAL_WHOLESALE: 'Total wholesale',
        TOTAL_RETAIL: 'Total retail',
        TOTAL_NET: 'Total net',
        TOTAL_NET_IVA: 'Total net (taxes incluses)',
        VAT_MARKUP: 'RE',
        VAT: 'TVA',
        TOTAL_ORDERED: 'Total commandé',
        TOTAL_DISCOUNT: 'Remise tot. sur wholesale',
        TOTAL_PIECES: 'Pièces',
        TOTAL_MARGIN: 'Marge',
        TOTAL_COST: 'Coût',
        TOTAL_CUSTOMER_DISCOUNT: 'Remise client',
        TOTAL_COMMERCIAL_DISCOUNT: 'Remise commerciale',
        TOTAL_FINANCIAL_DISCOUNT: 'Remise financière',
        TOTAL_STORECHANNEL_DISCOUNT: 'Remise StoreChannel',
        TOTAL_AGREEMENT_DISCOUNT: 'Remise sur l\'acc. comm.',
        TOTAL_AUTO_DISCOUNT: 'Remises automatiques',
        TOTAL_VOUCHER_AMOUNT: 'Valeur du voucher',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Remise da retail',
        DISCOUNT: 'Remise',
        TOTAL_SERVICES: 'Services totaux',
        SHIPPING_COST: 'Coût livraison',
        SHIPPING_COST_COURIER: 'Coût d’expédition du transporteur',
        SHIPPING_COST_SET: 'Coût d’expédition défini',
        SOME_ORDERITEMS_HAS_NO_COST: 'Certains articles de la commande n\'ont pas de coût',
        PENDING_OPERATION: 'Vous ne pouvez pas effectuer d\'opérations sur le panier tant que le chargement des lignes de commande via un fichier Excel est en cours de traitement.',
        CHOOSE_EXCEL_PROPS_TITLE: 'Choisir les propriétés',
        CHOOSE_EXCEL_PROPS: 'Choisissez les colonnes à afficher dans la feuille Excel dédiée aux lignes de commande',
        CHOOSE_DOWNLOAD_TYPE: 'Choisissez le type de téléchargement',
        DOWNLOAD_TYPE_MESSAGE: 'Une fois le processus terminé, vous recevrez un email à votre adresse avec le fichier joint une fois disponible',
        CUSTOM_DATE: 'Date personnalisée',
        EDIT_CUSTOM_DATE: 'Personnaliser la date',
        NO_CUSTOM_DATE: 'Date non personnalisable',
        SELECTED_ITEMS: 'lignes de commande sélectionnées',
        REQUESTED_SALES_PRICE: 'Prix de vente demandé',
        COLUMNS: {
          IMAGE: 'Image',
          NAME: 'Nom',
          SKU: 'SKU',
          COLOR: 'Couleur',
          COLOR_CODE: 'Code couleur',
          COLOR_NAME: 'Nom de la couleur',
          SIZE: 'Taille',
          UNIT_WHOLESALE: 'Unité gros',
          UNIT_NET: 'Unité nette',
          UNIT_COST: 'Coût unitaire',
          UNIT_MARGIN: 'Marge unitaire',
          TOTAL_RETAIL: 'Total détail',
          TOTAL_WHOLESALE: 'Total gros',
          TOTAL_NET: 'Total net',
          TOTAL_COST: 'Coût total',
          TOTAL_MARGIN: 'Marge totale',
          TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Pourcentage de réduction sur le détail',
          TOTAL_DISCOUNT_PERCENTAGE: 'Pourcentage de réduction sur le gros',
          CUSTOMER_DISCOUNT: 'Réduction client',
          AGREEMENT_DISCOUNT: 'Réduction sur accord',
          FINANCIAL_DISCOUNT: 'Réduction financière',
          STORECHANNEL_DISCOUNT: 'Réduction sur inventaire',
          DISCOUNT_BY_QTY: 'Réduction par quantité',
          DISCOUNT_BY_VALUE: 'Réduction par valeur',
          COMMERCIAL_DISCOUNT: 'Réduction commerciale',
          MARGIN_PERCENTAGE: 'Pourcentage de marge',
          QTY: 'Quantité',
          EAN: 'EAN',
          SIZE_GROUP: 'Groupe de tailles',
          PRODUCT_CODE: 'Code produit',
          PRODUCT_TITLE: 'Titre du produit',
          DATE: 'Date',
          ORDERED_QTY: 'Quantité commandée',
          CANCELED_QTY: 'Quantité annulée',
          NOT_FULFILLED_QTY: 'Quantité non exécutée',
          FULFILLED_QTY: 'Quantité exécutée',
          FULFILLMENT_STATUS: 'Statut d\'exécution',
          GROUP_GENERAL: 'Général',
          GROUP_UNITARY: 'Unitaire (€)',
          GROUP_TOTALS: 'Totaux (€)',
          GROUP_PERCENT: 'Pourcentages (%)',
          GROUP_FULFILLMENT: 'Exécution',
          STYLE_GROUP: 'Groupe de styles',
          NOTE: 'Notes',
          DELIVERY_DATE: 'Date de livraison',
          REPLACE_EAN: 'Remplace EAN',
          CANCELLATION_REASON: 'Motif annulation',
        },
      },
      UPLOADS: {
        UPLOADED: 'Téléchargement du fichier terminé! Un email vous informera de la fin de l\'opération.',
        TITLE: 'Uploads',
        MESSAGE1: 'Ici, vous pouvez télécharger des articles dans votre panier via des fichiers Excel (.xlxs, .xls). Dans la colonne Code, pour identifier la variante, vous pouvez saisir soit une liste de codes EAN, soit une liste de codes SKU.',
        MESSAGE1_1: 'La colonne "Prix demandé" est optionnelle et peut être utilisée pour spécifier un prix de vente souhaité afin de calculer la remise commerciale sur la ligne de commande.',
        MESSAGE2: 'Dans la colonne "Code", mon fichier contiendra des codes:',
        MESSAGE3: 'Vous souhaitez télécharger le fichier:',
        OPERATION_ERRORS_DETAILS: 'Détails de l\'erreur d\'opération',
        DEFAULT_ERROR_MESSAGE: 'Une erreur s\'est produite lors du traitement du fichier.',
        COLUMNS: {
          ID: 'Id',
          CREATED_BY: 'Créé par',
          CREATED_ON: 'Créé el',
          STARTED_ON: 'Commencé le',
          CONCLUDED_ON: 'Conclu le',
          STATUS: 'Status',
          FILE_ROW_INDEX: 'Ligne du fichier'
        }
      },
      FULFILLMENT: {
        FULFILLMENTS: 'Évasi',
        TITLE: 'Évasi #{{fulfillmentNumber}}',
        FULFILLMENT_STATUS: 'Statut d\'évasi',
        FULFILLMENT_DATE: 'Date d\'évasi',
        COURIER: 'Transporteur',
        TRACKING_NUMBER: 'Numéro de suivi',
        TRACK_DELIVERY: 'Suivi de la livraison',
        DOWNLOAD_DELIVERY_NOTE: 'Télécharger le bon',
        SHIPPED: 'Expédié',
        DELIVERED: 'Livré',
      },

      ORIGINAL_MODIFIED_INFORMATION: 'Informations modifiées, originales: {{originalValue}}',
      COMMERCIAL_BLOCK_INFO: 'Un bloc commercial est actif sur le client actuel.',
      NO_CART_CONF: 'Ce panier ne peut pas être confirmé.',
      PAYMENT_TERM: 'Conditions de paiement',
      ALREADY_FULFILLED_QUANTITY: 'Articles des commandes d\'usine',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Vous ne pouvez pas confirmer ce panier car le client n\'est pas approuvé',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Vous ne pouvez pas confirmer ce panier car le point de vente n\'est pas approuvé',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_HAS_NOT_ITEMS: 'Vous ne pouvez pas confirmer ce panier car il n\'a pas d\'articles',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Vous ne pouvez pas confirmer ce panier car le total du panier est inférieur à la valeur minimale autorisée dans cette boutique',
      SOME_ORDER_ITEMS_IS_NOT_AVAILABLE_FOR_CURRENT_REQUESTED_QUANTITY: 'Certains articles de la commande ne sont pas disponibles pour la quantité demandée',
      PREORDER_NO_BASELINE: 'Aucune dépense de référence dans la campagne précédente pour les variantes sélectionnées : aucun budget de pré-commande à afficher.',
      PREORDER_ADMITTED: 'Pré-commande dans la limite de dépense ({{percentage}}%) pour les variantes sélectionnées. Dépensé {{used}} sur {{max}} - restant {{remaining}}.',
      PREORDER_NOT_ADMITTED_NO_BASELINE: 'Pré-commande au-delà de la limite de dépense ({{percentage}}%) pour les variantes sélectionnées. (Variantes non achetées dans la campagne précédente : non réapprovisionnables.)',
      PREORDER_NOT_ADMITTED: 'Pré-commande au-delà de la limite de dépense ({{percentage}}%) pour les variantes sélectionnées. Dépensé {{used}} sur {{max}} - dépassement de {{exceeded}}.',
      REORDER_ADMITTED: 'Ce panier est un réapprovisionnement dans la campagne de vente "{{campaignName}}". Réapprovisionnement maximal autorisé : {{maxPrice}} ({{percentage}}%) - Disponible restant : {{remaining}}.',
      REORDER_NOT_ADMITTED: 'Attention ! Ce panier est un réapprovisionnement dans la campagne de vente "{{campaignName}}". Réapprovisionnement maximal autorisé : {{maxPrice}} ({{percentage}}%) - Dépassé de : {{exceeded}}.',
      REORDER_ADMITTED_INTERNAL_USER: 'En tant qu’utilisateur interne, vous pouvez tout de même procéder à la confirmation.',
      REORDER_NOT_ADMITTED_FOR_CUSTOMER_EXTERNAL_USER: 'Attention ! Vous ne pouvez pas confirmer ce panier. Contactez le service client à l\'adresse email "{{shopEmail}}" afin de résoudre le problème.',
      GOK_NOT_ADMITTED: 'Attention ! Ce panier a dépassé la limite maximale de {{totalAmount}}. Montant restant disponible : {{residualAmount}} - Dépassé de : {{exceeded}}.',
      SUMMARY: 'Résumé',
      ORDER_ITEMS: 'Détails articles',
      ORDER_TYPE: 'Type de order',
      REORDER_TYPE: 'Type de re-order',
      ORDER_STATUS: 'Statut de la commande',
      CHANNEL_NAME: 'Nom du canal',
      CHANNEL: 'Canal',
      CUSTOMER: 'Client',
      CUSTOMER_LOCATION: 'Adresse de facturation',
      POINT_OF_SALE: 'Point de vente',
      AGENT: 'Agent',
      AGENCY: 'Agence',
      USER: 'Utilisateur',
      USER_EMAIL: 'Email utilisateur',
      SHIPPING_ADDRESS: 'Adresses d\'expédition',
      CREATED_ON: 'Créé le',
      CONFIRMED_ON: 'Confirmé le',
      DELIVERY_DATE: 'Date de livraison',
      EXTERNAL_ID: 'ID externe',
      REASON: 'Causal',
      ORDER_REASON: 'Motif de commande',
      MANUAL_DISCOUNT: 'Remise manuelle',
      CUSTOMIZATION_REQUEST: 'Demande de personnalisation',
      NAME: 'Nom',
      AMOUNT: 'Montant',
      NOTE: 'Note',
      SELECT_ACTION_TYPE: 'Sélectionnez le type d\'action',
      BACK_TO_ORDERS: 'Retour aux commandes',
      BACK_TO_CARTS: 'Retour aux paniers',
      SAVED_NOTE: 'Remarque enregistrée',
      ESTIMATED_DELIVERY_DATE: 'Date livraison estimée',
      DELETE_ORDER: 'Supprimer la commande',
      CANCEL_ORDER: 'Annuler la commande',
      RESEND_ORDER_CONFIRMATION: 'Renvoyer confirmation commande',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ORDERS: 'Êtes-vous sûr de vouloir supprimer les commandes sélectionnées?',
      ADD_ITEMS: 'Ajouter articles',
      EDIT_ITEMS: 'Modifier articles',
      EDIT_SELECTED: 'Modifier articles sélectionnés',
      DELETE_NOT_FULFILED_ITEMS: 'Supprimer les articles non evasés',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ITEMS: 'Êtes-vous sûr de vouloir supprimer les articles sélectionnés?',
      CLOSE_SELECT_MODE: 'Fermer mode de sélection',
      SUCCESS_RESEND_ORDER_CONFIRMATION: 'Renvoi de la confirmation de commande réussi',
      INVOICING_NUMBER_FULL_NAME: 'Numéro de compte facture',
      CENTRAL_PAYMENT_NUMBER_FULL_NAME: 'Numéro de paiement centralisé',
      DISCOUNT: {
        DISCOUNT_AMOUNT: 'Remise additionnel',
        DESCRIPTION_COMMERCIAL_DISCOUNT: 'Cette remise sera appliquée sur les articles sélectionnés',
        DESCRIPTION_FINANCIAL_DISCOUNT: 'Cette remise sera appliquée à chaque article du panier'
      },
      MODAL: {
        ARE_YOU_SURE: 'Êtes-vous sûr ?',
        CONFIRM: 'Confirmer',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Êtes-vous sûr de vouloir supprimer ?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CART: 'Êtes-vous sûr de vouloir supprimer ce panier?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DISCOUNT: 'Êtes-vous sûr de vouloir supprimer remise?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VARIANT: 'Êtes-vous sûr de vouloir supprimer cette variante ?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SELECTED_VARIANTS: 'Êtes-vous sûr de vouloir supprimer ces variantes sélectionnées ?',
        SET_MAXIMUM_QUANTITY_FOR_THIS_SELECTED_VARIANTS: 'Attention! En confirmant, la quantité maximale relative disponible sera définie pour chaque variante sélectionnée.',

      },
      MODAL_EDIT_ORDERITEM: {
        EDIT_ORDER_ITEM: 'Modifier l\'article',
        ORDER_QTY: 'Qté commandée',
        MAXIMUM_QUANTITY_AVAILABLE_FOR_THIS_VARIANT_ON_DATE: 'Quantité maximale disponible pour cette variante à cette date',
        IS: 'est:',
        YOU_ARE_BUYING_THIS_VARIANT_WHIT_BLANCK_CELL_OPTION: 'Vous achetez cette variante avec l\'option de cellule vide',
        MAX_AMOUNT_EXCEEDED: 'Quantité maximale dépassée',
        MINIMUM_ONE_PIECE: 'Minimum 1 pièce',
        THE_QUANTITY_OF_THE_VARIANT_MUST_BE_A_MULTIPLE_OF: 'La quantité de la variante doit être un multiple de:',
        THE_QUANTITY_ENTERED_IS_LESS_THAN_THE_MINIMUM_ALLOWED: 'La quantité saisie est inférieure au minimum autorisé',
        THE_MINIMUM_ORDER_QUANTITY_OF_THE_VARIANT_IS: 'La quantité minimale de commande de la variante est:',
        LOSE_CUSTOM_DELIVERY_DATES: 'En modifiant les quantités de cet article de commande, vous perdrez les dates personnalisées que vous avez définies! Pensez à le réinitialiser lors de la validation de votre commande!',
      },
      MODAL_ORDER_NAME_CHANGE: {
        CHANGE_ORDER_NAME: 'Changer le nom de la commande',
      },
      MODAL_HANDLE_DATE: {
        HANDLE_DATE_BUTTON: 'Gérer les dates',
        HANDLE_DATE: 'Gérer la date de demande de livraison originale sur les lignes de commande',
        OVERWRITE_ORIGINAL_DATE: 'Utilisez cette date pour écraser la date de demande de livraison originale sur les articles de commande sélectionnés. Ainsi, des contrôles des quantités disponibles pour les articles concernés seront effectués à cette nouvelle date. Attention! En modifiant cette date, toutes les dates de livraison personnalisées seront perdues!'
      },
      MODAL_SHIPPING_VARIANTS_DATE_: {
        LIST_VARIANTS_FROR_DELIVERY_DATE: 'Liste des variantes pour la date de livraison',
      },
      BUTTONS: {
        EDIT: 'Modifier les infos de la commande',
        ADD_DISCOUNT_FINANCIAL: 'Ajouter remise financier',
        ADD_DISCOUNT_COMMERCIAL: 'Ajouter remise commercial',
        REMOVE_DISCOUNT_FINANCIAL: 'Supprimer la remise financier',
        REMOVE_DISCOUNT_COMMERCIAL: 'Supprimer la remise commercial',
        DISCOUNT_OPTIONS: 'Options remise',
        CONFIRM_ORDER: 'Confirmer la commande',
        CONTINUE: 'Continuer vos achats',
        DUPLICATE_CART: 'Dupliquer le panier',
        SAVE_NOTE: 'Enregistrer la note',
        RENAME_ORDER: 'Renommer la commande',
        REMOVE_CUSTOM_DATE: 'Supprimer la date personnalisée',
        SKIP_AUTOMATIC_DISCOUNT: 'Ignorer les remises automatiques',
        SKIP_CUSTOMER_DISCOUNT: 'Ignorer la remise client',
        ACTIVATE_AUTOMATIC_DISCOUNT: 'Activer les remises automatiques',
        ACTIVATE_CUSTOMER_DISCOUNT: 'Activer la remise client',
        ACTIVATE_STORECHANNEL_DISCOUNT: 'Activer les remises store-channel',
        SKIP_STORECHANNEL_DISCOUNT: 'Ignorer les remises store-channel',
        OPTIONS_ITEMS: 'Options des articles',
        REMOVE_ITEMS: 'Supprimer les articles',
        SET_MAXIMUM_QUANTITY: 'Définir la quantité maximale',
        COMMERCIAL_AGREEMENT: 'Accord commercial',
        HANDLE_NOTE_BUTTON: 'Gérer la note',
        EDIT_ORDER_HEADER: 'Modifier l\'entête de commande',
        CONFIRM_CART: 'En activant cette option, tous les paniers importés depuis le fichier seront automatiquement confirmés et transformés en commandes.',
        OPTIONS: 'Options',
      },
      MODAL_CONFIRMATION_MAIL: {
        TITLE: 'Envoyer un e-mail de confirmation',
        SEND: 'Envoyer',
        ACTIVATE_MAIL: 'Saisir des destinataires personnalisés',
        TO: 'À',
        CC: 'CC',
        CCN: 'CCN',
        TOOLTIP_MSG: 'Si vous n\'entrez pas de destinataires personnalisés, l\'e-mail de confirmation sera envoyé aux adresses par défaut',
        ADD: 'Ajouter',
        SNACKBAR_MESSAGE: 'La valeur d\'entrée n\'est pas un e-mail valide'
      },
      MODAL_ACTIVATE_AUTOMATIC_DISCOUNT: {
        TITLE: 'Activer les remises automatiques',
        DESCRIPTION: 'Êtes-vous sûr? Continuer activera toutes les remises automatiques pour le panier actuel.'
      },
      MODAL_ACTIVATE_CUSTOMER_DISCOUNT: {
        TITLE: 'Activez la remise client.',
        DESCRIPTION: 'Es-tu sûr? Continuer activera toute remise client pour le panier actuel.'
      },
      MODAL_SKIP_AUTOMATIC_DISCOUNT: {
        TITLE: 'Ignorer les remises automatiques',
        DESCRIPTION: 'Êtes-vous sûr? Si vous continuez, les remises automatiques pour le panier actuel seront ignorées.'
      },
      MODAL_SKIP_CUSTOMER_DISCOUNT: {
        TITLE: 'Ignorez la réduction client',
        DESCRIPTION: 'Es-tu sûr? En continuant, toute remise client pour le panier actuel sera ignorée.'
      },
      MODAL_ACTIVATE_STORECHANNEL_DISCOUNT: {
        TITLE: 'Activer les remises automatiques',
        DESCRIPTION: 'Êtes-vous sûr? Continuer activera toutes les remises automatiques pour le panier actuel.'
      },
      MODAL_SKIP_STORECHANNEL_DISCOUNT: {
        TITLE: 'Ignorer les remises store-channel',
        DESCRIPTION: 'Êtes-vous sûr? Si vous continuez, les remises store-channel pour le panier actuel seront ignorées.'
      },
      SHOW_ONLY_UNAVAILABLE: 'Afficher uniquement les articles dont la quantité disponible est inférieure à celle demandée',
      ADD_MANUAL_DISCOUNT_MANUAL: 'Entrer % de remise supplémentaire',
      ADD_MANUAL_DISCOUNT_CALCULATED: 'Calculer à partir du % de remise souhaité par le retail',
      ADD_MANUAL_DISCOUNT_CALCULATED2: 'Calculer à partir du prix de wholesale unitaire souhaité',
      ADD_MANUAL_DISCOUNT_CALCULATED3: 'Calculer à partir du % du le marge souhaité',
      INSERT_PERCENTAGE: 'Entrer un pourcentage',
      INSERT_DESIRED_WHOLESALE: 'Entrer wholesale souhaité',
      HIDE_CANCELLED: 'Hide cancelled order items',
      COMMERCIAL_DISCOUNT_APPLIED: 'Remise commerciale appliquée sur {{orderItemsCount}} {{itemsTranslation}} commandé',
      COMMERCIAL_DISCOUNT_INSUFFICIENT: 'La remise saisie doit être supérieure à la remise par défaut du retail pour les articles sélectionnés. Pour appliquer une remise inférieure à celle actuelle, supprimez d\'abord la remise existante puis appliquez la nouvelle.',
      ITEM: 'article',
      ITEMS: 'articles',
      SOME_ORDERITEMS_HAS_NO_COST: 'Certains articles du panier n\'ont pas de coût spécifié, donc cette fonctionnalité n\'est pas disponible',
      PENDING_OPERATION: 'Vous ne pouvez pas effectuer d\'opérations sur le panier car des téléchargements de lignes de commande via fichier Excel sont en cours de traitement.',
      PENDING_BULK_OPERATIONS: 'Cette commande a {{count}} opérations en attente.',
      CHOOSE_EXCEL_PROPS_TITLE: 'Choisir des propriétés',
      CHOOSE_EXCEL_PROPS: 'Choisissez les colonnes à afficher dans la feuille Excel dédiée aux articles de commande',
      CUSTOM_DATE: 'Date personnalisée',
      EDIT_CUSTOM_DATE: 'Personnaliser la date',
      NO_CUSTOM_DATE: 'Date non personnalisable',
      SELECTED_ITEMS: 'lignes de commande sélectionnées',
      ALERT_CART_SHIPPING_COST: 'À ce panier, des frais de livraison de <strong>{{shippingCost}}</strong>(TVA exclue) seront appliqués; pour les obtenir gratuitement, vous devez encore ajouter <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_NO_COST: 'À ce panier, des frais de livraison seront appliqués. Pour les obtenir gratuitement, vous devez encore ajouter <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_WITH_VOUCHER: 'Si vous utilisez un bon, vous ne serez pas facturé.',
      COLUMNS: {
        IMAGE: 'Image',
        NAME: 'Colonnes',
        SKU: 'Sku',
        COLOR: 'Couleur',
        COLOR_CODE: 'Code couleur',
        COLOR_NAME: 'Nom couleur',
        SIZE: 'Taille',
        UNIT_WHOLESALE: 'Wholesale unit.',
        UNIT_RETAIL: 'Retail unit.',
        GENDER: 'Genre',
        UNIT_NET: 'Net unit.',
        UNIT_COST: 'Coût unit.',
        UNIT_MARGIN: 'Marge unit.',
        TOTAL_RETAIL: 'Retail tot.',
        TOTAL_WHOLESALE: 'Wholesale tot.',
        TOTAL_NET: 'Net tot.',
        TOTAL_COST: 'Coût tot.',
        TOTAL_MARGIN: 'Marge tot.',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Rem. de retail',
        TOTAL_DISCOUNT_PERCENTAGE: 'Rem. de wholesale',
        CUSTOMER_DISCOUNT: 'Rem. client',
        AGREEMENT_DISCOUNT: 'Rem. accords comm.',
        FINANCIAL_DISCOUNT: 'Rem. financier',
        STORECHANNEL_DISCOUNT: 'Rem. store-channel',
        DISCOUNT_BY_QTY: 'Rem. by qty',
        DISCOUNT_BY_VALUE: 'Rem. by value',
        COMMERCIAL_DISCOUNT: 'Rem. commercial',
        MARGIN_PERCENTAGE: 'Margin',
        QTY: 'Qty',
        EAN: 'EAN',
        SIZE_GROUP: 'Groupe taille',
        PRODUCT_CODE: 'Code produit',
        PRODUCT_TITLE: 'Nom produit',
        DATE: 'Date',
        ORDERED_QTY: 'Qty commandée',
        CANCELED_QTY: 'Qty annulée',
        NOT_FULFILLED_QTY: 'Qty non évasée',
        FULFILLED_QTY: 'Qty évasée',
        FULFILLMENT_STATUS: 'Statut de la commande',
        GROUP_GENERAL: 'Généraux',
        GROUP_UNITARY: 'Unitaire (€)',
        GROUP_TOTALS: 'Totaux (€)',
        GROUP_PERCENT: 'Pourcentages (%)',
        GROUP_FULFILLMENT: 'Accomplissement',
        STYLE_GROUP: 'Style group',
        NOTE: 'Notes',
        VARIANT_CODE: 'Código de variante',
        CUSTOMIZATION_REQUEST: 'Demande de personnalisation',
      },
    },
    REGISTRATION: {
      WELCOME: 'Bienvenue à',
      REGISTER_NEW: 'Enregistrez un nouveau',
      BACK_TO_HOME: 'Arrière',
      LOGOUT: 'Logout',
      CUSTOMER: 'Client',
      CUSTOMER_INFO: 'Informations client',
      AGENCY: 'Agence',
      AGENCY_INFO: 'Informations sur l\'agence',
      INFO_SETUP: 'Ajouter des informations générales',
      STEPPER: {
        REQUIRED_INFOTO_CREATE: 'Pour créer un nouveau client sans l’envoyer à l’ERP, les informations nécessaires sont: ',
        REQUIRED_INFOTO_CREATE2: 'Numéro de compte (Onglet : Infos client), Nom de l’entreprise (Onglet : Infos client), Connu comme (Onglet : Infos client), Adresse de facturation (Onglet : Infos client), Email administratif (Onglet : Infos client), au moins un point de vente (Onglet : Adresses de livraison).',
        REQUIRED_INFOTO_CREATE3: 'N’oubliez pas! Vous pouvez créer le point de vente directement à partir des données de facturation et il ne sera pas dupliqué dans l’ERP. Depuis l’étape Adresses de livraison, vous pourrez ensuite enregistrer les données.',
        ADD_NEW: 'Ajouter nouveau',

        CONTACT_INFO: 'Informations de contact',
        ADD_CONTACT_INFO: 'Ajouter des coordonnées',

        PAYMENT_INFO: 'Information de paiement',
        ADD_PAYMENT_INFO: 'Ajouter des informations de paiement',

        POINT_OF_SALE: 'Points de vente',
        NEW_POINT_OF_SALE: 'Nouveau point de vente',
        ADD_POINT_OF_SALE: 'Ajouter un point de vente',
        ENABLED_ONLINE_STORE: 'Boutique en ligne activée',
        USE_BILLING: 'Utiliser l\'adresse de facturation',
        FINANCIAL_STATUS: 'Statut financier',
        COMPANY_FINANCIAL_STATUS: 'Situation financière de l\'entreprise',

        FINISH_REGISTRATION: 'Terminer l\'inscription',
        FINISH_REGISTRATION_TEXT: 'Une fois la demande d\'inscription envoyée, elle sera prise en charge.',
        SEND_REGISTRATION_REQUEST: 'Envoyer la demande d\'inscription',

        NEXT_STEP: 'Étape suivante',
        PREV_STEP: 'Étape précédente',
        SEND_REQUEST: 'Envoyer une demande',
        OWNER: 'Propriétaire',
        OWNER_SUB: 'Propriétaire d\'entreprise',
        SEND_USER_INVITATION: 'Envoyer e-mail d\'invitation au propriétaire',
        POS_WITHOUT_STORE: 'Vous devez activer chaque boutique pour au moins une boutique en ligne et le canal correspondant',
        FORWARDED_REQUEST: 'Votre demande a été transmise au service client',
        USER: {
          EXISTING: 'Choisissez un utilisateur existant',
          NEW: 'Créer un nouvel utilisateur',
          SELECT_USER: 'Sélectionner l\'utilisateur',
          EXISTING_EMAIL: 'L\'email existe déjà'
        }
      }
    },
    PRODUCT_DETAIL: {
      IMAGES_VISIBILITY_ACTION: 'Masquer les images de ce produit',
      IMAGES_VISIBILITY_INFO: 'En activant cette option, les images des variantes du produit ne seront affichées au client dans aucune section de l’application (comme la liste des produits, la page de détails ou les écrans de confirmation de commande). Ce paramètre a la priorité sur la visibilité configurée pour les images individuelles de variantes, que vous pouvez gérer dans le détail de chaque variante.',
      IMAGES_VISIBILITY: 'Visibilité des images',
      BACK_TO_PRODUCTS_LIST: 'Retour à la liste des produits',
      STYLE_CARD: 'Carte de style',
      NAME: 'Nom',
      CODE: 'Code',
      GENDER: 'Genre',
      DESCRIPTION: 'Description',
      PRODUCT_DESCRIPTION: 'Description du produit',
      OPEN_IN_BULK: 'Ouvrir dans l\'éditeur de variantes',
      COLOR: 'couleur',
      COLORS: 'couleurs',
      SETTINGS_PRODUCT: 'Paramètres d\'achat',
      SETTING_BASICKUSTOM: 'Paramètres BasicKustom',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE: 'Pour rendre ce produit personnalisable, sélectionnez une palette de référence',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE_WITH_PLAYERS: 'Activez ce paramètre si vous souhaitez permettre à l\'utilisateur d\'ajouter des informations relatives aux joueurs à ce produit',
      BUY_MULTIPLIER: 'Multiplicateur d\'achat pour les canaux: {{channels}}',
      BUY_MINIMUM_PER_ORDER: 'Quantité minimum d\'achat (pour les canaux de vente qui l\'exigent)',
      ADD_ORDER_ITEMS: 'Ajouter des articles à la commande',
      ORDER_ITEM_WITHOUT_WHOLESALE_PRICE: 'Attention ! Certaines variantes sélectionnées n’ont pas de prix de gros défini et ne pourront pas être ajoutées.',
      VARIANTS: {
        NAME: 'Variantes',
        COLUMNS: {
          VARIANT: 'Variante',
          QTY: 'Quantité',
          NEW_QTY: 'Nouvelle quantité',
          SKU: 'Sku',
          WHOLE_SALE: 'Wholesale',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },
      IMPORT_STATUS: {
        NAME: 'Statut d\'importation',
        START: 'Démarrer',
        END: 'Finir',
        ERROR: 'L\'erreur suivante s\'est produite: ',
        RESTART_IMPORT: 'Redémarrer l\'importation',
        MODAL_TEXT: 'Attention! Toutes les modifications relatives à ce produit et ses variantes seront perdues. Es-tu sûr?',
        RETAIL_DISCOUNT_PERCENTAGE: '% de remise par rapport à retail',
        LAST_RETAIL_DISCOUNT_PERCENTAGE: 'Dernière remise de base utilisée'
      },
      MODAL_DELETE: {
        ARE_YOU_SURE: 'Êtes-vous sûr?',
        ARE_YOU_SURE_TO_REMOVE_STOCK_LIMIT: 'Êtes-vous sûr de vouloir supprimer la limite de stock?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_PRE_ORDER: 'Êtes-vous sûr de vouloir supprimer le minimum pre-order?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_RE_ORDER: 'Êtes-vous sûr de vouloir supprimer le minimum re-order?',
        ARE_YOU_SURE_TO_REMOVE_ALL_LIMITS: 'Êtes-vous sûr de vouloir supprimer toutes les limites?',
        FOR: 'pour',
        STYLE_COLOR: 'style-couleur',
        STYLE_COLORS: 'style-couleurs',
      },

      SETTING_LIMIT: 'Définition de contraintes',
      SETTING_STOCK_LIMIT: 'Paramètres de limite de stock',
      SETTING_MINIMUM_PRE_ORDER: 'Paramètres de minimum pre-order',
      SETTING_MINIMUM_RE_ORDER: 'Paramètres de minimum re-order',
      ADD_OR_EDIT_STOCK_LIMIT: 'Ajouter/modifier la limite de stock',
      ADD_OR_EDIT_MINIMUM_PRE_ORDER: 'Ajouter/modifier le minimum pre-order',
      ADD_OR_EDIT_MINIMUM_RE_ORDER: 'Ajouter/modifier le minimum re-order',
      REMOVE_STOCK_LIMIT: 'Supprimer la limite de stock',
      REMOVE_MINIMUM_PRE_ORDER: 'Supprimer le minimum pre-order',
      REMOVE_MINIMUM_RE_ORDER: 'Supprimer le minimum re-order',
      REMOVE_ALL_LIMITS: 'Supprimer toutes les limites',
      MODAL_LIMIT: {
        STOCK_LIMIT: 'Limite de stock',
        MINIMUM_QTY_PRE_ORDER: 'Minimum pre-order',
        MINIMUM_QTY_RE_ORDER: 'Minimum re-order',
        SETTING_STOCK_LIMIT: 'Paramètres de limite de stock ',
        SETTING_MINIMUM_PRE_ORDER: 'Paramètres de minimum pre-order ',
        SETTING_MINIMUM_RE_ORDER: 'Paramètres de minimum re-order ',
        LIMIT_ENABLED_FOR_CHANNELS: 'Limite activée pour les canaux: {{channels}}',
        THE_QUANTITY_INSERTED_IS_NOT_VALID_MINIMUM_VALUE_IS_TWO: 'La quantité insérée n\'est pas valide. La valeur minimale est de 2',
      },
    },
    PRODUCT_AND_VARIANT: {
      REORDER: 'Ranger',
    },
    TAG_MANAGER: {
      NAME: 'Gestionnaire de tags',
    },
    MEDIA_CONTAINER: {
      START_SYNC: 'Commencez l\'alignement images',
      NAME: 'Médias',
      VISIBLE_IMAGE: 'Image visible',
      SET_AS_COVER: 'Définir comme couverture',
      NO_MEDIA_TO_VIEW: 'Aucun média à afficher',
      UPLOAD_MEDIA: 'Télécharger un média',
      SHOW_ALL_MEDIA: 'Afficher tous les médias',
      HIDE_ALL_MEDIA: 'Masquer tous les médias',
    },
    BULK_MEDIA_EDIT: {
      SHOW: 'Afficher',
      HIDE: 'Masquer',
      INFO: 'Afficher ou masquer tous les médias (produit et variantes)',
      NO_PRODUCT_SELECTED: 'Aucun produit sélectionné',
      MESSAGE_SUCCESS_VISIBILE_1: 'Toutes les images des produits sélectionnés ont été rendues visibles',
      MESSAGE_SUCCESS_VISIBILE_2: 'Toutes les images du produit et des variantes ont été rendues visibles',
      MESSAGE_SUCCESS_HIDE_1: 'Toutes les images des produits sélectionnés ont été rendues invisibles',
      MESSAGE_SUCCESS_HIDE_2: 'Toutes les images du produit et des variantes ont été rendues invisibles',
    },
    VARIANT_DETAIL: {
      BACK_TO_PRODUCT_DETAIL: 'Retour à la fiche produit',
      VARIANT: 'Variante',
      SELECT_VARIANT: 'Sélectionner une variante',
      COLOR: 'Couleur',
      SIZE: 'Taille',
      SKU_CODE: 'Code SKU',
      EAN_CODE: 'Code EAN',
      AVAILABLE_QTY: 'Quantité en stock',
      COST: 'Coûte',
      BLANK_CELLS_SETTINGS: 'Paramètres des blank cells',
      BLANK_CELLS_END_DATE: 'Date de fin de blank cells',
      BLANK_CELLS_DELIVERY_DATE: 'Date de livraison des blank cells',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Sélectionnez les tier pour lesquels le produit est disponible:',
      EXTERNAL_COLLECTIONS_ID: 'ID de collection externe',
      FROM: 'De',
      TO: 'À',
      DETAIL: 'Détail',
      LABELS: 'Étiquettes',
      PURPOSES: 'Utilisations',
      TEAMS: 'Équipes',
      CATEGORIES: 'Catégories',
      PRICING: 'Prix',
      PRE_ORDER: 'Pré-commande',
      RE_ORDER: 'Ré-commande',
      WHOLE_SALE_PRICE_NO_VAT: 'Prix wholesale (hors TVA)',
      SUGGESTED_RETAIL_PRICE_VAT: 'Prix retail suggéré (avec TVA)',
      PERCENTAGE_DISCOUNT_OF_RETAIL: '% de remise par rapport à retail',
    },
    VISIBILITY: {
      NAME: 'Visibilité',
      PUBLISH_ON_PRE_ORDER: 'Publier sur la pre-order',
      PUBLISH_ON_RE_ORDER: 'Publier sur la re-order',
      BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Bloquer la publication automatiquement sur la re-order',
      AUTOMATIC_PUBLISH_DESCRIBE: 'Si désactivé, lorsque la variante a une quantité de re-order disponible, elle sera publiée automatiquement'
    },
    ASSORTMENT_DETAIL: {
      NAME: 'Assortiment',
      BACK_TO_ASSORTMENTS: 'Retour aux assortiments',
      ASSORTMENT_CARD: 'Carte d\'assortiment',
      ASSORTMENT_NAME: 'Nom',
      ID: 'ID',
      EDIT_ORDER: 'Modifier l\'ordre',
      DESCRIPTION: 'Description (facultatif)',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Sélectionnez les tier pour lesquels le assortiment est disponible:',
      CHANNEL: 'Canal',
      SELECT_THE_CHANNEL_FIRST: 'Sélectionnez le canal d\'abord',
      CHANNEL_DESCRIPTION: 'Sélectionnez les canaux pour lesquels le assortiment est disponible:',
      INCLUDE_PRODUCTS: {
        NAME: 'Inclure les produits',
        MANUAL: 'Manuel (statique)',
        AUTOMATED: 'Automatique (dynamique)',
        PROPERTY: {
          CODE: 'Code',
          SIZE: 'Taille',
          COLOR: 'Couleur',
          TIER: 'Tier',
          PRICE: 'Prix',
          BRAND: 'Marque',
          GENDER: 'Genre',
          SEASON: 'Saison',
          TAG: 'Tag',
          CATEGORY: 'Catégorie',
          LABEL: 'Label',
          EXTERNAL_COLLECTION_ID: 'ID de collecte externe',
          PRODUCT_CODE: 'Code produit',
        },
        OPERATOR: {
          EQUALS: 'Égale',
          NOT_EQUALS: 'Différent de',
          GREATER_THAN: 'Plus grand que',
          LESS_THAN: 'Plus petit que',
          GREATER_OR_EQUAL: 'Plus grand ou égal',
          LESS_OR_EQUAL: 'Plus petit ou égal',
          CONTAINS: 'Contient',
          NOT_CONTAINS: 'Ne contient pas',
          STARTS_WITH: 'Commence par',
          ENDS_WITH: 'Finit par',
        },
        GENDER: {
          MAN: 'Homme',
          WOMAN: 'Femme',
          UNISEX: 'Unisex'
        }
      },
      ASSORTMENT_PRODUCTS: 'Produits de l\'assortiment',
      ASSORTMENT_INFO_1: 'L\'ordre de cette liste affecte la façon dont les produits sont affichés dans la liste de produits 4Shop.',
      ASSORTMENT_INFO_2: 'Pour modifier la commande de produits, vous devez d\'abord enregistrer les modifications concernant les variantes d\'assortiment, y compris ou les règles automatiques d\'assortiment.',
      UNDO_PRODUCTS_ORDER: 'Annuler l\'ordre des produits',
      SAVE_PRODUCTS_ORDER: 'Enregistrer l\'ordre des produits',
      FEATURED: 'Mis en évidence',
      ORDER: 'Ordre',
      MANAGE_ORDER_TITLE: 'Gérer l\'Ordre des Assortiments ',
      MANAGE_ORDER_DESCRIPTION: 'Glissez-déposez les assortiments pour les réorganiser ou modifiez les valeurs en vue liste.',
      LIST_VIEW: 'Liste',
      DRAG_VIEW: 'Glisser-déposer',
      SAVE_ORDER: 'Enregistrer l\'Ordre',
      SELECT_CHANNEL_TO_MANAGE: 'Sélectionnez un canal pour gérer l\'ordre des assortiments',
      MANAGE_ORDER_SAVE_SUCCESS: 'Ordre des assortiments enregistré avec succès',
      SELECT_CHANNEL_FIRST: 'Veuillez d\'abord sélectionner un filtre de canal',
      SELECTED: 'sélectionnés',
      REORDER: 'Réorganiser',
      REORDER_TITLE: 'Réorganiser les Assortiments',
      DUPLICATE_ORDER_WARNING: 'Deux assortiments ou plus ont la même valeur d\'ordre. Corrigez avant d\'enregistrer.',
      SEARCH_ASSORTMENT: 'Rechercher un assortiment...',
      MANAGE_MODAL_SELECT_DESCRIPTION: 'Sélectionnez les assortiments que vous souhaitez réorganiser pour ce canal',
      CLEAR_ALL_ORDERS: 'Supprimer tous les ordres',
    },
    AUTOMATED_INCLUDES: {
      ALL_CONDITION: 'Toutes les conditions',
      ANY_CONDITION: 'N\'importe quelle condition',
      PROPERTY: 'Propriété',
      OPERATOR: 'Opérateur',
      VALUE: 'Valeur',
    },
    BULK_EDITOR_DETAIL: {
      CHOOSE_PROPS: 'Choisissez les propriétés à modifier',
      BACK_TO_SELECT_VARIANTS: 'Retour à la sélection des variantes',
      EDIT_INFO: 'Vous pouvez modifier plusieurs variantes en même temps en les sélectionnant. Maintenez la touche Maj enfoncée pour sélectionner plus rapidement des groupes de variantes.',
      COLUMNS: {
        COLOR: 'Couleur',
        SIZE: 'Taille',
        SKU: 'SKU',
        RE_ORDER: 'Re-order',
        PRE_ORDER: 'Pre-order',
        AUTO_RE_ORDER: 'Bloquer re-order automatique',
        BLANK_CELLS_END: 'Date de fin de cellules vides',
        BLANK_CELLS_DELIVERY: 'Date de livraison des cellules vides',
        TAGS: 'Tags',
        TIERS: 'Tiers',
        PRICES: 'Prix',
      },
      RECAP_MODAL: {
        TITLE: 'Confirmer les modifications',
        MESSAGE: 'Vous êtes sur le point de mettre à jour {{count}} variantes. Vérifiez les modifications ci-dessous avant d\'enregistrer.',
        NO_CHANGES: 'Aucune modification détectée.',
        VARIANTS: 'variantes',
        CHANGE: 'Modification',
      },
    },
    SUPER_BULK_EDITOR_DETAIL: {
      CREATE_OPERATION: 'Créer une opération',
      MANUAL_CODE: 'Manuel',
      AUTO_CODE_BY_ASSORTMENT: 'Par assortiment',
      LIST_OPERATION: 'Liste des opérations',
      SELECT_THE_TYPE_OF_CODE: 'Sélectionnez le type de code',
      SELECT_TYPE_OF_CODE_DESC: 'Dans cette section, sélectionnez le type de codes que vous saisirez pour obtenir la liste des variantes sur lesquelles effectuer les opérations.',
      BEFORE_SELECT_THE_TYPE_OF_CODE: 'Sélectionnez d\'abord le type de code',
      INSERT_CODES: 'Insérer les codes à générer',
      INSERT_CODES_DESC: 'Dans cette section, saisissez une liste de codes basés sur le type précédemment sélectionné, en les séparant par un ";" ou par retour chariot pour chaque code.',
      REPORT_VALIDATION: 'Rapport de validation',
      BEFORE_INSERT_CODES_AND_VALIDATED: 'Insérez d\'abord les codes et validez',
      TOTAL_VARIANTS_INVOLVED: 'Total des variantes impliquées',
      CREATE_OPERATION_DESC: 'Dans cette section, choisissez l\'opération qui sera effectuée sur la liste des variantes concernées.',
      SELECT_OPERATION: 'Sélectionnez l\'opération à effectuer',

      CODE_TYPE: {
        BASIC_COLLECTION: 'Collection',
        PRODUCT_CODE: 'Produit',
        PRODUCT_TEAM: 'Produit team',
        PRODUCT_COLOR: 'Produit couleur',
        SKU_CODE: 'SKU',
      },

      CODE_TYPE_TOOLTIP: {
        BASIC_COLLECTION: 'Id collection basic, Ex. 12345',
        PRODUCT_CODE: 'Code produit, 7 premiers caractères du code SKU, Ex. 35124DW',
        PRODUCT_TEAM: 'Code produit de l\'équipe, 10 premiers caractères du code SKU, Ex. 35124DWACF ou 35124DW***',
        PRODUCT_COLOR: 'Code produit couleur, 13 premiers caractères du code SKU, Ex. 35124DW***A00 ou 35124DW A00',
        SKU_CODE: 'Code 19, Ex. 35124DW***A00L***** ou 35124DW A00L',
      },

      REPORT_VALIDATION_MODAL: {
        TITLE: 'Rapport de validation',
        VALIDATING: 'Validation en cours...',
        ALERT_MESSAGE: 'Certains codes saisis ne sont pas corrects ({{numberOfCodesInvalid}}), pour continuer, supprimez-les ou corrigez-les'
      },

      COLUMNS: {
        CODE: 'Code',
        VARIANTS_NUMBER: 'Nombre de variantes',
        STATUS: 'Statut',
        INSERTED: 'Inséré',
        INTERPRETED: 'Interprété',
      },
      BUTTONS: {
        EDIT_CODES: 'Modifier les codes',
        UNDO_EDITS: 'Annuler les modifications',
        ADD_ROW: 'Ajouter une ligne',
        VALIDATE: 'Valider',
      },

      ALERT: {
        NO_VARIANTS_FOUND_PLEASE_CHECK_THE_CODES: 'Aucune variante trouvée, veuillez vérifier les codes',
        OPERATION_CREATED_SUCCESSFULLY: 'Opération #{{opérationId}} créée avec succès',
      },

      OPERATION_LABELS: {
        VISIBLE_IN_RE_ORDER: 'Visible en re-order',
        VISIBLE_IN_PRE_ORDER: 'Visible en pre-order',
        BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Bloquer la publication automatique sur la re-order',
        BLANK_CELLS_END_DATE: 'Date de fin de cellules vides',
        BLANK_CELLS_DELIVERY_DATE: 'Date de livraison des cellules vides',
        INCLUDE_IN_TIER: 'Inclure dans le tier',
        EXCLUDE_FROM_TIER: 'Exclure du tier',
        INCLUDE_IN_ASSORTMENT: 'Inclure dans l’assortiment',
        EXCLUDE_FROM_ASSORTMENT: 'Exclure de l’assortiment',
        INCLUDE_IN_PROMOTION: 'Inclure dans la promotion',
        EXCLUDE_FROM_PROMOTION: 'Exclure de la promotion',
        PALETTES_STOCK_LIMITS: 'Limite de stock définie: ',
      },

      DETAIL_OPERATION_MODAL: {
        TITLE: 'Détail de la tâche #{{operationId}}',
        MESSAGE: 'L\'<strong>opération #{{operationId}}</strong> créée par <strong>{{userName}}</strong> le <strong>{{date}}</strong> est dans l\'état: <strong>{{status}}</strong>',
        OPERATION_REQUESTED: 'Opération demandée: ',
        ERROR_FOUND: 'Erreur trouvée: ',
        ERRORS_FOUND: 'Erreurs trouvées: ',

        COLUMNS: {
          VARIANT_SKU: 'SKU variante',
          ERRORS: 'Erreurs',
        },
      },
    },
    SUPPORT_BUTTON: {
      LABEL: 'AIDER',
      TITLE: 'Remplissez les champs pour envoyer une demande d\'assistance',
      SUCCESS_MESSAGE: 'Demande envoyée avec succès !',
      OBJECT: 'Objet',
      MESSAGE_BODY: 'Message',
      BROWSE_FILE: 'Parcourir...',
      FEEDBACK_MESSAGE_0: 'Ticket créé avec identifiant #',
      FEEDBACK_MESSAGE: 'Nous répondrons à votre demande par e-mail à',
      SEND_REQUEST: 'Envoyer une demande',
      CHOOSE_FILE: 'Choisir le fichier',
    },
    PROMOTION_DETAIL: {
      NAME: 'Promotion',
      EVALUATE_REQUIREMENTS_CONSIDERING_ENTIRE_ORDER: 'Évaluer les besoins en tenant compte de l\'ensemble de la commande',
      NEW_PROMOTION: 'Nouvelle promotion',
      BACK_TO_PROMOTIONS: 'Retour aux promotions',
      PROMOTION_NAME: 'Nom',
      CODE: 'Code',
      VALIDITY: 'Validité',
      VALID_FROM: 'Valide à partir de',
      VALID_UNTIL: 'Valide jusqu\'à',
      VALID_ON: 'Valide sur',
      REQUIREMENTS_AND_DISCOUNT: 'Conditions et remises',
      MINIMUM_QUANTITY: 'Quantité minimum',
      MINIMUM_VALUE: 'Valeur minimum',
      FROM: 'De',
      TO: 'À',
      DISCOUNT: 'Remise',
      INCLUDE_VARIANTS: 'Inclure les variantes',
      INCLUDED_VARIANTS: 'Variantes incluses',
      MESSAGE: 'Certaines variantes ne peuvent pas être sélectionnées car elles sont déjà présentes dans une autre promotion du même type',
      VARIANTS: 'Variantes',
      ERROR_APPLICATION_RANGE: {
        RANGE_IS_INCORRECT_FROM_MUST_BE_LESS_THAN_TO: 'L\'intervalle est incorrect. De doit être inférieur à À',
        THE_INTERVAL_OVERLAPS_WITH_ANOTHER_INTERVAL: 'L\'intervalle se chevauche avec un autre intervalle',
        THE_VALUE_FRO_THE_DISCOUNT_MUST_BE_BETWEEN_1_AND_100: 'La valeur de la remise doit être comprise entre 1 et 100',
        THE_VALUE_FOR_TO_MUST_BE_GREATER_THAN_0_OR_EMPTY: 'La valeur de À doit être supérieure à 0 ou vide',
      },
      INFO_APPLICATION_RANGE: {
        THIS_INPUT_WHITEOUT_VALUE_WILL_BE_CONSIDERED_AS_INFINITY: 'Cette entrée sans valeur sera considérée comme infinie',
      },
    },
    VOUCHER_DETAIL: {
      NAME: 'Voucher',
      NEW_VOUCHER: 'Nouveau voucher',
      NEW_VOUCHER_FOR: 'Nouveau voucher pour',
      BACK_TO_VOUCHERS: 'Retour aux vouchers',
      VOUCHER_NAME: 'Nom',
      VALIDITY: 'Validité',
      CUSTOMER_TO_APPLY: 'Clients à qui attribuer le voucher',
      CUSTOMER_APPLIED: 'Clients ayant reçu le voucher',
      ADD_CUSTOMER: 'Ajouter un client',
      CUSTOMER: 'Client',
      SELECTED: 'Choisi',
      DESELECT_ALL: 'Tout déselectionner',
      NO_CUSTOMER_SELECTED: 'Aucun client sélectionné',
      EXPIRED_VOUCHER: 'Le bon sélectionné est expiré!',
      EDIT_DESCRIPTION: 'Éditer la description',
      RESIDUAL_AMOUNT: 'Montant restant',
      SELECT_AT_LEAST_ONE_CUSTOMER: 'Veuillez sélectionner au moins un client',
      FILL_IN_ALL_REQUIRED_FIELDS: 'Veuillez remplir tous les champs obligatoires',
      CHANGE_VOUCHER: 'Changer le voucher',
      APPLICABLE_AS_PARTIAL_PAYMENT: 'Applicable en tant que paiement partiel',
      APPLICABLE_AS_PARTIAL_PAYMENT_MESSAGE: 'S\'il est activé, le bon sera applicable à une commande même si son montant restant ne peut pas couvrir le total de vente en gros réduit de la commande.',
    },
    ASSIGN_VOUCHER: {
      SELECT_VOUCHER: 'Sélectionnez le bon que vous souhaitez appliquer à la commande',
      SELECTION_MESSAGE: 'En appliquant ce bon, le total de la commande sera ',
    },
    AGENCY_DETAIL: {
      TABS: {
        SUMMARY: 'Résumé',
        CHECK_IN: 'Check-in',
        CUSTOMERS: 'Clients',
        ORDERS: 'Commandes',
        AGENTS: 'Agents',
      },
      PLEASE_INSERT_AGENCY_CODE_FOR_ALL_ACTIVE_STORES: 'Veuillez insérer le code de l\'agence pour toutes les boutiques actives',
      AGENCY_CODES: 'Codes de l\'agence',
      BACK_TO_AGENCIES: 'Retour aux agences',
      AGENCY_INFORMATION: 'Informations sur l\'agence',
      VAT: 'TVA',
      FISCAL_CODE: 'Code fiscal',
      AGENCY_CODE: 'Code de l\'agence',
      AGENCY_NAME: 'Nom de l\'agence',
      AGENCY_FORM: 'Forme juridique',
      CANT_EDIT: {
        MESSAGE: 'Vous ne pouvez pas modifier les informations sur l\'agence, car elles sont en attente d\'approbation !',
      },
      SEND_TO_ERP: 'Envoyer à ERP',
      CONTACT_INFO: 'Informations de contact',
      MODAL_ERP: {
        ARE_YOU_SURE: 'Êtes-vous sûr ?',
        ARE_YOU_SURE_YOU_WANT_TOSEND_TO_ERP: 'Êtes-vous sûr de vouloir envoyer ces informations à ERP ?',
        SEND: 'Envoyer',
      }
    },
    ADDRESS_INFO: {
      SEARCH: 'Rechercher',
      ADDRESS: 'Adresse',
      ALTERNATIVE_ADDRESS: 'Adresse alternatif',
      LABEL: 'Rechercher adresse',
      BILLING_LABEL: 'Rechercher adresse de facturation',
      STREET: 'Rue',
      NUMBER: 'Numéro',
      COUNTRY: 'Pays',
      PROVINCE: 'Province',
      CITY: 'Ville',
      ZIP_CODE: 'Code postal',
    },
    CONTACT_INFO: {
      DELETE_MODAL: {
        ARE_YOU_SURE: 'Êtes-vous sûr ?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Êtes-vous sûr de vouloir supprimer cette contactez ?',
        DELETE: 'Supprimer',
      },

      ADD_MODAL: {
        TITLE: 'Ajouter un contact',
        TYPE: 'Type',
      },

      EDIT_MODAL: {
        TITLE: 'Modifier un contact',
      },

      INVALID_VALUE: 'Valeur non valide pour le type de contact sélectionné',

      CONTACT_TYPE: {
        ADMINISTRATIVE: 'Administratif',
        COMMERCIAL: 'Commercial',
        EMAIL: 'Email',
        PEC: 'PEC',
        PHONE: 'Téléphone',
        FAX: 'Fax',
        MOBILE: 'Mobile',
        WEBSITE: 'Site web',
        SOCIAL: 'Social',
        FACEBOOK: 'Facebook',
        TWITTER: 'Twitter',
        INSTAGRAM: 'Instagram',
        LINKEDIN: 'Linkedin',
      }
    },
    CUSTOMER_DETAIL: {
      BACK_TO_CUSTOMERS: 'Retour aux clients',
      TABS: {
        SUMMARY: 'Résumé',
        CHECK_IN: 'Check-in',
        LOCATIONS: 'Lieux',
        ORDERS: 'Commandes',
        DISCOUNTS: 'Remises',
        USERS: 'Utilisateurs',
        VOUCHERS: 'Vouchers',
        SETTINGS: 'Envois',
      },

      ALLERT: {
        MESSAGE: 'Vous ne pouvez pas modifier les informations du client car elles sont en attente d\'approbation !',
      },

      SEND_TO_ERP: 'Envoyer à ERP',

      CARDS: {
        COMPANY_INFO: 'Informations sur la société',
        CONTACT_INFO: 'Informations sur le contact',
        COMPANY_FINANCIAL_STATUS: 'Statut financier de la société',
        PAYMENT_INFO: 'Informations de paiement',
        COMMERCIAL_AGREEMENT: 'Contrat commercial',
        CUSTOMER_DISCOUNT: 'Remise client',
        CUSTOMER_COMMERCIAL_BLOCK: 'Bloc commercial client',
        BASIC_KUSTOM_DISCOUNT: 'Remise Kustom de base',
      },

      STATUS: {
        COMPLETED: 'Terminé',
        NOT_COMPLETED: 'Non terminé',
      },

      MODAL_ERP: {
        ARE_YOU_SURE_YOU_WANT_TO_SEND_TO_ERP: 'Êtes-vous sûr de vouloir envoyer ces informations à ERP ?',
        MESSAGE: 'En confirmant le registre sera sauvegardé et transmis à l\'ERP',
        SEND: 'Envoyer',
      },

      MODAL_SAVE: {
        ARE_YOU_SURE: 'Êtes-vous sûr ?',
        MESSAGE: 'Attention! enregistrant la modification au client, elle sera définie avec le statut "à approuver"',
      },

      COMPANY_INFO: {
        PREFIX_VAT: 'Préfixe TVA',
        VAT_WHITHOUT_PREFIX: 'TVA sans préfixe',
        FISCAL_CODE: 'Code fiscal',
        COMPANY_NAME: 'Nom de l\'entreprise',
        AUTOCOMPLETE: 'Autocomplétion',
        COMPANY_FORM: 'Forme juridique',
        COMPANY_CATEGORIES: 'Catégories',
        ITALIAN_DIGITAL_INVOICING_SYSTEM: 'Système de facturation numérique italien',
        SDI_CODE: 'Code SDI',
        OFFICE_PA_CODE: 'Code PA',
        PEC_EMAIL: 'Email PEC',
        ERROR_YOU_CAN_NOT_ENTER_BOTH_PA_CODE_AND_SDI_CODE: 'Vous ne pouvez pas entrer à la fois le code PA et le code SDI',
        ERROR_CODE_MUST_BE_ALPHANUMERIC_CHARACTERS_WITHOUT_SPACES_AND_SPECIAL_CHARACTERS: 'Le code {{codeName}} doit être composé de {{numCharacters}} caractères alphanumériques sans espaces et caractères spéciaux',
      },

      FINANCIAL_STATUS: {
        ENTERPRISE_BOOL: 'Entreprise active',
        MASTER_DATA_BOOL: 'Registre correct',
        ACTIVITY_BOOL: 'Entreprise conforme',
        REQUEST_NEW_REPORT: 'Demande de nouveau rapport',
        NO_DATA_TO_SHOW: 'Aucun rapport existant, demandez un nouveau rapport en cliquant sur le bouton ci-dessous',
        COLUMNS: {
          DATE: 'Date',
          CLASS: 'Classe',
          RISK_DESCRIPTION: 'Description du risque',
          CREDIT_LIMIT: 'Limite de crédit',
          SCORE: 'Score',
          REPORT: 'Rapport',
        },
        REFRESH_MODAL: {
          ARE_YOU_SURE: 'Êtes-vous sûr ?',
          EACH_REFRESH_HAS_A_COST: 'Chaque rafraîchissement coûte',
          REFRESH: 'Rafraîchir',
        },
        PRINT: 'Imprimer',
        SHARE: 'Partager',
        VIEW_REPORT: 'Voir le rapport',
      },

      PAYMENT_INFO: {
        CHANNEL_PAYMENTS_TERM_INFO: 'Ici, vous pouvez ajouter un délai de paiement spécifique pour chaque canal de vente. Si aucune condition de paiement n\'est spécifiée pour un canal, la condition de paiement par défaut sera utilisée.',
        ADD_PAYMENT_TERM: 'Ajouter une condition de paiement',
        CHANNEL_PAYMENTS_TERM: 'Conditions de paiement par canal',
        PAYMENT_TERM: 'Condition de paiement',
        DEFAULT_PAYMENT_TERM: 'Condition de paiement par défaut',
        CHANNEL: 'Canal',
        BANCK_INFO: 'Informations bancaires',
        ABI: 'ABI',
        CAB: 'CAB',
        SWIFT: 'SWIFT',
      },

      COMMERCIAL_AGREEMENT: {
        COMMERCIAL_ALLOWANCE: 'Allocation commerciale',
      },

      COMMERCIAL_BLOCK: {
        COMMERCIAL_BLOCK: 'Bloc commercial',
        INFO: 'En activant le blocage commercial sur le client, personne à l\'exception des utilisateurs ayant les rôles storeOwner, storeUser et admin ne pourra confirmer le panier.',
        BLOCKED_BY: 'Bloqué par: {{name}}',
        ALERT_COMMERCIAL_BLOCK_FROM_ERP: 'Ce bloc commercial a été implémenté par l\'erp',
      },
    },
    STATUS_LABLE: {
      CREATED_ON: 'Créé le',
      BY: 'par',
      LAST_UPDATE_ON: 'Dernière mise à jour le',
      STATUS: 'Statut',
      FOR_CURRENT_STORE: 'Pour la boutique courante',
    },
    STATUS: {
      ALL: 'Tous',
      ENABLED: 'Activé',
      GOK: 'GOK',
      IS_DIRECT: 'Ordre direct',
      NOT_GOK: 'Non GOK',
      VALID: 'Valide',
      INVALID: 'Invalide',
      TOAPPROVE: 'Doit être approuvé',
      APPROVED: 'Approuvé',
      APPROVED_BY_REQUESTING_USER: 'Approuvé par demandeur',
      APPROVED_GRAPHICALLY: 'Approuvé graphiquement',
      REJECTED: 'Rejeté',
      ORDERED: 'Commandé',
      EVO: 'Evo',
      SUBLI: 'Subli',
      COMMERCIALBLOCKED: 'Bloqué',
      BLOCKED: 'Bloqué',
      PARTIALLY_FULFILLED: 'Partiellement rempli',
      ONHOLD: 'En attente',
      BILLING: 'Facturation',
      SHIPPING: 'Expédition',
      CUSTOMER: 'Client',
      AGENCY: 'Agence',
      ADMIN: 'Administrateur',
      UNASSIGNED: 'Non assigné',
      ACTIVE: 'Actif',
      INVITED: 'Invité',
      DISABLED: 'Désactivé',
      DRAFT: 'Brouillon',
      DRAFT_WITHOUT_NOTIFICATION: 'Brouillon',
      DRAFT_WITH_NOTIFICATION: 'Brouillon avec notification',
      CREATED: 'Créé',
      CONFIRMED: 'Prêt pour l\'évasion',
      FAILED: 'Manqué',
      RE_ORDER: 'Re-order',
      RESTOCK: 'Réassortiment',
      ITEMEXCHANGE: 'Échange d\'article',
      PRE_ORDER: 'Pre-order',
      BY_VALUE: 'Par valeur',
      BY_QUANTITY: 'Par quantité',
      BOTH: 'Les deux',
      EXTERNAL_ID: 'ID externe',
      UNCONSTRAINED: 'Non contraint',
      BY_ORDER_TOTAL_AMOUNT: 'Dépense minimale',
      BY_ORDER_TOTAL_QUANTITY: 'Quantité minimum',
      DELIVERED: 'Livré',
      SHIPPED: 'Expédié',
      PENDING: 'En attente',
      CANCELLED: 'Annulée',
      CONCLUDED: 'Rempli',
      PARTIAL: 'Partiel',
      EXPIRED: 'Expiré',
      INACTIVE: 'Inactif',
      AWAITING_PROCESSING: 'En attente de traitement',
      TO_BE_PROCESSED: 'À traiter',
      PROCESSING: 'En traitement',
      PROCESSED: 'Traité',
      PROCESSED_WITH_ERRORS: 'Traité avec des erreurs',
      PROCESSING_FAILURE: 'Échec du traitement',
      PROCESSED_WITH_ISSUES: 'Traité avec des problèmes',
      ARCHIVED: 'Archivé',
      SYNCING: 'En synchronisation',
      SINGLE_ORDER: 'Commande unique',
      MULTIPLE_ORDERS: 'Commandes multiples',
    },
    PROJECT_TYPE: {
      ALL: 'Tous',
      SUBLI: 'Subli',
      EVO: 'Evo',
    },
    CHANGES_HANDLER: {
      DATE_UNSAVE_CHANGES: 'Vous avez des changements non enregistrés',
      UNDO: 'Annuler',
      SAVE: 'Enregistrer',
      IF_YOU_HAVE_PENDING_CHANGES_YOU_WILL_LOSE_THEM: 'Si vous avez des changements non enregistrés, vous perdrez les modifications.',
    },
    CART: {
      ERROR_DIALOG: {
        TITLE: 'Articles indisponibles',
        UPDATE_DATES: 'Dates de mise à jour',
        UPDATE_DATES2: 'Mettre à jour les dates et supprimer les variantes indisponibles',
        UPDATE_DATES3: 'Dates de mise à jour uniquement',
        UPDATE_DATES4: 'Mettre à jour les dates et retirer les variantes non disponibles',
        INVALID_DATES: 'Dates invalides',
        VARIANT_UNAVAILABLE: 'Variantes non disponibles',
        DELETE_ITEMS: 'Supprimer non disponible',
        LIMIT: 'Limite',
        STOCK_QTY: 'Qty stock',
        ORDERED_QTY: 'Qty commandée',
        AVAILABLE_QTY: 'Qty disponible',
        CART_QTY: 'Qty dans panier',
        POS_LIMIT: 'Limite pour le magasin',
        SKU: 'Sku code',
        COLOR: 'Couleur',
        PRODUCT: 'Produit',
        SIZE: 'Taille',
        NEW_DATE: 'Nouvelle date',
        MESSAGE1: 'Les articles suivants ne sont plus disponibles pour la date de livraison demandée mais ils sont disponibles pour une nouvelle date.',
        MESSAGE1_REORDER: 'Les articles suivants ont des dates de livraison expirées.',
        MESSAGE1_REORDER2: 'Les articles suivants ne sont plus disponibles pour la date de livraison demandée mais sont disponibles pour une nouvelle date.',
        MESSAGE2: 'Voulez-vous mettre à jour les dates de livraison?',
        MESSAGE3: 'Certains articles de commande ne sont plus publiés o disponible. Ceux-ci seront supprimés du panier!',
        MESSAGE4: 'Attention! Vous avez dépassé la limite pour les combinaisons style-couleur suivantes. Veuillez vérifier votre panier pour pouvoir le confirmer.',
        MESSAGE5: 'Attention! Vous avez dépassé la limite pour le magasin actuel. Veuillez vérifier votre panier pour pouvoir le confirmer.',
        MESSAGE6: 'Voulez-vous mettre à jour la date de livraison ?',
        MESSAGE_MIN_QTY_PER_ORDER: 'Attention! Certains articles de la commande n\'atteignent pas la quantité minimale requise pour ce style-couleur spécifique!',
        MINIMUM: 'Minimum',
        ERROR_REASON: 'Raison de l\'erreur',
        REASON: {
          REQUESTED_QTY_NOT_AVAILABLE: 'Quantité demandée non disponible',
          VARIANT_NOT_AVAILABLE_IN_YOUR_TIER: 'Variante non disponible dans votre tier',
          VARIANT_NOT_AVAILABLE_IN_YOUR_CHANNEL: 'Variante non disponible dans votre canal',
          VARIANT_NO_LONGER_VISIBLE: 'Variante plus visible',
          BLANK_CELL_DATE_NO_LONGER_ACTIVE: 'Blank cell, date plus active',
        }
      },
      ATTENTION: 'Attention!',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Vous ne pouvez pas confirmer ce panier car le client n\'est pas approuvé',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Vous ne pouvez pas confirmer ce panier car le point de vente n\'est pas approuvé',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Vous ne pouvez pas confirmer ce panier car le total du panier est inférieur à la valeur minimale autorisée dans cette boutique',
      THIS_CART_NOT_AVAILABLE: 'Questo carrello non è più disponibile',
      NO_PRODUCTS_IN_CART: 'Pas de produits dans le panier',
      COMMERCIAL_BLOCK_INFO: 'Un bloc commercial est actif sur le client actuel.',
      NO_CART_CONF: 'Ce panier ne peut pas être confirmé.',
      DETAILS: {
        ADDRESS_INFO: 'Informations d\'expédition',
        POS: 'Point de vente',
        SHIPPING: 'Expédition à',
        ALTERNATIVE: 'Sélectionnez une autre adresse',
        REMOVE_CUSTOM: 'Supprimer la date personnalisée',
        SET_CUSTOM: 'Définir une date personnalisée',
        INVALID_SELECTION_FOR_CUSTOM_DATES: 'Vous ne pouvez pas définir les mêmes dates de livraison personnalisées pour les mêmes SkuCodes commandés avec différentes dates de livraison suggérées',
        CUSTOM_DATES: 'Dates de livraison personnalisées',
        SELECT_ALL: 'Tout sélectionner',
        DESELECT_ALL: 'Tout déselectionner',
        SHIPPING_UPDATED: 'Adresse de livraison mise à jour',
        NO_OTHER_SHIPPING_ADDRESS_AVAILABLE: 'Aucune autre adresse de livraison disponible',
        VARIANTS_ALREADY_ORDERED_WITH_REORDER_DATE: ' articles non ajoutés car déjà dans le panier avec date d\'expiration. Accédez au panier pour les gérer.',
        PLEASE_SAVE_OR_CANCEL_YOUR_ORDER_CHANGES: 'Veuillez enregistrer ou annuler vos modifications de commande',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Un ou plusieurs articles ne répondent pas à la quantité minimale de commande',
        SEASON_REFERENCE: 'Season Reference',
        GOK: 'GOK',
        TOTAL_COST: 'Coût total',
        TOTAL_MARGIN: 'Marge totale',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Pourcentage de réduction sur le détail',
        NOTE: 'Note',
      },
      CONTROLLERS: {
        DELETE: 'Supprimer panier',
        DUPLICATE: 'Dupliquer panier',
        NOTES: 'Notes',
        PRINT: 'Imprimer',
        ACTIONS: 'Actions',
        CONFIRM_ORDER: 'Confirmer la commande',
        OPEN_IN_BACKOFFICE: 'Ouvrir dans le panneau d\'administration',
        CANCEL_CHANGES: 'Annuler modifications',
        SAVE_CHANGES: 'Sauvegarder modifications',
        EDIT_QTY: 'Modifier quantité',
        COMMERCIAL_AGREEMENT: 'Accord commercial',
        VIEW_IN_BACK_OFFICE: 'Voir le panier dans le Back Office'
      },
      SELECTORS: {
        SHIPPING: {
          TITLE: 'Expédition à',
          TEXT: 'Adresse d\'expédition',
          INPUT: 'Séléctionner l\'adresse d\'expédition',
          DELIVERY_DATES: 'Dates de livraison'
        },
        DELIVERY: 'Date de livraison',
        PRICE: {
          TITLE: 'Totaux',
          TOT_WHOLESALE_GROSS: 'Wholesale brut',
          TOT_DISCOUNT: 'Réduction',
          TOT_DISCOUNT_PERC: 'Réduction %',
          COMM_AGR_DISCOUNT_PERC: 'Réduction acc. comm. %',
          TOT_WHOLESALE_NET: 'Wholesale Net',
          TOT_RETAIL_NET: 'Retail',
          TOTAL_CART: 'Tot. panier'
        },
        ADDING_INFO: 'Vous ajoutez {{totalPcs}} unités, pour une valeur totale en gros de €{{totalWholesale}}',
        ADDING_INFO_LOADING: 'Vous ajoutez...',
        QUANTITY: 'Quantité',
        DISCOUNT: {
          TITLE: 'Votre réduction',
          TEXT: 'Votre réduction'
        },
        PAYMENT: {
          TITLE: 'Méthode de paiement',
          SUB_TITLE: 'Méthode de paiement'
        },
        BILLING: {
          TITLE: 'Informations de facturation',
          SUB_TITLE_CUSTOMER: 'Client',
          SUB_TITLE_ADDRESS: 'Adresse de facturation'
        }
      },
      PRODUCT: {
        TITLES: {
          NAME: 'Nom du produit',
          WHOLESALE: 'Tot. wholesale',
          QUANTITY: 'Tot. quantité'
        },
        DOT_MENU: {
          REMOVE: 'Supprimer',
          REMOVE_LINE: 'Définissez la quantité de lignes sur 0'
        },
        ERRORS: {
          UNAVAILABLE: 'taille indisponible',
          UNAVAILABLES: 'tailles non disponibles'
        }
      },
      CHECKOUT: {
        YOUR_ORDER: 'Votre commande',
        HAS_BEEN_CONFIRMED: 'est bien confirmée',
        POINT_OF_SALE: 'Point de vente',
      },
      PROMOTION: 'Promotions utilisées',
      ORDER_NOTES: 'Notes de commande',
    },
    ON_BACK: {
      MODAL: {
        TITLE: 'Les modifications n\'ont pas été enregistrées',
        MESSAGE: 'Si vous quittez cette page, toutes les modifications non enregistrées seront perdues.',
        LEAVE_PAGE: 'Quitter',
        CONTINUE: 'Continuer',
      }
    },
    FINANTIAL_RISK: {
      FINANTIAL_RISK_CURRENT: 'Risque financier actuel',
      FINANTIAL_RISK_PREVIUS: 'Risque financier précédent',
      CLASS: 'Classe',
      SCORE: 'Score',
      DESCRIPTION: 'Description',
      SUMMARY: 'Résumé',
      CREDIT_LIMIT: 'Limite de crédit',
      INSOLVENCY: 'Insolvabilité',
      COMPANY_INSOLVENCY: 'Insolvabilité de l\'entreprise',
      PROTESTI: 'Protesti',
      PREJUDICIALS: 'Préjudiciaux',
      NAME: 'Nom',
      LEGAL_FORM: 'Forme juridique',
      TAX_CODE: 'Code fiscal',
      VAT_CODE: 'Code TVA',
      COMPANY_NUMBER: 'Numéro de société',
      EMAIL: 'Email',
      COUNTRY: 'Pays',
      COMPANY_REG_NUMBER: 'Numéro d\'enregistrement de la société',
      PUBLIC_REG_SECTION: 'Section du registre public',
      INCORPORATION_DATE: 'Date d\'incorporation',
      REA_REGISTRATION_DATE: 'Date d\'enregistrement REA',
      STATUS: 'Statut',
      STATUS_DESCRIPTION: 'Description du statut',
      EMPLOYESS: 'Employés',
      TURNOVER: 'Chiffre d\'affaires',
      ACTIVITY_CODE: 'Code d\'activité',
      ACTIVITY_DESCRIPTION: 'Description de l\'activité',
      COMPANY_DETAILS: 'Détails de la société',
      STATUS_AND_KEY_FIGURES: 'Statut et chiffres clés',
      ACTIVITY_DETAILS: 'Détails de l\'activité',
      TELEPHONE: 'Téléphone',
      ADDRESS: 'Adresse',
      LAST_RATING_CHANGE_AT: 'Dernier changement de notation le',
      TYPE: 'Type',
    },
    IMPORT_PRODUCT_MODAL: {
      RETAIL_DISCOUNT_PERCENTAGE: 'Pourcentage de remise par rapport à retail',
      DISCOUNT_REQUIRED: 'Remise requise',
      MAX_DISCOUNT_ALLOWED: 'Remise maximale autorisée {{value}}%',
    },
    LOCALIZED_TEXT_EDITOR: {
      ACTIONS: 'Actions',
      ACTION: {
        SET_DEFAULT: 'Définir comme défaut',
      },
      DEFAULT_LANGUAGE: 'Langue par défaut',
    },
    OPERATION_LOG: {
      TITLE: 'Journal des opérations de l\'ERP pour {{value}}',
      OPERATION_LOGS: 'Journal des opérations',
      ORDER: 'commande #{{value}}',
      FULFILLMENT: 'évasi #{{value}}',
      LOG_DESCRIPTION: 'Description du journal',
      COLUMNS: {
        CREATION_DATE: 'Date de création',
        OPERATION_TYPE: 'Type d\'opération',
        OUTCOME: 'Résultat',
      },
      OPERATION_TYPE_STATUS: {
        CONFRIMED_ORDER: 'Commande confirmée',
        FULFILLMENT_CANCELED: 'Évasi annulée',
        ORDER_ITEMS_INSERTED: 'Articles insérés',
        ORDER_ITEMS_UPDATED: 'Articles mis à jour',
        ORDER_UPDATED: 'Commande mise à jour',
        SERVICE_ITEM_INSERTED: 'Service inséré',
        SERVICE_ITEM_UPDATED: 'Service mis à jour',
        SERVICE_ITEM_DELETED: 'Service supprimé',
        FULFILLMENT_CREATED: 'Évasi créée',
        FULFILLMENT_UPDATED: 'Évasi mise à jour',
        FULFILLMENT_PACKAGE_CREATED: 'Colis créé',
        FULFILLMENT_PACKAGE_ITEM_CREATED: 'Article ajouté au cou',
        ORDER_HEADER_UPDATED: 'En-tête de commande mise à jour',
        BULK_ADD_ITEMS: 'Articles ajoutés',
        BULK_CHANGE_QTY: 'Quantité modifiée',
        BULK_REPLACE_ITEMS: 'Articles remplacés',
        BULK_CHANGE_WHOLESALE: 'Prix modifiés',
        BULK_CHANGE_DELIVERY_DATE: 'Date de livraison modifiée',
        WEBHOOK_NOTIFICATION: 'Webhook transmis à l’ERP',
        ORDER_SYNC_STATUS: 'Statut de la commande mis à jour',
        CHANGE_CUSTOMER_OR_POS: 'Client/point de vente modifié',
        BULK_CANCEL_ORDER: 'Commandes annulées',
        BULK_OPERATION_ROLLBACK: 'Annulation opération',
        BULK_REMOVE_ITEMS: 'Articles supprimés',
      },
      OUTCOME_STATUS: {
        SUCCESS: 'Succès',
        FAILED: 'Échec',
      },
    },
    CUSTOMIZATION_REQUEST: {
      EXCEL_IMPORT: {
        UPLOAD_FROM_EXCEL: "Charger depuis Excel",
        MODAL_TITLE: "Charger des variantes depuis Excel",
        INSTRUCTIONS: "Un seul fichier pour toute la demande — une ligne = un article. Téléchargez-le, saisissez la quantité dans QTY, et laissez NUMBER et JERSEY TEXT vides pour les articles sans personnalisation. Pour personnaliser un article, ajoutez une ligne en remplissant NUMBER et/ou JERSEY TEXT et en répétant STYLE CODE, CR STYLE NAME, COLOR et SIZE — avec QTY à 1. Vous pouvez ajouter des tailles non listées, à condition qu'elles existent pour ce produit. Laissez QTY vide sur les tailles que vous ne voulez pas commander. Ne renommez pas et ne dupliquez pas les en-têtes, ne modifiez pas SIZE GROUP pré-rempli, et gardez NUMBER au format texte pour que des valeurs comme 07 ne soient pas modifiées par Excel.",
        INSTRUCTIONS_TEAMS: "La même équipe sur plusieurs produits ? Copiez les lignes et changez CR STYLE NAME et COLOR.",
        UPLOAD: "Charger",
        FILE_REJECTED: "Fichier refusé",
        UPLOAD_FAILED: "Le fichier n'a pas pu être lu",
        REVIEW_TITLE: "Vérification des variantes importées",
        REVIEW_SUBTITLE: "Vérifiez les données lues dans le fichier, corrigez-les si nécessaire, puis confirmez.",
        REPORT: "{{total}} lignes lues · {{imported}} importées · {{ignored}} laissées vides",
        WARNINGS_TITLE: "À vérifier",
        SAVE_SUCCESS: "Données importées enregistrées ({{count}} tailles)",
        PARTIAL_SAVE: "Enregistrement partiel",
      },
      CREATE_NEW_CART: 'Créer un nouveau panier depuis CR',
      PLAYERS: 'Informations des joueurs',
      NO_PLAYERS: 'Aucune information sur le joueur n’a été saisie pour cette demande de personnalisation',
      NO_PLAYERS_TO_EDIT: 'Aucun joueur à modifier pour ce produit.',
      TITLE: 'Demande de personnalisation : {{name}}',
      SUCCESSFULLY_SAVED: 'Configuration sauvegardée avec succès',
      HEADER: {
        TITLE: 'Titre',
        CUSTOMER: 'Client',
        REQUESTER: 'Demandeur',
        CUSTOMER_REQUESTER: 'Demandeur Client',
        AGENCY_REQUESTER: 'Demandeur Agence',
        DESIGNER: 'Designer',
        POINT_OF_SALE: 'Point de vente',
        CUSTOMIZATION_REQUEST_CREATION: 'Création DP.',
        PERSONALIZED_COST: 'Coût de personnalisation',
        SHIPPING_COST: 'Frais d\'expédition',
        DISCOUNT: 'Pourcentage de réduction qui sera appliqué au panier',
        ENDORSEMENT_REQUESTER: 'Approbation demandeur',
        ENDORSEMENT_DESIGNER: 'Approbation designer',
        ENDORSEMENT_COMMERCIAL: 'Approbation commerciale',
        ORDER_CREATED: 'Commande créée',
        REQUEST_REJECTED: 'Rejetée',
        APPROVED_BY_AT: 'Approuvé par {{name}} le {{date}}',
        REJECTED_BY_AT: 'Rejeté par {{name}} le {{date}}',
        PENDING: 'En attente',
        SUPPORT_PHONE: 'Téléphone de support',
        POS_PHONE: 'Téléphone du POS',
        SUPPORT_EMAIL: 'E-mail de support',
        TOTAL_QUANTITY: 'Quantité totale',
        DELIVERY_DATE: 'Date de livraison',
        LAST_DESIGNER_NOTIFICATION: 'Dernière notification au designer',
        TITLE_UPDATED_SUCCESSFULLY: 'Titre mis à jour avec succès',
        REQUESTER_UPDATED_SUCCESSFULLY: 'Demandeur mis à jour avec succès',
        DESIGNER_UPDATED_SUCCESSFULLY: 'Designer mis à jour avec succès',
        POINT_OF_SALE_UPDATED_SUCCESSFULLY: 'Point de vente mis à jour avec succès',
        ARE_YOU_SURE_DUPLICATE: 'Êtes-vous sûr de vouloir dupliquer la demande de personnalisation',
      },
      REQUESTER_APPROVAL: {
        CHOOSE_TITLE: "Voulez-vous entrer les informations des joueurs de votre équipe ?",
        CHOOSE_DONT_CUSTOMIZE: "Non, je ne veux pas personnaliser",
        CHOOSE_CUSTOMIZE: "Oui, je veux entrer les noms et les numéros de mes joueurs (optionnel)",
        HOW_MANY: "Combien de joueurs voulez-vous entrer ?",
        SIZES_TITLE: "Entrez les quantités pour chaque produit. Rappelez-vous, vous avez un minimum de {{min}} pièces pour chaque produit",
        EXTRA_SIZES_TITLE: "Entrez des quantités supplémentaires non personnalisées",
        EXTRA_SIZES_TITLE2: " (optionnel)",
        EXTRA_SIZES_TITLE3: ". Il y a {{n}} produits pour lesquels vous n'avez pas atteint la quantité minimale d'achat ({{min}} pièces). Entrez des quantités pour atteindre le minimum d'achat pour chaque produit.",
        PLAYERS_TITLE: "Sélectionnez une police et entrez, pour chaque joueur, le nom (optionnel) et le numéro (obligatoire), et sélectionnez la taille pour chaque article que vous souhaitez lier à ce joueur.",
        NUMBER: "Numéro",
        JERSEY_TEXT: "Nom",
        DUPLICATE_PRODUCT: "Dupliquer le produit",
        DUPLICATE_ARE_YOU_SURE: "Êtes-vous sûr de vouloir dupliquer ce produit dans votre demande de personnalisation? Si oui, entrez le nom du produit dans la demande et confirmez",
        SHOW_PLAYERS_INFO: "Afficher les infos des joueurs",
        FONTS: "Polices",
      },

      NEW_REQUESTER_APPROVAL: {
        MODAL_TITLE: "Approbation de la demande de personnalisation",
        MODAL_SUBTITLE: "Définissez les quantités de produits et les personnalisations supplémentaires optionnelles.",
        ALERT_INFO: "Cette demande comprend plusieurs produits. Pour compléter la demande, vous devez entrer les quantités pour chaque produit. Les personnalisations sont optionnelles. Rappelez-vous, vous avez un minimum de {{min}} pièces pour chaque produit.",
        PRODUCTS: "Produits",
        INCOMPLETE: "Incomplet",
        COMPLETE: "Complet",
        TOTAL_PIECES: "Total pièces",
        TOTAL_PIECES_RECAP_TITLE: "Récapitulatif des quantités",
        TOTAL_PIECES_PER_PRODUCT_TITLE: "Récapitulatif des quantités par produit",
        CUSTOMIZED: "Personnalisés",
        WITH_CUSTOMIZATION: "Avec personnalisation",
        WITHOUT_CUSTOMIZATION: "Sans personnalisation",
        QUANTITY_WITHOUT_CUSTOMIZATION: "Quantité de produit sans personnalisation",
        SIZE: "Taille",
        QUANTITY: "Quantité",
        WS_UNIT: "WS unit",
        CUST_UNIT: "Pers. Unit",
        WS_TOT: "WS tot",
        INSERT: "Insérer",
        CUSTOMIZATION: "Quantité de produit avec personnalisation",
        FONTS: "Polices",
        LOADING_FONTS: "Chargement des polices...",
        NUMBER: "Numéro",
        NAME: "Nom",
        ADD_PLAYER: "Ajouter un joueur",
        IMPORT_PLAYERS: "Importer joueurs",
        IMPORT_PLAYERS_HINT: "Importer le numéro et le nom des joueurs déjà configurés",
        IMPORT_LAST_CUSTOMIZATION: "Importer la dernière personnalisation",
        IMPORT_LAST_CUSTOMIZATION_TOOLTIP: "Si présents, vous pouvez importer le numéro et le nom des derniers joueurs saisis",
        SAVE_APPROVAL: "Enregistrer l'approbation",
        CHECK_QUANTITIES_AND_PLAYERS: "Vérifiez les quantités et les joueurs saisis avant de procéder à la confirmation",
        NO_SUMMARY_ROWS: "Aucune ligne de résumé.",
        BACK_TO_CUSTOMIZATION_REQUEST: "Retour à la demande de personnalisation",
        SIZE_GROUP: {
          ADULT: "Adulte",
          YOUTH: "Jeune",
          KIDS: "Enfant",
        }
      },

      GRAPHICAL_APPROVAL: {
        COLOR_NAME: "Nom de la couleur",
        COLOR_NAME_TOOLTIP: 'Exemple : nom du club {{currentYear}} + but (match, entraînement...)',
        COLOR_NAME_ERROR: 'Ce nom de couleur est déjà utilisé pour un autre produit.',
      },

      ACTION: {
        APPROVE: 'Approuver',
        EDIT_CUSTOMIZATION_REQUEST_NAME: 'Modifie le nom de la demande de personnalisation',
        EDIT_CR_PRODUCT_NAME: 'Modifier le nom du produit dans la CR',
        BACK: 'Back',
        NEXT: 'Suivant',
        APPROVE_GRAPHICALLY: 'Approuver graphiquement',
        APPROVE_COMMERCIAL: 'Approuver commercialement',
        LOCK_CONFIGURATOR: 'Verrouiller le configurateur',
        UNLOCK_CONFIGURATOR: 'Déverrouiller le configurateur',
        REJECT: 'Rejeter',
        DELETE: 'Supprimer',
        DOWNLOAD_REPORT: 'Rapport',
        DOWNLOAD_COLOR_REPORT: 'Rapport de couleur',
        DOWNLOAD_STORE_ORDERS_ITEMS_REPORT: 'Télécharger le rapport des lignes de commande',
        DOWNLOAD_STORE_ORDERS_REPORT: 'Télécharger le rapport des commandes',
        DOWNLOAD_POINTS_OF_SALE_REPORT: 'Télécharger le rapport du point de vente',

        DUPLICATE_CUSTOMIZATION_REQUEST: 'Dupliquer la demande de personnalisation',
        CUSTOMIZATION_REQUEST_ENDORSEMENT: 'Approbation de la demande de personnalisation',
        DELETE_CUSTOMIZATION_REQUEST: 'Supprimer la demande de personnalisation',
        REJECT_CUSTOMIZATION_REQUEST: 'Rejeter la demande de personnalisation',
        INSERT_REJECTION_REASON: 'Insérer la raison du rejet',
        ARE_YOU_SURE: 'Êtes-vous sûr ?',
        ARE_YOU_SURE_YOU_WANT_TO_LOCK_CONFIGURATOR: 'Êtes-vous sûr de vouloir verrouiller le configurateur ?',
        ARE_YOU_SURE_YOU_WANT_TO_UNLOCK_CONFIGURATOR: 'Êtes-vous sûr de vouloir déverrouiller le configurateur ?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Êtes-vous sûr de vouloir supprimer la demande de personnalisation ?',

        DELIVERY_DATE: 'Date de livraison',
        FINANCIAL_DISCOUNT: 'Remise financière',
        ADDITIONAL_CUSTOMIZATION_COST: "Coût de personnalisation sur cette demande (optionnel)",
        CUSTOMIZATION_REQUEST_APPROVED_SUCCESSFULLY: 'Demande de personnalisation approuvée avec succès',
        CONFIGURATOR_LOCKED_SUCCESSFULLY: 'Configurateur verrouillé avec succès',
        CONFIGURATOR_UNLOCKED_SUCCESSFULLY: 'Configurateur déverrouillé avec succès',
        CUSTOMIZATION_REQUEST_REJECTED_SUCCESSFULLY: 'Demande de personnalisation rejetée avec succès',
        CUSTOMIZATION_REQUEST_DELETED_SUCCESSFULLY: 'Demande de personnalisation supprimée avec succès',
        CUSTOMIZATION_REQUEST_DUPLICATED_SUCCESSFULLY: 'Demande de personnalisation dupliquée avec succès',
        REVERT_TO_DRAFT: 'Revenir en brouillon',
        REVERT_TO_DRAFT_SUCCESSFULLY: 'Le statut de la demande de personnalisation a été modifié avec succès',
        NOTIFY_DESIGNER_READY: 'Notifier le Designer',
        DESIGNER_NOTIFIED_SUCCESSFULLY: 'Designer notifié avec succès',
      },
      DETAIL: {
        BACK_TO_CUSTOMIZATION_REQUESTS: 'Retour aux demandes de personnalisation',
        ORDER: 'Commande',
        GO_TO_ORDER: 'Aller à la commande',
        READ_ONLY_BANNER: 'Cette demande ne vous appartient pas : vous pouvez la consulter en lecture seule, mais pas la modifier ni la supprimer.',
        DETAIL: 'Détail',
        TIMELINE: 'Messagerie',
        MEDIA: 'Médias',
        CHANNEL_NAME: 'Nom de chaîne',
        STATUS: 'Statut',
        CONFIGURATOR_LOCKED: 'Configurateur verrouillé',
        CUSTOMIZED_PRODUCTS: 'Produits personnalisés',
        ADD_PRODUCT: 'Ajouter un produit',
        SELECT_PRODUCT: 'Sélectionner un produit'
      },
      MEDIA: {
        FILE_NAME: 'Nom de fichier',
        USER_NAME: 'Nom d\'utilisateur',
        USER_ROLE: 'Rôle d\'utilisateur',
        DOCUMENT_GRAPHICAL_APPROVAL: 'Documents d\'approbation graphique',
        DOWNLOAD_DOCUMENT: 'Télécharger le document',
        ATTACHMENTS_OF_CUSTOMIZATION_REQUEST: 'Pièces jointes de la demande de personnalisation',
        DOWNLOAD_ALL: 'Tout télécharger',
      },
      UPLOAD_FILE: {
        ERROR_FILE_MAX_SIZE: '<strong>Erreur ! </strong> Le fichier dépasse la taille maximale autorisée de {{maxSize}}',
        ERROR_FILE_TYPE: '<strong>Erreur ! </strong> Le fichier n\'est pas d\'un type autorisé, les types autorisés sont : {{allowedTypes}}',
        ATTACH_DOCUMENT: 'Joindre un document',
        ATTACH_IMAGE: 'Joindre une image',
        ATTACHMENT: 'Pièce jointe',
        BROWSE: 'Parcourir',
        CHOSE_DOCUMENT: 'Choisir un document',
        CHOSE_IMAGE: 'Choisir une image',
      },

      CUSTOMIZATION_PRODUCT: {
        PRODUCT_DELETED_SUCCESSFULLY: 'Produit supprimé avec succès',
        PERSONALIZE: 'Personnaliser',
        COLOR_NAME: 'Nom couleur',
        COLOR_CODE: 'Code couleur',
        START_3D_VIEWER: 'Démarrer le visualiseur 3D',

        SKU: 'Code produit',
        PRODUCT_NAME: 'Nom produit',
        TEMPLATE_ID: 'ID modèle',
        ID: 'ID',
        WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',

        TABLE: {
          SIZE: 'Taille',
          QUANTITY: 'Quantité',
          WHOLESALE_UNIT_PRICE: 'Wholesale unit.',
          CUSTOMIZATION_UNIT_PRICE: 'Personnalisation unitaire',
          WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',
        }
      },

      TIMELINE: {
        CUSTOMIZATION_REQUEST_CREATED: 'Demande de personnalisation créée',
        CUSTOMIZATION_REQUEST_REJECTED: 'Demande de personnalisation rejetée',
        PRODUCT_ADDED: 'Produit ajouté',
        PRODUCT_DELETED: 'Produit supprimé',
        POINT_OF_SALE_UPDATED: 'Point de vente mis à jour',
        CONFIGURATOR_LOCKED: 'Configurateur bloqué',
        CONFIGURATOR_UNLOCKED: 'Configurateur débloqué',
        STATUS_RESET_TO_DRAFT: 'Statut réinitialisé à l\'ébauche',
        APPROVED_BY_REQUESTER: 'Approuvé par le demandeur',
        APPROVED_GRAPHICALLY: 'Approuvé graphiquement',
        APPROVED_COMMERCIAL: 'Approuvé commercialement',
        DEFAULT_DESIGNER_ASSIGNED: 'Designer par défaut assigné',
        DESIGNER_REASSIGNED: 'Designer réaffecté',
        REQUESTER_REASSIGNED: 'Demandeur réaffecté',
        CUSTOMER_REQUESTER_REASSIGNED: 'Demandeur client réaffecté',
        AGENCY_REQUESTER_REASSIGNED: 'Demandeur agence réaffecté',
        MESSAGE_ADDED: 'Message ajouté',
        MEDIA_ADDED: 'Médias ajoutés',
        DESIGNER_NOTIFIED: 'Designer notifié',
        ORDER_ISSUED: 'Demande de personnalisation commandée',
        BY: 'par {{name}}',
        HIDE_MESSAGE_FROM_REQUESTER: 'Masquer le message du demandeur',
        READ_MORE: 'Lire plus',
        READ_LESS: 'Lire moins',
        FOR_CR_PRODUCT: 'pour produit: #{{value}}',
        REQUESTING_NEW_DESIGN: 'avec demande de nouveau design',
        TRANSLATE_MESSAGE: 'Traduire le message',
        SHOW_ORIGINAL_MESSAGE: 'Afficher le message original',
      },
      CONFIGURATOR: {
        BACK_TO_CUSTOMIZATION_REQUEST: 'Retour à la demande de personnalisation',
        PRODUCT_CONFIGURATOR: 'Configurateur de produit #{{sku}} - {{title}}',
      },
      INHERIT_OR_RESET_SIZES_FROM_CR: 'Réutiliser ou réinitialiser les tailles depuis la CR',
      INHERIT_OR_RESET_SIZES_FROM_CR_DESCRIPTION: 'Voulez-vous réutiliser des tailles de la demande de personnalisation précédente ou les réinitialiser ?',
      RESET_SIZES: 'Réinitialiser les tailles',
      INHERIT_SIZES: 'Réutiliser des tailles',
    },
    // TRADUZIONI CROSS FRONT / BACK OFFICE
    DUPLICATE_CART: {
      TITLE: 'Dupliquer le panier',
      CUSTOMER: 'Client',
      POINT_OF_SALES: 'Point de vente',
      CART_NAME: 'Nom du panier',
      ALTERNATIVE_SHIPPING_ADDRESS: 'Adresse de livraison alternative',
      SUCCESS_CART_DUPLICATED: 'Le panier a été dupliqué avec succès',
      ERROR_CART_DUPLICATED: 'Erreur lors de la duplication d\'un ou plusieurs produits',
      DUPLICATE_CART: 'Dupliquer le panier',
      SET_REQUEST_DELIVERY_DATE: 'Définir la date de livraison',
      AGENCY: 'Agence',
      CART_DUPLICATED_PARTIALLY: 'Le panier a été dupliqué partiellement',
      CART_NOT_DUPLICATED: 'Le panier n\'a pas été dupliqué',
      VARIANTS_NOT_ADDED: 'Variantes non ajoutées',
      VARIANT: 'Variante',
      VARIANT_NOT_AVAILABLE: 'variante non disponible',
      QUANTITY_INSUFFICIENT: 'quantité insuffisante',
      REQUESTED_QUANTITY: 'quantité demandée',
      AVAILABLE_QUANTITY: 'quantité disponible',
      MANUAL_DISCOUNT: 'Inclure les remises appliquées manuellement',
      PENDING_FULFILLMENT: 'Dupliquer uniquement les articles de commande non exécutés',
      OPTION_DUPLICATE_ORDER: 'Opciones de duplicación de pedido',
      INCLUDE_CUSTOM_DELIVERIES: 'Inclure les dates de livraison personnalisées',
      SKIP_CHECKS: 'Exclure les contrôles de visibilité et de quantité',
    },
    CHANNEL: {
      BROWSE: 'Feuilleter',
      TITLE: 'Channel',
    },

    CONFIRM_CART_MODAL: {
      TITLE: 'Confirmer le panier',
      SUB_TITLE: 'Vous confirmez le panier',
      ATTENTION_THIS_CUSTOMER_HAVE_A_COMMERCIAL_BLOCK_ACTIVE: 'Ce client a un blocage commercial actif. Voulez-vous vraiment confirmer la commande malgré tout ?',
      YOU_HAVE_VOUCHERS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Vous avez des voucher disponibles que vous pouvez appliquer à ce panier',
      NO_ENTERED_ATTACHMENTS: 'Aucune attachment inséré',
      SELECT_VOUCHER: 'Sélectionnez un voucher',
      RESIDUAL_VOUCHER_VALUE: 'Valeur résiduelle du voucher: {{value}}',
      TOTAL_CART: 'Total panier: {{value}}',
      TERMS_AND_CONDITIONS: 'Termes et conditions',
      ACCEPT_TERMS_AND_CONDITIONS: 'J\'accepte les termes et conditions',
      NO_VOUCHERS_AVAILABLE: 'Aucun voucher disponible',
      VOUCHERS_UNAVAILABLE: 'Fonctionnalité de bon temporairement indisponible',
      CONFIRM: 'Confirmer',
      COMMERCIAL_AGREEMENT: 'Accord commercial',
      YOU_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Vous avez des accords commerciaux disponibles que vous pouvez appliquer à ce panier',
      SELECT_COMMERCIAL_AGREEMENT: 'Sélectionnez un accord commercial',
      DISCOUNT: 'Remise',
      COMMERCIAL_AGREEMENT_ID_IS_NOT_VALID: 'L\'accord commercial précédemment associé à ce panier n\'est plus valable. Sélectionnez-en un autre ou supprimez l\'ancien',
      REMOVE_COMMERCIAL_AGREEMENT: 'Retirer accord commercial',
      YOU_DONT_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Vous n\'avez aucun accord commercial disponible que vous pouvez appliquer à ce panier',
      SAVE: 'Sauvegarder',
      MANAGE_DELIVERY_DATES: 'Gérer les dates de livraison',
      OPTION_TITLE: 'Options de confirmation',
      EXCLUDE_CONTROLS: 'Exclure les contrôles de visibilité et de quantité',
      INFO_EXCLUDE_CONTROLS: 'En excluant les contrôles de visibilité et de quantité, vous pouvez confirmer le panier même si les articles ne sont pas visibles ou si la quantité demandée n\'est pas disponible',
      DONT_SENT_EMAIL: 'Ne pas envoyer d\'e-mail de confirmation',
      POPULATE_DEFAULT_RECIPIENTS: 'Remplir avec les destinataires par défaut',
    },

    PAGINATION: {
      ITEM_FOR_PAGE: 'Éléments par page',
      PAGE: 'Page',
      OF: 'de',
    },

    EVALUATE_CART_SALE_CAMPAIGN_CONSTRAINT: {
      COMMERCIAL_RULES: 'Règles commerciales',
      ALERT: {
        TITLE: 'Attention!',
        MESSAGE: 'La règle commerciale "{{commercialRuleName}}" pour la campagne commerciale "{{saleCampaignName}}" a été activée sur ce panier.',
        MORE_INFO: 'Afficher les détails.',
        CLICK_HERE_FOR_MORE_INFO: 'Cliquez ici pour afficher les détails.',
        CART_NOT_CONFIRMABLE: 'Une règle métier est active sur ce panier pour laquelle une ou plusieurs contraintes ne sont pas satisfaites.',
        FOR_CONFIRM_CART: 'pour le confirmer, toutes les contraintes doivent être satisfaites.',
        ROLE_BYPASS: 'Votre rôle vous permet de confirmer le panier même si toutes les contraintes ne sont pas satisfaites.',
        CONSTRAINTS_IS_SATISFIED: 'Une règle métier est active sur ce panier et ses contraintes sont satisfaites',
      },

      MODAL: {
        DETAIL_COMMERCIAL_RULE: 'Détail de la règle commerciale: {{commercialRuleName}}',
        MISSING_ITEMS_OF_PRODUCTS: 'Il vous manque {{missingNumberOfItems}} pièces parmi les produits : {{stylesCode}}',
        VALUE_CONSTRAINT_NOT_REACHED: "Les articles de cet assortiment n'atteignent pas le pourcentage minimum par rapport au total de la vente en gros, en tenant compte également des commandes précédentes effectuées dans la campagne de vente en cours (total en gros {{computedTotalWholesaleForMatchedItems}}€, correspondant à {{computedPercentageOfTotalWholesaleForMatchedItems}}%, tandis que le seuil est de {{constrainedTotalWholesaleMinimumPercentage}}%; il manque €{{missingWholasale}})",
        VALUE_CONSTRAINT_REACHED: 'Contrainte de valeur satisfaite',
        VALUE_CONSTRAINT: '({{computedTotalWholesaleForMatchedItems}}€, correspondant au {{computedPercentageOfTotalWholesaleForMatchedItems}}%)',
        ALL_PACKAGE_CONSTRAINTS_ARE_SATISFIED: 'Contraintes du package satisfaites',
        CONSTRAINTS_ON_ASSORTMENT: 'Contraintes sur l\'assortiment: {{assortmentName}}',
      },
    },

    CUSTOM_SHIP_DATES: {
      ITEMS_WITH_NO_STOCK1: 'Certaines dates n’ont pas été ajoutées : ',
      ITEMS_WITH_NO_STOCK2: ' articles n’ont pas de quantité disponible en stock',
      TITLE: 'Dates de livraison personnalisées',
      SELECT_ALL: 'Tout sélectionner',
      UNSELECT_ALL: 'Tout désélectionner',
      BULK_PERSONALIZED_DATE: 'Personnaliser les dates de livraison ({{numberOfItems}})',
      VIEW_SELECTION: '({{n}}) articles sélectionnés',
      CUSTOM_DATE: 'Date personnalisée',
      DATE_NOT_SELECTABLE: 'Date non sélectionnable',
      REMOVE_ALL_CUSTOM_DATES: 'Supprimer dates personnalisées',
      DATE_OVER_MAX_DATE: 'Un ou plusieurs articles ont une date de personnalisation qui dépasse la date de personnalisation maximale définie dans cette magasin',
      REQUESTED_DATE_OVER_MAX_DATE: 'Un ou plusieurs articles sélectionnés ne sont pas personnalisables car la date de livraison initialement demandée dépasse la date de personnalisation maximale définie dans cette magasin',
      ON: 'le',
      FROM: 'du',
      TO: 'au',
      ADD_NEW_DATE: 'Ajouter une nouvelle date',
      EDIT_DATE: 'Modifier la date',
      DATE: 'Date',
      QTY: 'Q.ty',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_GREATER_THAN_THE_QUANTITY_ORDERED: 'Erreur! La somme des quantités pour les dates personnalisées est supérieure à la quantité commandée',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_LESS_THAN_THE_QUANTITY_ORDERED: 'Erreur! La somme des quantités pour les dates personnalisées est inférieure à la quantité commandée',
      ERROR_THERE_ARE_DUPLICATE_DATES: 'Erreur! Il y a des dates en double',
      ERROR_THE_CURRENT_DATE_IS_OVER_THE_MAX_DATE: 'Erreur! La date actuelle est supérieure à la date maximale',
      INFO_MODAL_TITLE: 'Nouveau mode de personnalisation des dates de livraison',
      INFO_MODAL_CONTENT: 'La personnalisation des dates de livraison des articles dans un panier est désormais disponible via la fenêtre de confirmation de commande (voir capture d\'écran ci-dessous). Il ne sera plus possible de réaliser cette opération à l\'aide des actions utilisées jusqu\'à présent.',
      OK: 'J\'ai compris',
      COL_ORDER_ITEM: 'Article de commande',
      N_ORDER_ITEMS: 'N° articles de commande',
      ORIGINAL_DATE: 'Date originale',
    },


    CUSTOMIZATION_REQUEST_CREATOR: {
      PERSONALIZE: 'Personnaliser',
      BACK: 'Retour',
      CONFIRM: 'Confirmer',
      REQUEST_CONFIGURATION: 'Demander nouveau design',
      DOWNLOAD_THUMBNAIL: 'Télécharger l\'image',
      SAVE: 'Enregistrer',
      CHANGE_TEMPLATE: 'Changer le modèle',
      CREATED_SUCCESSFULLY: 'Demande de personnalisation créée avec succès',
      PRODUCT_ADDED_SUCCESSFULLY: 'Produit ajouté avec succès',
      STEP_1: {
        TITLE: 'Nouvelle personnalisation',
        MESSAGE: 'Souhaitez-vous créer une nouvelle demande de personnalisation ou utiliser une existante ?',
        NEW_CR: 'Nouvelle demande',
        EXISTING_CR: 'Demande existante',
      },
      STEP_2: {
        TITLE: 'Nouvelle demande de personnalisation',
        SELECT_REQUESTER: 'Sélectionnez au moins un demandeur. Vous pouvez sélectionner un client et/ou un agent',
        SELECT_REQUESTER_2: 'En tant qu’utilisateur d’une agence, vous pouvez également lier cette demande de personnalisation à un client',
        SELECT_REQUESTER_3: 'En tant qu’utilisateur client, vous pouvez également lier cette demande de personnalisation à un agent, si votre point de vente est suivi par une agence',
        TITLE_REQUEST: 'Nom du club',
        TITLE_REQUEST_TOOLTIP: 'Exemple : nom du club {{currentYear}}.',
        COMMENTS: 'Nom du produit dans la demande',
        COMMENTS_TOOLTIP: 'Exemple: nom du club + but (match, entraînement...)',
        POS_PHONE: 'Numéro de téléphone du point de vente',
        POS_PHONE_TOOLTIP: 'Numéro de téléphone associé au point de vente. S\'il est déjà enregistré, il sera pré-rempli.',
        POS_PHONE_EXAMPLES_TITLE: 'Exemples par pays :',
      },
      STEP_3: {
        TITLE: 'Sélectionner la demande de personnalisation',
        SELECT_REQUEST: 'Sélectionner la demande',
      },
      STEP_4: {
        TITLE: 'Sélectionner un modèle de base',
        DESCRIPTION: 'Demande de personnalisation : {{name}}',
      },
      STEP_5: {
        TITLE: 'Demander la configuration pour la personnalisation : {{name}}',
        DESCRIPTION: 'Modèle #{{expiviId}}',
      },
      STEP_6: {
        TITLE: 'Configuration pour la demande : {{name}}',
        DESCRIPTION: 'Modèle #{{expiviId}}',
      },

      CONFIGURATION_MESSAGE: {
        PLACEHOLDER: 'Décrivez le produit que vous souhaitez demander',
        MESSAGE_OF_REQUEST: 'Message de la demande',
        ATTACHMENTS: {
          TITLE: 'Pièces jointes',
          ADD: 'Ajouter une pièce jointe',
        },
      },

      VALIDATION: {
        AT_LEAST_ONE_REQUESTER: 'Veuillez sélectionner au moins un demandeur (Client ou Agence)',
        REQUESTERS_MUST_BE_DIFFERENT: 'Le demandeur Client et le demandeur Agence doivent être des utilisateurs différents',
        PHONE_REQUIRED: 'Le numéro de téléphone est obligatoire',
      },

    },
    BASIC_KUSTOM_REQUESTER: {
      CUSTOMER: 'Client',
      AGENT: 'Agent',
      CUSTOMER_REQUESTER: 'Demandeur Client',
      SELECT_AGENCY: 'Sélectionner une agence',
      SELECT_AGENT: 'Sélectionner un agent',
      THIS_POINT_OF_SALES_DOES_NOT_HAVE_ANY_AGENCY: 'Ce point de vente n\'a pas d\'agence',
      SECTION_CLIENTE: 'Client',
      SECTION_USER: 'Utilisateur',
      POINT_OF_SALE: 'Point de vente',
    },

    //shop

    POS_STOCK_INFO: {
      TITLE: 'Informations sur les stocks du point de vente',
      LOADING: 'Chargement stock info..',
      ORDERABLE_QTY: 'Quantité à commander pour le point de vente actuel',
      ORDERABLE_QTY2: 'Dans le panier actuel, vous pouvez ajouter plus',
      CART_QTY: 'Quantité dans le panier actuel',
      TOTAL: 'Total'
    },
    COMMON: {
      SET: 'Set',
      SAVE: 'Sauvegarder',
      MIN: 'Minimum',
      MAX: 'Maximum',
      FROM: 'De',
      TO: 'À',
      SHOW: 'Afficher',
      ONLY: 'Seulement',
      IN: 'Dans',
      SHOW_ONLY: 'Afficher seulement',
      SHOW_MORE: 'Afficher plus',
      SUGG_RETAIL: 'Sugg. retail',
      SEARCH: 'Recherche',
      DATES_CHECKBOX: 'Afficher uniquement les semaines avec les produits disponibles',
      DELIVERY_DATES: 'Dates de livraison',
      PCS: 'pcs',
      WHOLESALE: 'Wholesale',
      SUGGESTED: 'Suggéré',
      VALID: 'Valide',
      TYPE: 'Type',
      EXPAND_ALL: 'Développer tout',
      COLLAPSE_ALL: 'Réduire tout',
      PRODUCTS: 'Produits',
      COMMERCIAL_BLOCK_ACTIVE: 'Blocage commercial actif',
      MAN: 'Homme',
      WOMAN: 'Femme',
      UNISEX: 'Unisexe',
    },
    HEADER: {
      PRE_ORDER: 'Pre-order',
      RE_ORDER: 'Re-order',
      MY_CARTS: 'Mes paniers',
      CART: 'Panier',
      CARTS: 'Paniers',
      SELECT_CHANNEL: 'Sélectionner channel'
    },
    ACCOUNT_POPUP: {
      MY_ACCOUNT: 'Mon compte',
      BACK_OFFICE: 'Back-office',
      LOGOUT: 'Logout',
      SWITCH_TENANT: 'Changer de pays',
      CHANGE_LINGUAGE: 'Changer de langue',
      SHOW_ONLY_RETAIL_PRICES: 'Afficher les prix retail',
    },
    DIALOGS: {
      USE_TIER_FILTER: 'Définir un filtre selon la configuration du niveau',
      NO_TIER: 'Informations non liées à un niveau',
      SELECT_TIER: 'Informations liées à un niveau spécifique',
      ARE_YOU_SURE_YOU_WANT_TO_CONFIRM_THIS_CART_BLOCKED: 'Attention! ce client a un blocage commercial actif. Voulez-vous vraiment confirmer la commande malgré tout ?',
      DO_YOU_WANT_TO_LOGOUT: 'Voulez-vous vous déconnecter ?',
      DO_YOU_WANT_TO_DELETE_THIS_CART: 'Voulez-vous supprimer ce panier ?',
      DO_YOU_WANT_TO_CONFIRM_THIS_ORDER: 'Voulez-vous confirmer cette commande?',
      DO_YOU_WANT_TO_DELETE: 'Voulez-vous supprimer',
      CREATE_NEW_CART: 'Créer un nouveau panier',
      CREATE_CART: 'Créer un panier',
      EDIT_CART: 'Modifier le panier',
      COPY_CART: 'Copier un panier',
      TYPE_A_NEW_CART_NAME: 'Saisissez un nouveau nom de panier',
      AGENCY: 'Agence',
      NEW_CART_NAME: 'Nom de panier',
      NO_SEASON_REFERENCE_AVAILABLE: 'Aucune season reference disponible',
      CANT_CONFIRM_THIS_ORDER: 'Impossible de confirmer cette commande',
      CANCEL: 'Annuler',
      CONFIRM: 'Confirmer',
      SAVE: 'Enregistrer',
      GOK_MODE: 'GOK',
      GOK_CART: 'Panier Gok',
      CREATE_PRICE_LIST: 'Créer une liste de prix',
      EDIT_PRICE_LIST: 'Modifier la liste de prix',
      DELETE_PRICE_LIST: 'Supprimer la liste de prix',
      DELETE_PRICE_LIST_CONFIRM: 'Êtes-vous sûr de vouloir supprimer cette liste de prix?',
      ASSOCIATE_CUSTOMERS: 'Associer des clients',
    },
    FOOTER: {
      COPYRIGHT: 'Copyright BasicGroup 2025',
      PRIVACY_POLICY: 'Politique de confidentialité',
      TERMS: 'Termes et conditions',
      TERMS_NOT_FOUND: 'Termes et conditions non trouvés',
      FOR_CLUBS: 'For clubs',
      NO_DATA: 'Aucune donnée disponible, veuillez contacter l\'administrateur.',
      RESET: 'Reinitialiser mot de passe',
      TEXT: 'BasicItalia S.r.l. - Strada della Cebrosa 106, 10100 Torino, Italy - P.IVA e CF IT1234567890',
      BUTTON: 'Support'
    },
    CART_POPUP: {
      CLOSE: 'Fermer',
      PIECES: 'Pièces',
      PRODUCTS: 'Produits',
      RE_ORDER_CARTS: 'RE-ORDER',
      PRE_ORDER_CARTS: 'PRE-ORDER',
      SELECTED_CURRENT: 'Le panier sélectionné est le panier avec lequel vous faites actuellement vos achats',
      SELECTED: 'Selected',
      NAVIGATE: 'Go to cart',
      DELIVERY_DATES: 'Livraison le',
      WHOLESALE_PRICE: 'Prix wholesale',
      CREATED: 'Créé',
      CONTROLLERS: {
        DELETE: 'Supprimer le panier sélectionné',
        CREATE: 'Créer un nouveau panier',
        GO_TO_CHECKOUT: 'Procéder au paiement',
        NO_CARTS: 'Pas de paniers, veuillez en créer un nouveau'
      }
    },
    FILTERS: {
      STRATEGIC: 'Stratégique',
      PROMO: 'En promo',
      CUSTOMIZABLE: 'Personnalisables',
      AVAILABLE_NOW: 'Disponible maintenant',
      GENDER: 'Civilité',
      SIZE_GROUP: 'Groupe de taille',
      STYLE_GROUP: 'Groupe de article',
      COLLECTIONS: 'Collections',
      COLORS: 'Couleurs',
      CATEGORY: 'Catégorie',
      PURPOSE: 'Purpose',
      ASSORTMENTS: 'Assortiments',
      TEAM: 'Team',
      SEASON: 'Saison',
      AVAILABILITY: 'Disponibilité',
      WHOLESALE_PRICE: 'Prix wholesale',
      SUGGESTED_RETAIL_PRICE: 'Prix de vente suggéré',
      NO_DATA: 'No data',
      TAGS: 'Tags',
      APPLAY_FILTERS: 'Appliquer les filtres',
      CLEAR_ALL: 'Effacer tout',
    },
    SIZE_GROUPS: {
      ADULT: 'Adulte',
      YOUTH: 'Jeunes',
      KID: 'Enfant',
      INFANT: 'Bébé'
    },
    SIZES_TABS: {
      LIMIT: 'Limite',
      COLOR: 'Couleur',
      PRICE: 'Prix',
      DOT_MENU: {
        COPY: 'Copier',
        PASTE: 'Coller',
        CLEAR_ALL: 'Effacer tout',
        REMOVE_ALL: 'Supprimer tout'
      },
      ADD: 'Ajouter au panier',
      TOT_PCS: 'Total pcs.',
      MAX_QTY_REACHED: 'Quantité maximale atteinte',
      QTY_NOT_AVAILABLE: 'Quantité non disponible'
    },
    BREADCRUMBS: {
      HOME: 'Home',
      RE_ORDER: 're-order',
      PRE_ORDER: 'pre-order',
      CATALOG: 'Catalogue',
    },
    HOME: {
      SHOP: {
        CATALOG: 'Explorer tout le catalogue',
        BROWSE: 'Parcourir par'
      },
      CATEGORIES: {
        TITLE: 'Catégories',
        TEXT: 'Acheter par catégories \n et passer votre commande en quelques clics',
        BUTTON: 'Parcourir tout le catalogue'
      },
      VIDEO: {
        TITLE: 'Quoi de nouveau cette saison ?',
        TEXT: 'Découvrez ce que nous avons pour vous cette saison : produits phares, nouvelles technologies et plus encore'
      },
      COLLECTIONS: {
        TITLE: 'Assortiments',
        TEXT: 'Découvrez la sélection de produits réalisée pour vous',
        EXPLORE: 'Découvrez tous les assortiments'
      },
      PRODUCTS: {
        TITLE: 'Nos produits stratégiques',
        TEXT: 'Découvrez quels sont les produits phares que vous devez avoir pour la prochaine saison',
        BUTTON: 'Shop strategic',
        ADD_TO_CART: 'Ajouter au panier'
      },
      PROMOTIONS: {
        TITLE: 'Promotions',
        EXPLORE: 'Découvrez toutes les promotions'
      },
      SHOWCASE: {
        ALL: 'Tous',
        EXPLORE: 'Découvrez le catalogue des {{name}}',
        SHOP_NOW: 'Acheter maintenant',
        DISCOVER_MORE: 'Découvrez tous les produits pour {{name}}'
      }
    },
    PRODUCTS: {
      LIST: {
        FILTERS: 'Filtres',
        ACTIVE_FILTERS: 'Filtres actifs',
        BROWSE_BY: 'Naviguer par',
        ITEMS: 'Elements',
        ORDER_BY: 'Trier par',
        NO_PRODUCTS: 'Pas de produits',
        NO_ASSORTMENTS: 'Pas d\'assortiment',
        VIEW: 'Vue',
        GRID: 'Grille',
        LIST: 'Liste'
      },
      DETAIL: {
        ERROR_VARIANTS_ALREADY_PRESENT: 'Les variantes suivantes sont déjà dans le panier avec une date de livraison demandée différente de celle sélectionnée ({{date}}):',
        STYLE_COLOR_QUANTITY_LIMIT_EXCEEDED: 'Vous dépassez la limite de quantité de style-couleur',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Vous essayez d\'ajouter un ou plusieurs articles qui ne respectent pas la quantité minimale de commande',
        PROMO: {
          ORDER: 'Commande',
          MORE_OF: 'La plupart de ces produits ont un',
          MORE_MORE_OF: 'La plupart de ces produits ont un',
          MORE_OF_VALUE: '€ plupart de ces produits, pour obtenir le',
          DISCOUNT: 'Réduction',
          QUANTITY: 'Quantité',
          PRICE: 'Prix',
          VIEW_PROMO: 'Voir promotion',
          TITLE: 'Promotions',
          PROMOTION_NAME: 'Nom de la promotion',
          RANGE: 'Plage de validité',
          TYPE: 'Type de promotion',
          VALIDITY_PERIOD: 'Période de validité',
          ITEM_IN_YOUR_CART: 'Articles dans votre panier',
          VALUE_IN_YOUR_CART: 'Valeur de votre panier',
          INFO_ALLERT: 'Attention! Les promotions ne seront pas appliquées sur les variantes qui bénéficient d\'une remise de canal',
        },
        INFO: {
          SHOP_SELLING_PERIOD: 'Période de vente de la boutique',
          PRICE_LIST: 'Liste de prix'
        },
        ADDITIONAL: {
          PRODUCT_DESCRIPTION: 'Description produit',
          PRODUCT_INFO: 'Information produit',
          PURPOSE: 'Purpose',
          DESCRIPTION: 'Description',
          SEASON: 'Saison',
          GENDER: 'Civilité',
        },
        CS: {
          TITLE: 'Couleurs et tailles',
          DELIVERY_DATE: 'Date de \n livraison',
          PLACEHOLDER: 'Couleur recherchée'
        },
        CONTROLLERS: {
          CLEAR_ALL: 'Supprimer toutes les quatités',
          ADD_ALL: 'Ajouter des quantités au panier',
          COMPRESS: 'Compresse',
          EXPAND: 'Développer',
        },
        NO_AVAILABLE: {
          TEXT: 'This product is non longer available on pre-order. Please to on re-order cataloge to place your order',
          BUTTON: {
            PRE_ORDER: 'Acheter produit en pre-order',
            RE_ORDER: 'Acheter produit en re-order'
          }
        },
        SAME: 'Produits dans le même assortiment',
        SIMILAR: 'Produits similaires dans d\'autres assocrtiments',
        NO_VARIANTS_PUBLISHED: 'AUCUNE VARIANTE PUBLIÉE POUR LE ACTUEL GROUPE DE TAILLE N\'EST DISPONIBLE POUR LA DATE SÉLECTIONNÉE',
        ERROR_QUANTITY: 'Attention! Quantité demandée non disponible. Quantité maximale disponible définie',
      },
      CARD: {
        WHOLESALE: 'Wholesale',
        RETAIL: 'Retail',
        AVAILABILITY: 'pièces en stock'
      }
    },
    ORDER_CHECKOUT: {
      LIMITED_REORDER_PIECES_VIOLATION_TITLE: 'Limite de pièces réapprovisionnables dépassée',
    },
    ERRORS: {
      TITLE: 'Message d\'erreur',
      PRODUCT_LOADING: 'Une erreur s\'est produite lors du chargement du produit',
      INVALID_ORDER: 'La commande est invalide',
      DEFAULT_MESSAGE: 'Désolé, quelque chose s\'est mal passé. Veuillez réessayer plus tard'
    },
    COLLECTION_CARD: {
      SHOP_ASSORTMENT: 'Découvrir l\'assortiment'
    },
    PROMOTION_CARD: {
      SHOP_PROMO: 'Découvrez la promo'
    },

    VARIANT_GRID: {
      CUSTOMER_DISCOUNT: "Le client pour lequel vous achetez bénéficie d'une remise de",
      USE_ACTION: "Utiliser l'action",
      USING_PERC: "en appliquant directement la remise de",
      ADD_DELIVERY_WITH_STOCK: 'Ajouter une livraison avec quantité en stock',
      ADD_DATE_WITH_STOCK: 'Ajouter une date avec quantité en stock',
      QTY_AVAILABLE_IN_STOCK: 'Qté disp. en stock',
      USE_OLD_VERSION: 'Utiliser l\'ancienne version',
      USE_NEW_VERSION: 'Utiliser la nouvelle version',
      NEW_SIZE_GRID_NOTICE: 'La nouvelle grille des tailles est disponible. Vous pouvez choisir ici quelle version utiliser.',
      A_CUSTOM_DELIVERY: 'livraison personnalisée',
      REORDER_SECTION: 'section re-order',
      SELECT_COLORS: 'Sélectionnez les couleurs pour voir les dates et les quantités',
      ADD_DELIVERY: 'Ajouter une livraison personnalisée',
      ON_DATE: 'À cette date',
      COLORS: 'Couleurs',
      PCS_ORDERED: 'Pièces commandées',
      CUSTOM_ADD: 'Ajout personnalisé',
      ADD_QTY: 'Ajouter quantité',
      SELECT_CUSTOM_DELIVERY: 'Sélectionnez votre livraison personnalisée',
      ADD_ITEMS_CUSTOM: 'Ajouter des articles avec des options personnalisées',
      CANT_MANAGE_DATES: 'Vous ne pouvez pas gérer les dates de livraison dans',
      DISCOUNT_APPLIED_ALL: 'La remise sera appliquée à chaque article que vous ajoutez, y compris ceux pour lesquels des quantités ont déjà été saisies.',
      DIFF_PRICE_WARNING: 'Vous ajoutez des articles avec des prix différents, vous ne pouvez donc pas définir un prix de gros souhaité pour calculer la remise.',
      PERCENTAGE: 'Pourcentage',
      DISCOUNT_NAME: 'Nom de la remise',
      DISCOUNT_TYPE: 'Type de remise',
      DESIRED_WHOLESALE: 'Prix wholesale souhaité',
      DISCOUNT_PCT: 'Pourcentage de remise',
      CLEAR_QUANTITY: 'Effacer la quantité',
      ADD_ALL: 'Ajouter tout',
      ADD: 'Ajouter',
      PRE_COMPILE_WITH_AVAILABLE_QTY: 'Pré-remplir avec les quantités disponibles',
      PRECOMPILE: 'Pré-remplir',
      COPY: 'Copier les valeurs',
      PASTE: 'Coller les valeurs',
      COPIED: 'Valeurs copiées!',
      PASTED: 'Valeurs collées!',
      ADD_AVAILABLE_QUANTITY: 'Ajouter la quantité disponible',
      QTY_AVAILABLE: 'Quantité disponible',
      QTY_IN_CART: 'Quantité dans le panier',
      THERE_ARE_NO_AVAILABLE_QUANTITIES_TO_ADD: 'Il n\'y a pas de quantités disponibles à ajouter',
      MAX_QTY_REACHED: 'Quantité maximale atteinte',
      QTY_NOT_AVAILABLE: 'Quantité non disponible',
      QTY_NOT_AVAILABLE_BY_CLICKING_SAVE_THE_VARIANT_WILL_BE_REMOVED: 'Quantité non disponible. En cliquant sur "Enregistrer", la variante sera supprimée.',
      LIMIT_EXCEEDED_FOR_PALETTE: 'Limite dépassé pour la couleur : {{paletteCode}}',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART: 'Quantités de couleur <b>{{colorCode}}</b> ont été précompilés. Cliquez sur "Ajouter" pour les ajouter à votre panier.',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART_ALL: 'Quantités disponibles ont été précompilés. Cliquez sur "Ajouter tout" pour les ajouter à votre panier.',
      INPUTS_RESET_TO_ZERO: 'Entrées remises à 0.',
      ITEMS_ADDED_TO_CART: '<b>{{sumQtyAdded}}</b> articles ajoutés au panier.',
      NO_QUANTITIES_TO_ADD: 'Il n\'y a pas de quantités à ajouter.',
      RESET_QUANTITIES_INPUTS: 'Réinitialiser l\'entrée de quantité',
      NO_COLORS_FOUND: 'Aucune couleur trouvée',
      NO_COLORS_FOUND_HINT: 'Pour voir les variantes, créez un panier et assurez-vous qu\'une campagne de vente est active.',
      NO_AVAILABLE_DATES: 'No available delivery dates',
      CHOOSE_DELIVERY_DATE: 'Date de livraison',
      DATES: '({{numberDate}}) disponibles',
      SUGG_RETAIL: 'Sugg retail',
      MAX: 'Max',
      SUGG: 'Sugg',
      PROMOTION_TABLE: 'Afficher les promotions',
      PRICE_TABLE: 'Afficher les prix',
      PRICE_TABLE_TITLE: 'Tableau des prix',
      PROMOTION_TABLE_TITLE: 'Tableau des promotions',
      BY_VALUE: 'Par valeur de la commande',
      BY_QUANTITY: 'Par quantité de produits',
      QUANTITY: 'Quantité',
      MIN_QTY_ERROR: 'Quantité minimale non atteinte',
    },

    MODAL_ATTENTION_CHANGE_ORDER_QTY: {
      LOSE_CUSTOM_DELIVERY_DATES: 'En modifiant les quantités, vous perdrez les dates personnalisées que vous avez définies! Pensez à le réinitialiser lors de la validation de votre commande!',
      ARE_YOU_SURE: 'Êtes-vous sûr?',
      CONFIRM: 'Confirmer',
    },


    PROMOTION_STEPS: {
      ITEMS_IN_THE_CART: 'Articles dans le panier {{products}}',
      PROMOTION_DISCOUNT: 'Réduction promotionnelle {{discount}}%',
      ADD_PCS_FOR_REACH_PROMO_DISCOUNT: 'Ajouter {{pcs}} pcs pour atteindre le rabais promotionnel',
      CART_VALUE: 'Valeur du panier {{value}}',
      ADD_VALUE_FOR_REACH_PROMO_DISCOUNT: 'Ajouter {{value}} pour atteindre le rabais promotionnel',
      PROMOTION: 'Promotion',
    },
    BULK_OPERATIONS: {
      STATUS: {
        AWAITINGPROCESSING: 'En attente de traitement',
        PROCESSING: 'En traitement',
        PROCESSEDWITHOUTISSUES: 'Traité',
        PROCESSINGFAILURE: 'Échec du traitement',
        PROCESSEDWITHISSUES: 'Traité avec des problèmes',
      },
      TYPES: {
        ADDNEWITEMS: 'Ajouter de nouveaux articles',
        REMOVEITEMS: 'Supprimer des articles',
        REPLACEITEMS: 'Remplacer des articles',
        EDITQUANTITY: 'Changer la quantité',
        CHANGEITEMSDELIVERYDATE: 'Changer la date de livraison',
        EDITWHOLESALEPRICE: 'Modifier le prix net',
        CHANGERETAILPRICE: 'Modifier le prix de vente',
        UPDATEERPSERVICEITEMS: 'Frais supplémentaires mis à jour',
        CHANGECUSTOMERANDSHIPPINGADDRESS: 'Changer le client et le point de vente',
        CANCELORDER: 'Annuler les commandes',
        UPDATEFROMTEMPLATE: 'Mettre à jour depuis modèle',
        UPDATEORDERHEADER: 'Mettre à jour le header de la commande',
      },
      SCOPES: {
        SINGLEORDER: 'Commande unique',
        MULTIPLEORDERS: 'Commandes multiples',
      },
      MODAL: {
        TITLE: 'Détails de l\'opération',
        TAB1_TITLE: 'Log ERP',
        TAB2_TITLE: 'Issues',
      },
      FILTER: {
        ALL: 'Toutes les opérations bulk',
        ONLY_MINE: 'Vos opérations bulk',
      },
      BACK_TO_BULK_OPERATIONS: 'Opérations',
      PROCESSED_ORDER_ITEMS_COUNT: 'Articles traités',
      PROCESSED_WITH_ISSUES_COUNT: 'Problèmes',
      PENDING_OPERATIONS: 'Opérations en attente',
      LOADING_OPERATIONS: 'Chargement des opérations...',
      NO_PENDING_OPERATIONS: 'Aucune opération en attente',
      NO_PENDING_OPERATIONS_DESC: 'Toutes les opérations pour cette commande ont été traitées.',
      TOTAL_OPERATIONS: 'Total {{count}} opérations en attente',
      VIEW_DETAILS: 'Voir les détails',
      VIEW_PENDING_OPERATIONS: 'Voir les opérations en attente',
      CREATED_BY: 'Créé par',
      AFFECTED_ITEMS: 'Articles affectés',
      ADD_NEW_ITEMS: 'Ajouter de nouveaux articles',
      REMOVE_ITEMS: 'Supprimer articles',
      REPLACE_ITEMS: 'Remplacer articles',
      CHANGE_QUANTITY: 'Changer la quantité',
      CHANGE_DELIVERY_DATE: 'Changer la date de livraison',
      ADD_DELIVERIES: 'Ajouter des livraisons',
      DELIVERIES_TO_ADD: 'Livraisons à ajouter',
      CHANGE_WHOLESALE_PRICE: 'Modifier le prix net',
      CHANGE_RETAIL_PRICE: 'Modifier le prix de vente',
      UPDATE_SERVICE_ITEMS: 'Frais supplémentaires mis à jour',
      CHANGE_CUSTOMER_AND_POS: 'Changer le client et le point de vente',
      CANCEL_ORDERS: 'Annuler les commandes',
      UPDATEFROMTEMPLATE: 'Mettre à jour commande depuis modèle',
      UPDATE_ORDER_HEADER: 'Mettre à jour en-tête commande',
      SINGLE_ORDER: 'Commande unique',
      MULTIPLE_ORDERS: 'Commandes multiples',
      PRODUCT: 'SKU Code-EAN',
      UPDATE_FROM_TEMPLATE: 'Mettre à jour depuis un modèle',
      DELIVERY_DATE: 'Date de livraison',
      UNKNOWN: 'Inconnu',
      UNKNOWN_SCOPE: 'Alcance inconnu',
      ITEMS_TO_ADD: 'Articles à ajouter',
      ITEMS_TO_REMOVE: 'Articles à supprimer',
      ITEMS_TO_REPLACE: 'Articles à remplacer',
      QUANTITY_CHANGES: 'Changements de quantité',
      DELIVERY_DATE_CHANGES: 'Changements de date de livraison',
      PRICE_CHANGES: 'Changements de prix',
      CUSTOMER_AND_POS_CHANGES: 'Changements de client et de point de vente',
      CUSTOMER: 'Client',
      POINT_OF_SALE: 'Point de vente',
      ORDER_CANCELLATION: 'Annuler la commande',
      OLD_PRODUCT: 'SKU Code-EAN précédent',
      NEW_PRODUCT: 'SKU Code-EAN nouveau',
      NEW_PRICE: 'Nouveau prix',
      OLD_QUANTITY: 'Quantité précédente',
      NEW_QUANTITY: 'Nouvelle quantité',
      OLD_DATE: 'Date précédente',
      NEW_DATE: 'Nouvelle date',
      OLD_PRICE: 'Prix précédent',
      FROM: 'De',
      TO: 'À',
      CANCELLATION_REASON_ID: 'ID motif annulation',
      QUANTITY: 'Quantité',
      DELIVERY: 'Livraison',
      REASON: 'Motif',
      PRICE: 'Prix',
      TYPE: 'Type d\'opération',
    },
    REPORTS: {
      STORE_VARIANTS: 'Variantes produit',
      STORE_ORDERS: 'Ordres produit',
      STORE_ORDERS_ITEMS: 'Articles ordre',
    },
    GRID: {
      RESET_COLUMN_ORDER: 'Réinitialiser l\'ordre des colonnes',
    },
    ORDER_GRID: {
      BULK_EDIT: {
        SYNC_LATER_SUCCESS: '{{count}} commande(s) sauvegardée(s) : la modification bulk est en file d\'attente et sera synchronisée ultérieurement.',
        SYNC_NOW_SUCCESS: '{{count}} commande(s) sauvegardée(s) : la modification bulk est en cours de synchronisation.',
      },
      BULK_DELETE: {
        SYNC_LATER_SUCCESS: '{{count}} commande(s) en file d\'attente pour annulation et seront synchronisées ultérieurement.',
        SYNC_NOW_SUCCESS: '{{count}} commande(s) en file d\'attente pour annulation, la synchronisation est en cours.',
      },
    },
    PENDING_BULK: {
      SYNC_SELECTED: 'Synchroniser les opérations sélectionnées ({{count}})',
      SYNC_ALL: 'Synchroniser toutes les opérations en attente',
      INFO_MESSAGE: 'Vous consultez tous vos bulk en attente.',
      ONLY_YOU: 'Seulement vous',
      YOU_AND_OTHERS: 'Vous et d\'autres utilisateurs',
      SYNC: 'Synchroniser',
      GO_TO_ORDER: 'Aller à la commande',
      VIEW_ALL_BULK_OPERATIONS: 'Voir toutes les opérations bulk',
      PENDING: 'En attente',
      SYNCED: 'Synchronisé',
      TAB: {
        EDIT_ORDERS: 'Modifier les commandes',
        VIEW_PENDING_BULK: 'Voir les opérations bulk en attente',
      },
      MINES: 'Les miens',
      OTHERS: 'Autres',
      OTHER_USERS: 'Autres utilisateurs',
      FILTER: {
        VISIBILITY: 'Afficher',
        ALL_USERS: 'Tous les utilisateurs',
        ONLY_MINE: 'Seulement les miens',
      },
      SYNC_SUCCESS: 'Synchronisation démarrée avec succès',
      SYNC_ALL_SUCCESS: 'Synchronisation démarrée pour toutes les opérations en attente',
      COLUMNS: {
        PENDING_OPERATIONS: 'N opérations en attente',
        HANDLED_BY: 'Opérations en attente gérées par',
      },
      CONFIRM_MODAL: {
        SINGLE_TITLE: 'Synchroniser les opérations en attente ?',
        ONLY_YOU_MESSAGE: 'Vous êtes sur le point de synchroniser les opérations en attente pour les commandes sélectionnées. Rappel : vous ne pourrez pas effectuer d\'autres opérations tant que la synchronisation ne sera pas terminée.',
        WITH_OTHERS_MESSAGE: 'Cette commande est actuellement modifiée par d\'autres membres de l\'équipe. La synchronisation inclura également leurs opérations en attente. Comment souhaitez-vous procéder ? Rappel : vous ne pourrez pas effectuer d\'autres opérations sur cette commande tant que la synchronisation ne sera pas terminée.',
        SYNC_ALL_MESSAGE: 'Vous êtes sur le point de synchroniser toutes les opérations en attente pour cette commande. Personne ne pourra effectuer d\'autres opérations tant que la synchronisation ne sera pas terminée.',
        MIXED_SELECTION_MESSAGE: 'Certaines commandes de votre sélection sont actuellement modifiées par d\'autres membres de l\'équipe. La synchronisation inclura également leurs opérations en attente. Comment souhaitez-vous procéder ? Rappel : personne ne pourra effectuer d\'autres opérations sur ces commandes tant que la synchronisation ne sera pas terminée.',
        EXCLUDE_IN_USE_BTN: 'Exclure les commandes en cours d\'utilisation',
        SYNC_ALL_BTN: 'Tout synchroniser',
      },
    },
    POWER_BI: {
      LOAD_ERROR: 'Impossible de charger les rapports Power BI. Veuillez réessayer plus tard.',
      FILTERS_TITLE: 'Filtres',
      FILTER_PLACEHOLDER: 'Sélectionner...',
      CANCEL: 'Annuler',
      APPLY: 'Appliquer',
      MONTH: 'Mois',
      CAMPAIGN: 'Campagne',
      SEASON: 'Saison',
      POINT_OF_SALE: 'Point de vente',
      CUSTOMER: 'Client',
      AGENCY: 'Agence',
    },
  },
};
